(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp', [
            'ngRaven',
            'ngStorage',
            'ngCookies',
            'tmh.dynamicLocale',
            'pascalprecht.translate', 
            'ngResource',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'angular.vertilize',
            'ngAnimate',
            'ngQuill'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('summary', {
            parent: 'app',
            url: '/summary',
            data: {
                authorities: ['PRE_AUTHORIZED','AUTHORIZED','ESC_INACTIVE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/summary/summary.html',
                    controller: 'SummaryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('summary');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('SummaryService', SummaryService);

    SummaryService.$inject = ['$http', 'API_URL'];

    function SummaryService ($http, API_URL) {

        var service = {
            loadSummaryLabels:loadSummaryLabels,
            loadSummaryDocuments:loadSummaryDocuments
        };

        function loadSummaryLabels() {
            return $http.get(API_URL + 'project/summary');
        }

        function loadSummaryDocuments() {
            return $http.get(API_URL + 'project/summarydocuments');
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('SummaryController', SummaryController);

    SummaryController.$inject = ['$rootScope', 'Principal', '$translate', '$log', 'CartFactory', '$localStorage', '$window', 'SummaryService', '$state', 'CartLabelService', 'RegistrationService', 'ProjectService', '$sce'];

    function SummaryController($rootScope, Principal, $translate, $log, CartFactory, $localStorage, $window, SummaryService, $state, CartLabelService, RegistrationService, ProjectService, $sce) {

        // VARIABLES
        var vm = this;

        vm.summaryExhibitor = {};

        vm.cart = CartFactory.getCart();
        vm.totalPrice = CartFactory.totalPrice();
        vm.gtcDescription;
        vm.privacyDescription;
        vm.additionalPrivacyDescription;


        vm.lang = $translate.use();

        // FUNCITONS DEFINITIONS
        vm.loaded = pageLoaded;
        vm.bookCart = bookCart;
        vm.back = back;
        vm.getLabelForItem = getLabelForItem;

        vm.preAuthorized=false;


        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            countryIdToCountryText();
        });
        getExhibitorAuthorities();

        loadSummaryData();

        return vm;

        // FUNCTIONS
        function pageLoaded() {
            if (true) {
                return true;
            }
            return false;
        }

        function getExhibitorAuthorities() {
            Principal.identity().then(function(identity) {
                $log.debug('SummaryController | authorities', identity);
                if (identity.authorities.indexOf('PRE_AUTHORIZED') !== -1) {
                    vm.preAuthorized = true;
                }
            }, function() {
                $log.debug('SummaryController | ERROR IDENTITY', value);
            });
        }


        function loadSummaryData() {
            RegistrationService.getCurrentExhibitor().then(successExhibitor, error);
            SummaryService.loadSummaryLabels().then(successLabels, error);
            SummaryService.loadSummaryDocuments().then(successDocuments, error);
        }

        function successCountries(response) {
            $log.debug('SummaryController | Getting Countries...', response.data);
            vm.countries = response.data;
            countryIdToCountryText();
        }

        function successDocuments(response) {
            $log.debug('SummaryController | Getting Documents...', response.data);
            vm.documents = response.data;
        }


        function successExhibitor(response) {
            $log.debug("SummaryController | Exhibitor:", response);
            vm.summaryExhibitor = response.data;
            ProjectService.loadCountries($localStorage.project).then(successCountries, error);
        }

        function getLabelForItem(item) {
            return CartLabelService.getCartLabelForItem(item, vm.lang);
        }

        function countryIdToCountryText() {
            $log.debug('SummaryController | country ids to text');
            angular.forEach(vm.countries, function (value) {
                if (value.id == vm.summaryExhibitor.country) {
                    vm.country = value.translations[vm.lang];
                }
                if (value.id == vm.summaryExhibitor.companyRegisteredIn) {
                    vm.companyRegisteredIn = value.translations[vm.lang];
                }
            });
        }

        function successLabels(response) {
            vm.labels = [];
            $log.debug("SummaryController | Fetching text labels", response.data);
            angular.forEach(response.data, function(label, key) {
                if (key == 'gtcDescription' && label) {
                    vm.gtcDescription =  $sce.trustAsHtml(label[vm.lang]);
                }
                if (key == 'privacyDescription' && label) {
                    vm.privacyDescription =  $sce.trustAsHtml(label[vm.lang]);
                }
                if (key == 'additionalPrivacyDescription' && label) {
                    vm.additionalPrivacyDescription =  $sce.trustAsHtml(label[vm.lang]);
                }
            });

            vm.labels = response.data;
        }


        function error(response) {
            $log.debug('SummaryController | ERROR:', response);
        }

        function back() {
            $log.debug('SummaryController | back');
            $window.history.back();
        }

        function bookCart() {
            $log.debug('SummaryController | posting shopping cart', $localStorage.cart);
            CartFactory.book().then(successBooking, error);
        }

        function successBooking() {
            $log.debug('SummaryController | success posting areas. clearing cart now');
            CartFactory.clear();
            $localStorage.coExhibitors=[];
            $state.go('download');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('User', User);

    User.$inject = ['$resource', 'API_URL'];

    function User ($resource, API_URL) {
        var service = $resource(API_URL + 'api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http', 'API_URL'];

    function ProfileService($q, $http, API_URL) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
           if (!angular.isDefined(dataPromise)) {
                dataPromise = $http.get(API_URL + 'api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerDisabled = result.data.activeProfiles.indexOf("no-swagger") !== -1;
                        return response;
                    }
                }, function (error) {
                    // Ignore unhandled error
                    return $q.reject(error);
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('pageRibbon', pageRibbon);

    function pageRibbon($rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
           
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('Register', Register);

    Register.$inject = ['$resource', 'API_URL'];

    function Register ($resource, API_URL) {
        return $resource(API_URL + 'api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', '$log'];

    function Principal ($q, Account, $log) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            hasAuthorities: hasAuthorities,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) != -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthorities (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            var hasAll = true;
            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) == -1) {
                    hasAll = false;
                }
            }

            return hasAll;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                var result = _id.authorities && _id.authorities.indexOf(authority) != -1;
                return result;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource', 'API_URL'];

    function PasswordResetInit($resource, API_URL) {
        var service = $resource(API_URL + 'api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource', 'API_URL'];

    function PasswordResetFinish($resource, API_URL) {
        var service = $resource(API_URL + 'api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('Password', Password);

    Password.$inject = ['$resource', 'API_URL'];

    function Password($resource, API_URL) {
        var service = $resource(API_URL + 'api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal', '$q'];

    function hasAuthority(Principal, $q) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        }, function (error) {
                            // Ignore unhandled error
                            return $q.reject(error);
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('hasAuthorities', hasAuthorities);

    function hasAuthorities(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAuthorities.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAuthorities(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', '$localStorage'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, $localStorage) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen, function (error) {
                // Ignore unhandled error
                return $q.reject(error);
            });

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home', {}, {reload: true, notify: true});
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        }, function (error) {
                            // Ignore unhandled error
                            return $q.reject(error);
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        }, function (error) {
                            // Ignore unhandled error
                            return $q.reject(error);
                        });
                    }
                    deferred.resolve(data);
                }, function (error) {
                    // Ignore unhandled error
                    return $q.reject(error);
                });

                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save({mail:mail,project:$localStorage.project}, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    /*jshint camelcase: false */
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', 'Base64', 'API_URL', '$q'];

    function AuthServerProvider ($http, $localStorage, Base64, API_URL, $q) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken;
        }

        function hasValidToken () {
            var token = this.getToken();
            return token && token.expires_at && token.expires_at > new Date().getTime();
        }

        function login (credentials) {
            var data = 'username=' +  encodeURIComponent(credentials.username) + '&password=' +
                encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
                'client_secret=client_secret&client_id=ExhibitorRegistrationapp';

            return $http.post(API_URL + 'oauth/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + Base64.encode('ExhibitorRegistrationapp' + ':' + 'client_secret')
                }
            }).then(authSucess, function (error) {
                return $q.reject(error);
            });

            function authSucess (response) {
                var data = response.data;
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + data.expires_in);
                data.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = data;

                return data;
            }
        }

        function logout() {
            $http.post(API_URL + 'api/logout').then(function () {
                delete $localStorage.authenticationToken;
                delete $localStorage.cart;
            }, function (error) {
                delete $localStorage.authenticationToken;
                delete $localStorage.cart;
                // Ignore unhandled error
                return error;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource', 'API_URL'];

    function Activate ($resource, API_URL) {
        var service = $resource(API_URL + 'api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('Account', Account);

    Account.$inject = ['$resource', 'API_URL'];

    function Account ($resource, API_URL) {
        var service = $resource(API_URL + 'api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('registration', {
            parent: 'app',
            url: '/registration?id',
            data: {
                authorities: ['PRE_AUTHORIZED','AUTHORIZATION_PENDING','ESC_INACTIVE','AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/registration/registration.html',
                    controller: 'RegistrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('registration');
                    $translatePartialLoader.addPart('cart');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('RegistrationService', RegistrationService);

    RegistrationService.$inject = ['$http', 'API_URL', 'Upload', '$q'];

    function RegistrationService ($http, API_URL, Upload, $q) {

        var service = {
            storeAddressData: storeAddressData,
            getCurrentLogo: getCurrentLogo,
            storeLogoData: storeLogoData,
            getCurrentExhibitor: getCurrentExhibitor,
            deleteCoExhibitor: deleteCoExhibitor,
            loadFees: loadFees,
            loadCoExhibitors: loadCoExhibitors,
            createCoExhibitor: createCoExhibitor,
            uploadLogo: uploadLogo
        };

        return service;

        function getCurrentExhibitor(id) {
            if(id){
                return $http.get(API_URL + 'exhibitor/'+id);
            }else{
                return $http.get(API_URL + 'exhibitor');
            }
        }


        function storeAddressData (data,id) {
            if(id){
                return $http({
                    method: 'POST',
                    url: API_URL + 'exhibitor/saveaddressdata/'+id,
                    data: data
                });
            }else{
                return $http({
                    method: 'POST',
                    url: API_URL + 'exhibitor/saveaddressdata/',
                    data: data
                });
            }
        }

        function getCurrentLogo(id) {
            if (id) {
                return $http.get(API_URL + 'exhibitor/logo/' + id);
            } else {
                return $http.get(API_URL + 'exhibitor/logo');
            }
        }

        function storeLogoData(logo, id) {
            if (id) {
                return $http({
                    method: 'POST',
                    url: API_URL + 'exhibitor/logo/' + id,
                    data: {
                        logo: logo
                    }
                });
            } else {
                return $http({
                    method: 'POST',
                    url: API_URL + 'exhibitor/logo/',
                    data: {
                        logo: logo
                    }
                });
            }
        }

        function createCoExhibitor () {
            return $http({
                method: 'POST',
                url: API_URL + 'exhibitor/createcoexhibitor'
            });
        }

        function deleteCoExhibitor (id) {
            return $http({
                method: 'DELETE',
                url: API_URL + 'exhibitor/coexhibitor/'+id,
            });
        }

        function loadCoExhibitors() {
            return $http.get(API_URL + 'exhibitor/coexhibitors');
        }

        function loadFees() {
            return $http.get(API_URL + 'project/fee');
        }

        function uploadLogo(file) {
            var data = {
                file: file
            };

            return Upload.upload({
                // TODO: Add to API => files/upload/exhibitorlogo
                url: API_URL + 'files/upload/exhibitorlogo',
                data: data
            }).then(function (response) {
                return response.data;
            }, function (error) {
                // Ignore unhandled error
                return $q.reject(error);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('RegistrationController', RegistrationController);

    RegistrationController.$inject = ['$rootScope', '$state', '$stateParams', 'RegistrationService', 'ProjectService', '$localStorage', '$translate', '$log', 'Principal', 'CartFactory', '$q','AlertService'];

    function RegistrationController($rootScope, $state, $stateParams, RegistrationService, ProjectService, $localStorage, $translate, $log, Principal, CartFactory, $q,AlertService) {

        // VARIABLES
        var vm = this;
        vm.exhibitor = {};

        vm.salutations = [];
        vm.academictitles = [];
        vm.countries = [];
        vm.labels = [];
        vm.readOnly = false;
        vm.bookLogo = false;
        vm.logo = null;
        vm.logoUploadStatus = null;
        vm.logoPreviewThumbnail = null;
        vm.logoIsPaid = null;
        vm.steinexpo = $localStorage.projectinfo.steinexpo;

        vm.lang = $translate.use();

        vm.alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

        vm.invoicePaidBy = [
            {id: 0, value: $translate.instant('registration.form.mainExhibitor')},
            {id: 1, value: $translate.instant('registration.form.coExhibitor')}
        ];


        // FUNCITONS DEFINITIONS
        vm.loaded = pageLoaded;
        vm.uploadLogo = uploadLogo;
        vm.register = register;
        vm.goBack = goBack;

        vm.mainExhibitorDataSet = $localStorage.exhibitorDataSet;

        vm.coExhibitorId = $stateParams.id;
        vm.registered = false;

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateComboBoxValues(vm.countries);
            translateComboBoxValues(vm.salutations);
            translateComboBoxValues(vm.academictitles);
        });


        loadProjectData();

        loadExhibitor();

        getExhibitorAuthorities();


        function getExhibitorAuthorities() {
            Principal.identity().then(function(identity) {
                $log.debug('RegistrationController | authorities', identity);
                if (identity.authorities.indexOf('AUTHORIZATION_PENDING') !== -1) {
                    vm.readOnly = true;
                    $log.debug('RegistrationController | readonly mode', vm.readOnly);
                }
                if (identity.authorities.indexOf('AUTHORIZED') !== -1 || identity.authorities.indexOf('ESC_INACTIVE') !== -1) {
                    vm.registered = true;
                    vm.mainExhibitorDataSet = true;
                }
            }, function() {
                $log.debug('RegistrationController | ERROR IDENTITY', value);

            });
        }


        // FUNCTIONS
        function loadExhibitor() {
            if (vm.coExhibitorId) {
                if (vm.coExhibitorId > 0) {
                    RegistrationService.getCurrentLogo(vm.coExhibitorId).then(fillLogo, error);
                    RegistrationService.getCurrentExhibitor(vm.coExhibitorId).then(fillExhibitor, error);
                } else {
                    if ($localStorage.coExhibitors) {

                        var index = 0
                        var found = false;
                        angular.forEach($localStorage.coExhibitors, function (exhibitor) {
                            if (exhibitor.id == vm.coExhibitorId) {
                                found = true;
                            }
                            if (!found)
                                index++;
                        });
                        if (found) {
                            vm.exhibitor = $localStorage.coExhibitors[index];
                        } else {
                            vm.exhibitor.coExhibitor = 1;
                            vm.exhibitor.id = vm.coExhibitorId;
                        }
                    } else {
                        vm.exhibitor.coExhibitor = 1;
                        vm.exhibitor.id = vm.coExhibitorId;
                    }
                }
            } else {
                RegistrationService.getCurrentLogo().then(fillLogo, error);
                RegistrationService.getCurrentExhibitor().then(fillExhibitor, error);
            }
        }

        function fillExhibitor(response) {
            $log.debug("RegistrationController | Exhibitor:", response);
            vm.exhibitor = response.data;
        }

        function fillLogo(response) {
            $log.debug("RegistrationController | Exhibitor:", response);
            vm.bookLogo = response.data.logo || response.data.paid ? 1 : 0;
            vm.logo = vm.bookLogo ? 'USE_EXISTING' : null;
            vm.logoPreviewThumbnail = response.data.logo;
            vm.logoIsPaid = response.data.paid;
        }

        function register() {
            // Add registrationfee to cart
            $log.debug('RegistrationController | Posting exhibitor...', vm.exhibitor);

            if (vm.coExhibitorId) {
                if (vm.coExhibitorId < 0) {
                    addCoExhibitorRegistrationFeeToCart(vm.coExhibitorId);
                }
            } else {
                if (!vm.registered) {
                    addRegistrationFeeToCart();
                }
            }

            if (vm.steinexpo) {
                if (vm.bookLogo) {
                    if (!vm.logoIsPaid) {
                        var isAlreadyInCart;

                        if (vm.coExhibitorId) {
                            isAlreadyInCart = CartFactory.getCart().find(function (item) {
                                return item.type === 'CoExhibitorLogoFee' && item.cartPositionBookedForId === vm.coExhibitorId;
                            });

                            if (!isAlreadyInCart) {
                                addCoExhibitorLogoFeeToCart(vm.coExhibitorId);
                            }
                        } else {
                            isAlreadyInCart = CartFactory.getCart().find(function (item) {
                                return item.type === 'LogoFee';
                            });

                            if (!isAlreadyInCart) {
                                addLogoFeeToCart();
                            }
                        }
                    }
                } else if (vm.logo) {
                    delete vm.logo;
                }
            }

            if (vm.coExhibitorId) {
                if (vm.coExhibitorId < 0) {
                    var index = 0;
                    var update = false;
                    angular.forEach($localStorage.coExhibitors, function (exhibitor) {
                        if (exhibitor.id == vm.coExhibitorId) {
                            update = true;
                            return;
                        }
                        if (!update)
                            index++;
                    });
                    if (update) {
                        $localStorage.coExhibitors[index] = vm.exhibitor;
                    } else {
                        $localStorage.coExhibitors.push(vm.exhibitor);
                    }
                    goHome();
                } else {
                    RegistrationService.storeAddressData(vm.exhibitor, vm.coExhibitorId).then(storedAddressData, error);
                    $localStorage.exhibitorDataSet = true;
                }
            } else {
                RegistrationService.storeAddressData(vm.exhibitor).then(storedAddressData, error);
                $localStorage.exhibitorDataSet = true;
            }
        }

        function goBack() {
            $state.go('home', {}, {reload: true, notify: true});
        }

        function storedAddressData() {
            if (vm.steinexpo && vm.logo && vm.logo !== 'USE_EXISTING') {
                RegistrationService.storeLogoData(vm.logo, vm.coExhibitorId ? vm.coExhibitorId : null).then(function () {
                    goHome();
                }, function (error) {
                    // Ignore unhandled error
                    return $q.reject(error);
                });
            } else {
                goHome();
            }
        }

        function goHome() {
            Principal.identity();

            if (vm.steinexpo) {
                if (vm.coExhibitorId && vm.coExhibitorId < 0) {
                    var hasAuthority = Principal.hasAnyAuthority(['PRE_AUTHORIZED', 'ESC_INACTIVE']);

                    if (hasAuthority) {
                        $state.go('nomenclature', {id: vm.coExhibitorId});
                    } else {
                        $state.go('home', {}, {reload: true, notify: true});
                    }
                } else {
                    Principal.hasAuthority('PRE_AUTHORIZED').then(function (hasAuthority) {
                        if (hasAuthority) {
                            $state.go('nomenclature');
                        } else {
                            $state.go('home', {}, {reload: true, notify: true});
                        }
                    }, function () {
                        $state.go('home', {}, {reload: true, notify: true});
                    });
                }
            } else {
                $state.go('home', {}, {reload: true, notify: true});
            }
        }

        function reloadAuthorities() {
            Principal.identity();
        }

        function loadProjectData() {
            $log.debug("RegistrationController | Load project data for Project-ID: ", $localStorage.project);
            ($localStorage.salutations !== undefined) ? vm.salutations = $localStorage.salutations : ProjectService.loadSalutations($localStorage.project).then(successSalutations, error);
            ($localStorage.academictitles !== undefined) ? vm.academictitles = $localStorage.academictitles : ProjectService.loadAcademicTitles($localStorage.project).then(successAcademicTitles, error);
            ($localStorage.countries !== undefined) ? vm.countries = $localStorage.countries : ProjectService.loadCountries($localStorage.project).then(successCountries, error);
            RegistrationService.loadFees().then(successFees, error);
            ProjectService.loadProjectLabels('general').then(succesLabels, error);
        }


        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.translations[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function successCountries(response) {
            $log.debug('RegistrationController | Getting Countries...', response.data);
            vm.countries = response.data;
            translateComboBoxValues(vm.countries);
            $localStorage.countries = vm.countries;
        }

        function successFees(response) {
            $log.debug('RegistrationController | Getting Fees...', response);
            vm.fees = response.data;
            if (vm.fees) {
                vm.registrationFee = vm.fees.registrationFee;
                vm.registrationFeeCoExhibitor = vm.fees.registrationFeeCoExhibitor;
                vm.registrationFeeCartLabel = vm.fees.translations;
                vm.logoFee = vm.fees.logoFee;
                vm.logoFeeCartLabel = vm.fees.logoFeeLabel;
            }
        }

        function succesLabels(response) {
            $log.debug('RegistrationController | Getting General-Labels...', response.data);
            var labels = [];
            angular.forEach(response.data, function (value) {
                labels[value.key] = value.translations;
            });
            vm.labels = labels;
        }

        function successSalutations(response) {
            $log.debug('RegistrationController | Getting Salutations...', response.data);
            vm.salutations = response.data;
            translateComboBoxValues(vm.salutations);
            $localStorage.salutations = vm.salutations;
        }

        function successAcademicTitles(response) {
            $log.debug('RegistrationController | Getting Academictitles...', response.data);
            vm.academictitles = response.data;
            translateComboBoxValues(vm.academictitles);
            $localStorage.academictitles = vm.academictitles;
        }

        function error(response) {
            $log.debug('RegistrationController | ERROR:', response);
        }

        function addRegistrationFeeToCart() {
            var fee = {
                cartPositionPrice: vm.registrationFee,
                cartPositionParent: null,
                cartPositionLabel: vm.registrationFeeCartLabel,
                cartPositionBookedFor: null,
                type: 'Fee',
                cartPositionId: null
            };

            $log.debug('RegistrationController | Cart entry for registrationfee:', fee);

            CartFactory.addFee(fee);

            $localStorage.showFeeAddedToCart = true;
        }

        function addCoExhibitorRegistrationFeeToCart(id) {
            var fee = {
                cartPositionPrice: vm.registrationFeeCoExhibitor,
                cartPositionParent: null,
                cartPositionLabel: vm.registrationFeeCartLabel,
                cartPositionBookedFor: '- ' + vm.exhibitor.company,
                cartPositionBookedForId: id,
                coExhibitor: vm.exhibitor,
                type: 'CoExhibitorFee'
            };

            // CartFactory.removeFee();
            $log.debug('RegistrationController | Cart entry for registrationfee:', fee);

            CartFactory.addFee(fee);

            $localStorage.showCoExhibitorFeeAddedToCart = true;

        }

        function addLogoFeeToCart() {
            var fee = {
                cartPositionPrice: vm.logoFee,
                cartPositionParent: null,
                cartPositionLabel: vm.logoFeeCartLabel,
                cartPositionBookedFor: null,
                type: 'LogoFee',
                cartPositionId: null,
                logoId: vm.logo
            };

            $log.debug('RegistrationController | Cart entry for logofee:', fee);

            CartFactory.addFee(fee);

            $localStorage.showLogoFeeAddedToCart = true;
        }

        function addCoExhibitorLogoFeeToCart(id) {
            var fee = {
                cartPositionPrice: vm.logoFee,
                cartPositionParent: null,
                cartPositionLabel: vm.logoFeeCartLabel,
                cartPositionBookedFor: '- ' + vm.exhibitor.company,
                cartPositionBookedForId: id,
                coExhibitor: vm.exhibitor,
                type: 'CoExhibitorLogoFee',
                logoId: vm.logo
            };

            // CartFactory.removeFee();
            $log.debug('RegistrationController | Cart entry for logofee:', fee);

            CartFactory.addFee(fee);

            $localStorage.showCoExhibitorLogoFeeAddedToCart = true;
        }

        function pageLoaded() {
            return (vm.academictitles && vm.countries && vm.salutations && vm.exhibitor && vm.labels);
        }

        function uploadLogo(file) {
            if (!file) {
                return;
            }

            vm.logoUploadStatus = 0;
            RegistrationService.uploadLogo(file, vm.logo).then(function (data) {
                vm.logo = data.fileName;
                vm.logoPreviewThumbnail = data.fileDownloadUri;
                vm.logoUploadStatus = null;
            }, function () {
                vm.logoUploadStatus = null;
            }, function (event) {
                vm.logoUploadStatus = parseInt(100.0 * event.loaded / event.total);
            });
        }

        return vm;
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('ProjectInitService', ProjectInitService);

    ProjectInitService.$inject = ['$log', '$localStorage', '$sessionStorage', 'Auth', '$sce', '$q', '$window', 'ProjectService', 'JhiLanguageService', 'NO_PROJECT_URL'];

    function ProjectInitService($log, $localStorage, $sessionStorage, Auth, $sce, $q, $window, ProjectService, JhiLanguageService, NO_PROJECT_URL) {
        return {
            initProject: initProject
        };

        function initProject(project) {
            var deferred = $q.defer();

            if (project !== undefined) {
                $localStorage.$reset();
                $sessionStorage.$reset();
                Auth.logout();

                return ProjectService.validateProject(project).then(
                    storeProjectInLocalStorage,
                    function (response) {
                        $log.debug('ProjectInitService | ERROR', response);
                        $window.location.assign(NO_PROJECT_URL);

                        deferred.resolve(response);
                    }
                );
            } else {
                setProjectInfo();
                deferred.resolve();
            }

            return deferred.promise;
        }

        function storeProjectInLocalStorage(response) {
            $log.debug('ProjectInitService | Project-Id received: ', response.data);

            if (isInteger(response.data) && response.data > 0) {
                var project = response.data;
                $localStorage.project = project;

                return loadProjectInfo(project);
            } else {
                $log.debug('ProjectInitService | ERROR getting project-id, go to', NO_PROJECT_URL);
                $window.location.assign(NO_PROJECT_URL);

                return $q.resolve();
            }
        }

        function isInteger(value) {
            return typeof value === "number" &&
                isFinite(value) &&
                Math.floor(value) === value;
        }

        function loadProjectInfo(project) {
            return ProjectService.loadProjectInfo(project)
                .then(function (response) {
                    $log.debug('ProjectInitService | Project info fetching successful', response);
                    $localStorage.projectinfo = response.data;
                    setProjectInfo();

                    return $q.resolve(response);
                }, function (data) {
                    $log.debug('ProjectInitService | error fetching project info', data);

                    return $q.resolve(data);
                });
        }

        function setProjectInfo() {
            $log.debug('ProjectInitService | Project-Info: ', $localStorage.projectinfo);

            if ($localStorage.projectinfo !== undefined) {
                JhiLanguageService.setLanguages($localStorage.projectinfo.languages);
            } else {
                $window.location.assign(NO_PROJECT_URL);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('ProjectService', ProjectService);

    ProjectService.$inject = ['$http', 'API_URL'];

    function ProjectService ($http, API_URL) {
        var service = {
            validateProject: validate,
            loadProjectInfo: info,
            loadCountries: countries,
            loadSalutations: salutations,
            loadAcademicTitles: academicTitles,
            loadProjectLabels: loadProjectLabels,
            loadPendingLabels: loadPendingLabels,
            loadEscInactiveLabels: loadEscInactiveLabels
        };

        return service;

        function validate (name) {
            return $http.get(API_URL + 'project', {params:{name:name}});
        }

        function countries(project) {
            return $http.get(API_URL + 'country', {params:{project:project}});
        }

        function salutations(project) {
            return $http.get(API_URL + 'salutation', {params:{project:project}});
        }

        function academicTitles(project) {
            return $http.get(API_URL + 'academictitle', {params:{project:project}});
        }

        function info(project) {
            return $http.get(API_URL + 'project/info', {params:{project:project}});
        }

        function loadProjectLabels(key) {
            return $http.get(API_URL + 'project/translations', {params:{key:key}});
        }

        function loadPendingLabels(){
            return $http.get(API_URL + 'project/pending');
        }

        function loadEscInactiveLabels(){
            return $http.get(API_URL + 'project/escinactive');
        }
    }
})();

if (!Array.prototype.filter) {
    Array.prototype.filter = function(func, thisArg) {
        'use strict';
        if ( ! ((typeof func === 'Function' || typeof func === 'function') && this) )
            throw new TypeError();

        var len = this.length >>> 0,
            res = new Array(len), // preallocate array
            t = this, c = 0, i = -1;
        if (thisArg === undefined) {
            while (++i !== len){
                // checks to see if the key was set
                if (i in this){
                    if (func(t[i], i, t)){
                        res[c++] = t[i];
                    }
                }
            }
        }
        else{
            while (++i !== len){
                // checks to see if the key was set
                if (i in this){
                    if (func.call(thisArg, t[i], i, t)){
                        res[c++] = t[i];
                    }
                }
            }
        }

        res.length = c; // shrink down array to proper size
        return res;
    };
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return -1.
            return -1;
        },
        configurable: true,
        writable: true
    });
}

// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {

    Array.prototype.forEach = function(callback, thisArg) {

        var T, k;

        if (this === null) {
            throw new TypeError(' this is null or not defined');
        }

        // 1. Let O be the result of calling ToObject passing the |this| value as the argument.
        var O = Object(this);

        // 2. Let lenValue be the result of calling the Get internal method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = O.length >>> 0;

        // 4. If IsCallable(callback) is false, throw a TypeError exception.
        // See: http://es5.github.com/#x9.11
        if (typeof callback !== "function") {
            throw new TypeError(callback + ' is not a function');
        }

        // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 1) {
            T = thisArg;
        }

        // 6. Let k be 0
        k = 0;

        // 7. Repeat, while k < len
        while (k < len) {

            var kValue;

            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the HasProperty internal method of O with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            if (k in O) {

                // i. Let kValue be the result of calling the Get internal method of O with argument Pk.
                kValue = O[k];

                // ii. Call the Call internal method of callback with T as the this value and
                // argument list containing kValue, k, and O.
                callback.call(T, kValue, k, O);
            }
            // d. Increase k by 1.
            k++;
        }
        // 8. return undefined
    };
}

// Production steps of ECMA-262, Edition 5, 15.4.4.19
// Reference: http://es5.github.io/#x15.4.4.19
if (!Array.prototype.map) {

    Array.prototype.map = function(callback, thisArg) {

        var T, A, k;

        if (this == null) {
            throw new TypeError(' this is null or not defined');
        }

        // 1. Let O be the result of calling ToObject passing the |this|
        //    value as the argument.
        var O = Object(this);

        // 2. Let lenValue be the result of calling the Get internal
        //    method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = O.length >>> 0;

        // 4. If IsCallable(callback) is false, throw a TypeError exception.
        // See: http://es5.github.com/#x9.11
        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }

        // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 1) {
            T = thisArg;
        }

        // 6. Let A be a new array created as if by the expression new Array(len)
        //    where Array is the standard built-in constructor with that name and
        //    len is the value of len.
        A = new Array(len);

        // 7. Let k be 0
        k = 0;

        // 8. Repeat, while k < len
        while (k < len) {

            var kValue, mappedValue;

            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the HasProperty internal
            //    method of O with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            if (k in O) {

                // i. Let kValue be the result of calling the Get internal
                //    method of O with argument Pk.
                kValue = O[k];

                // ii. Let mappedValue be the result of calling the Call internal
                //     method of callback with T as the this value and argument
                //     list containing kValue, k, and O.
                mappedValue = callback.call(T, kValue, k, O);

                // iii. Call the DefineOwnProperty internal method of A with arguments
                // Pk, Property Descriptor
                // { Value: mappedValue,
                //   Writable: true,
                //   Enumerable: true,
                //   Configurable: true },
                // and false.

                // In browsers that support Object.defineProperty, use the following:
                // Object.defineProperty(A, k, {
                //   value: mappedValue,
                //   writable: true,
                //   enumerable: true,
                //   configurable: true
                // });

                // For best browser support, use the following:
                A[k] = mappedValue;
            }
            // d. Increase k by 1.
            k++;
        }

        // 9. return A
        return A;
    };
}

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('orderhistory', {
            parent: 'app',
            url: '/orderhistory',
            data: {
                authorities: ['AUTHORIZATION_PENDING','ESC_INACTIVE','AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/orderhistory/orderhistory.html',
                    controller: 'OrderHistoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('orderhistory');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('OrderHistoryService', OrderHistoryService);

    OrderHistoryService.$inject = ['$http', 'API_URL'];

    function OrderHistoryService($http, API_URL) {

        var service = {
            loadBookedAreas: loadBookedAreas,
            loadBookedParts: loadBookedParts,
            deletePart: deletePart
        };

        return service;

        function loadBookedAreas() {
            return $http.get(API_URL + 'cart/areas');
        }

        function loadBookedParts() {
            return $http.get(API_URL + 'cart/history');
        }

        function deletePart(id) {
            return $http({
                method: 'DELETE',
                url: API_URL + '/cart/part?id=' +id
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('OrderHistoryController', OrderHistoryController);

    OrderHistoryController.$inject = ['$rootScope', '$translate', '$log', 'OrderHistoryService'];

    function OrderHistoryController($rootScope, $translate, $log, OrderHistoryService) {

        // VARIABLES
        var vm = this;

        vm.lang = $translate.use();

        // FUNCITONS DEFINITIONS
        vm.loaded = pageLoaded;
        vm.deletePart = deletePart;


        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        loadData();

        return vm;

        function loadData() {
            OrderHistoryService.loadBookedAreas().then(successAreas, error);
            OrderHistoryService.loadBookedParts().then(successParts, error);
        }

        // FUNCTIONS
        function pageLoaded() {
            if (true) {
                return true;
            }
            return false;
        }

        function successParts(response) {
            $log.debug('OrderHistoryController | fetching parts', response.data);
            vm.parts = response.data;
        }

        function successAreas(response) {
            $log.debug('OrderHistoryController | fetching areas', response.data);
            vm.areas = response.data;
        }

        function error(response) {
            $log.debug('OrderHistoryController | ERROR:', response);
        }

        function deletePart(id) {
            OrderHistoryService.deletePart(id).then(successDelete, error);
        }

        function successDelete() {
            OrderHistoryService.loadBookedParts().then(successParts, error);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('nomenclature', {
            parent: 'app',
            url: '/nomenclature?id',
            data: {
                authorities: ['PRE_AUTHORIZED', 'ESC_INACTIVE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/nomenclature/nomenclature.html',
                    controller: 'NomenclatureController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('nomenclature');
                    return $translate.refresh();
                }],
                steinexpo: ['$localStorage', function ($localStorage) {
                    return !!$localStorage.projectinfo.steinexpo;
                }],
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('NomenclatureService', NomenclatureService);

    NomenclatureService.$inject = ['$http', 'API_URL', 'CartFactory', '$q'];

    function NomenclatureService($http, API_URL, CartFactory, $q) {

        var service = {
            loadNomenclature: loadNomenclature,
            postNomenclature: postNomenclature
        };

        return service;

        function loadNomenclature(coExhibitorId) {
            if (coExhibitorId) {
                var cartItems = CartFactory.getCart();

                var cartItemIndex = -1;
                for (var i = 0; i < cartItems.length; ++i) {
                    if (cartItems[i].type === 'CoExhibitorFee' && cartItems[i].cartPositionBookedForId === coExhibitorId) {
                        cartItemIndex = i;
                        break;
                    }
                }

                // var cartItemIndex = cartItems.findIndex(function (item) {
                //     return item.type === 'CoExhibitorFee' && item.cartPositionBookedForId === coExhibitorId;
                // });

                if (cartItemIndex >= 0) {
                    var cartItem = cartItems[cartItemIndex];

                    if (cartItem) {
                        return $q.resolve({
                            data: {
                                nomenclature: (cartItem.nomenclature || [])
                            }
                        });
                    }
                }

                return $q.resolve([]);
            } else {
                return $http({
                    method: 'GET',
                    url: API_URL + 'exhibitor/nomenclature'
                });
            }
        }

        function postNomenclature(coExhibitorId, data) {
            if (coExhibitorId) {
                var cartItems = CartFactory.getCart();

                var cartItemIndex = -1;
                for (var i = 0; i < cartItems.length; ++i) {
                    if (cartItems[i].type === 'CoExhibitorFee' && cartItems[i].cartPositionBookedForId === coExhibitorId) {
                        cartItemIndex = i;
                        break;
                    }
                }


                // var cartItemIndex = cartItems.findIndex(function (item) {
                //     return item.type === 'CoExhibitorFee' && item.cartPositionBookedForId === coExhibitorId;
                // });

                if (cartItemIndex >= 0) {
                    var cartItem = cartItems[cartItemIndex];

                    if (cartItem) {
                        cartItem.nomenclature = data;
                        CartFactory.updateItemByIndex(cartItemIndex, cartItem);

                        return $q.resolve(cartItem);
                    }
                }

                return $q.reject();
            } else {
                return $http({
                    method: 'POST',
                    url: API_URL + 'exhibitor/nomenclature',
                    data: {
                        nomenclature: data
                    }
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('NomenclatureController', NomenclatureController);

    NomenclatureController.$inject = ['NomenclatureService', '$state', '$stateParams','AlertService','$localStorage','$translate'];

    function NomenclatureController(NomenclatureService, $state, $stateParams,AlertService,$localStorage,$translate) {
        var vm = this;

        vm.status = 'loading';
        vm.coExhibitorId = $stateParams.id;
        vm.selected = {};
        vm.nomenclature = [
            {
                key: 'c1',
                items: [
                    'c1i1',
                    'c1i2',
                    'c1i3',
                    'c1i4',
                ]
            },
            {
                key: 'c2',
                items: [
                    'c2i1',
                    'c2i2',
                    'c2i3',
                    'c2i4',
                    'c2i5',
                    'c2i6',
                    'c2i7',
                ]
            },
            {
                key: 'c3',
                items: [
                    'c3i1',
                    'c3i2',
                    'c3i3',
                    'c3i4',
                    'c3i5',
                    'c3i6',
                    'c3i7',
                    'c3i8',
                ]
            },
            {
                key: 'c4',
                items: [
                    'c4i1',
                    'c4i2',
                    'c4i3',
                ]
            },
            {
                key: 'c5',
                items: [
                    'c5i1',
                    'c5i2',
                ]
            },
            {
                key: 'c6',
                items: [
                    'c6i1',
                    'c6i2',
                    'c6i3',
                    'c6i4',
                    'c6i5',
                    'c6i6',
                    'c6i7',
                ]
            },
            {
                key: 'c7',
                items: [
                    'c7i1',
                    'c7i2',
                    'c7i3',
                    'c7i4',
                ],
            },
            {
                key: 'c8',
                items: [
                    'c8i1',
                    'c8i2',
                    'c8i3',
                    'c8i4',
                ]
            },
            {
                key: 'c9',
            },
            {
                key: 'c10',
            },
        ];

        vm.submit = submit;

        init();

        function init() {
            vm.status = 'loading';
            NomenclatureService.loadNomenclature(vm.coExhibitorId).then(function (response) {
                angular.forEach(response.data.nomenclature, function (key) {
                    vm.selected[key] = true;
                });
                vm.status = 'loaded';

                if ($localStorage.showCoExhibitorLogoFeeAddedToCart !== undefined && $localStorage.showCoExhibitorLogoFeeAddedToCart == true) {
                    var successMsg = $translate.instant('nomenclature.coExhibitorLogoFeeAddedToCart');
                    AlertService.success(successMsg, {}, 'bottom right');
                    delete $localStorage.showCoExhibitorLogoFeeAddedToCart;
                }
                if ($localStorage.showLogoFeeAddedToCart !== undefined && $localStorage.showLogoFeeAddedToCart == true) {
                    var successMsg = $translate.instant('nomenclature.logoFeeAddedToCart');
                    AlertService.success(successMsg, {}, 'bottom right');
                    delete $localStorage.showLogoFeeAddedToCart;
                }
                if ($localStorage.showCoExhibitorFeeAddedToCart !== undefined && $localStorage.showCoExhibitorFeeAddedToCart == true) {
                    var successMsg = $translate.instant('nomenclature.coExhibitorFeeAddedToCart');
                    AlertService.success(successMsg, {}, 'bottom right');
                    delete $localStorage.showCoExhibitorFeeAddedToCart;
                }
                if ($localStorage.showFeeAddedToCart !== undefined && $localStorage.showFeeAddedToCart == true) {
                    var successMsg = $translate.instant('nomenclature.feeAddedToCart');
                    AlertService.success(successMsg, {}, 'bottom right');
                    delete $localStorage.showFeeAddedToCart;
                }

            }, function () {
                vm.status = 'notfound';
            });
        }

        function submit() {
            var keys = [];

            angular.forEach(Object.keys(vm.selected), function (key) {
                if (vm.selected[key] === true) {
                    keys.push(key);
                }
            });

            NomenclatureService.postNomenclature(vm.coExhibitorId, keys).then(function () {
                $state.go('home', {}, {reload: true, notify: true});
            }, function () {
                alert('Error!');
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('NewsService', NewsService);

    NewsService.$inject = ['$http', 'API_URL', 'Upload', '$log'];

    function NewsService($http, API_URL, Upload, $log) {

        var service = {
            getList: getList,
            create: create,
            remove: remove,
            uploadImage: uploadImage,
            uploadAttachment: uploadAttachment,
            removeAttachment: removeAttachment
        };

        return service;

        function getList() {
            return $http({
                method: 'GET',
                url: API_URL + 'exhibitor/news'
            });
        }

        function create(data) {
            return $http({
                method: 'POST',
                url: API_URL + 'exhibitor/news',
                data: data
            }).then(function (response) {
                return response;
            }, function (error) {
                $log.error(error);
                alert('ERROR');

                return error;
            });
        }

        function remove(id) {
            return $http({
                method: 'DELETE',
                url: API_URL + 'exhibitor/news/' + id
            }).then(function (response) {
                return response;
            }, function (error) {
                $log.error(error);
                alert('ERROR');

                return error;
            });
        }

        function uploadImage(file) {
            var data = {
                file: file
            };

            return Upload.upload({
                url: API_URL + 'files/upload/newsimage',
                data: data
            }).then(function (response) {
                return response.data;
            });
        }

        function uploadAttachment(file) {
            var data = {
                file: file
            };

            return Upload.upload({
                url: API_URL + 'files/upload/newsattachment',
                data: data
            }).then(function (response) {
                return response.data;
            });
        }

        function removeAttachment(id) {
            return $http({
                method: 'DELETE',
                url: API_URL + 'files/' + id
            }).then(function (response) {
                return response;
            }, function (error) {
                $log.error(error);
                alert('ERROR');

                return error;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('news', {
            parent: 'app',
            url: '/news',
            data: {
                authorities: ['AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/news/list/list.html',
                    controller: 'NewsListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('news');
                    return $translate.refresh();
                }],
                steinexpo: ['$localStorage', function ($localStorage) {
                    return !!$localStorage.projectinfo.steinexpo;
                }],
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('NewsListController', NewsListController);

    NewsListController.$inject = ['NewsService', '$state', '$sce', '$translate', '$q'];

    function NewsListController(NewsService, $state, $sce, $translate, $q) {
        var vm = this;

        vm.items = [];

        vm.trustedHtml = trustedHtml;
        vm.add = add;
        vm.remove = remove;

        loadData();

        function loadData() {
            NewsService.getList().then(function (response) {
                vm.items = response.data.content;
            }, function (error) {
                // Ignore unhandled error
                return $q.reject(error);
            });
        }

        function trustedHtml(plainText) {
            return $sce.trustAsHtml(plainText);
        }

        function add() {
            $state.go('news_new');
        }

        function remove(id) {
            $translate('news.removeWarning').then(function (newsrRemoveWarningMessage) {
                if (confirm(newsrRemoveWarningMessage)) {
                    NewsService.remove(id);
                    vm.items = vm.items.filter(function (item) {
                        return item.id !== id
                    });
                }
            }, function (error) {
                // Ignore unhandled error
                return $q.reject(error);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('news_new', {
            parent: 'app',
            url: '/news/new',
            data: {
                authorities: ['AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/news/edit/edit.html',
                    controller: 'NewsEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('news');
                    return $translate.refresh();
                }],
                steinexpo: ['$localStorage', function ($localStorage) {
                    return !!$localStorage.projectinfo.steinexpo;
                }],
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('NewsEditController', NewsEditController);

    NewsEditController.$inject = ['NewsService', '$state', '$q'];

    function NewsEditController(NewsService, $state, $q) {
        var vm = this;

        vm.news = {
            language: 'de_DE',
            title: '',
            teaser: '',
            content: '',
            image: null,
            downloads: [],
        };
        vm.imageUploadStatus = null;
        vm.imagePreviewThumbnail = null;

        vm.submit = submit;
        vm.uploadImage = uploadImage;
        vm.uploadAttachment = uploadAttachment;
        vm.removeAttachment = removeAttachment;

        function submit() {
            NewsService.create(vm.news).then(function () {
                $state.go('news');
            }, function (error) {
                // Ignore unhandled error
                return $q.reject(error);
            });
        }

        function uploadImage(file) {
            if (!file) {
                return;
            }

            vm.imageUploadStatus = 0;
            NewsService.uploadImage(file, vm.news.image).then(function (data) {
                vm.news.image = data.fileName;
                vm.imagePreviewThumbnail = data.fileDownloadUri;
                vm.imageUploadStatus = null;
            }, function () {
                vm.imageUploadStatus = null;
            }, function (event) {
                vm.imageUploadStatus = parseInt(100.0 * event.loaded / event.total);
            });
        }

        function uploadAttachment(file) {
            if (!file) {
                return;
            }

            NewsService.uploadAttachment(file).then(function (data) {
                vm.news.downloads.push({
                    uuid: data.fileName,
                    title: file.name.split('.').slice(0, -1).join('.')
                });
            }, function () {
            }, function (event) {
            });
        }

        function removeAttachment(uuid) {
            NewsService.removeAttachment(uuid);
            vm.news.downloads = vm.news.downloads.filter(function (download) {
                return download.uuid !== uuid;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$scope', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$localStorage'];

    function NavbarController ($scope, $state, Auth, Principal, ProfileService, LoginService, $localStorage) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        /*ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = false;
            vm.swaggerDisabled = true;
        });*/

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        $scope.$watch(function () {
            return $localStorage.projectinfo ? $localStorage.projectinfo.steinexpo : false;
        }, function (steinexpo) {
            vm.steinexpo = steinexpo;
        });

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home', {}, {reload: true, notify: true});
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('activeMenu', activeMenu);

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    },
                    'navbar@': {
                    } 
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html',
                        controller: 'ErrorController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('ErrorController', ErrorController);

    ErrorController.$inject = ['$window', 'NO_PROJECT_URL', '$localStorage'];

    function ErrorController($window, NO_PROJECT_URL, $localStorage) {
        var vm = this;

        if ($localStorage.project === undefined){
            $window.location.assign(NO_PROJECT_URL);
        }

        return vm;
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/?project',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'AlertService', 'CartFactory', 'Principal', '$sessionStorage', 'LoginService', 'RegistrationService', '$state', '$stateParams', 'ProjectService', '$localStorage', '$translate', '$log', 'NO_PROJECT_URL', '$window', 'Auth', '$rootScope', '$sce', 'JhiLanguageService', '$uibModal', '$q'];

    function HomeController($scope, AlertService, CartFactory, Principal, $sessionStorage, LoginService, RegistrationService, $state, $stateParams, ProjectService, $localStorage, $translate, $log, NO_PROJECT_URL, $window, Auth, $rootScope, $sce, JhiLanguageService, $uibModal, $q) {
        // VARIABLES
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = false;
        vm.project = $stateParams.project;
        vm.welcomeHeadline = '';
        vm.welcomeText = '';
        vm.welcomeImage = '';
        vm.pendingLabel = '';
        vm.escInactiveLabel = '';
        vm.lang = $translate.use();
        vm.coExhibitors = [];

        // FUNCITONS PUBLIC
        vm.login = LoginService.open;
        vm.showLogin = showLoginButton;
        vm.isLoggedIn = isLoggedIn;
        vm.go = go;
        vm.newCoExhibitor = newCoExhibitor;
        vm.removeCoExhibitor = removeCoExhibitor;
        vm.editCoexhibitor = editCoexhibitor;


        $scope.$on('authenticationSuccess', function () {
            var authenticationToken = $localStorage.authenticationToken;
            var project = $localStorage.project;
            var projectinfo = $localStorage.projectinfo;
            var languages = $localStorage.languages;
            $localStorage.$reset();
            $sessionStorage.$reset();
            CartFactory.clear();
            $localStorage.authenticationToken = authenticationToken;
            $localStorage.project = project;
            $localStorage.projectinfo = projectinfo;
            $localStorage.languages = languages;
            $localStorage.exhibitorDataSet = false;
            getAccount();
            loadExhibitorInfo();
            loadCoExhibitors();
            vm.showLoginButton = false;
        });

        if (vm.project !== undefined) {
            $localStorage.$reset();
            $sessionStorage.$reset();
            Auth.logout();
            validateProject();
        } else {
            setProjectInfo();
        }

        if ($localStorage.showCoExhibitorLogoFeeAddedToCart !== undefined && $localStorage.showCoExhibitorLogoFeeAddedToCart == true) {
            var successMsg = $translate.instant('home.coExhibitorLogoFeeAddedToCart');
            AlertService.success(successMsg, {}, 'bottom right');
            delete $localStorage.showCoExhibitorLogoFeeAddedToCart;
        }
        if ($localStorage.showLogoFeeAddedToCart !== undefined && $localStorage.showLogoFeeAddedToCart == true) {
            var successMsg = $translate.instant('home.logoFeeAddedToCart');
            AlertService.success(successMsg, {}, 'bottom right');
            delete $localStorage.showLogoFeeAddedToCart;
        }
        if ($localStorage.showCoExhibitorFeeAddedToCart !== undefined && $localStorage.showCoExhibitorFeeAddedToCart == true) {
            var successMsg = $translate.instant('home.coExhibitorFeeAddedToCart');
            AlertService.success(successMsg, {}, 'bottom right');
            delete $localStorage.showCoExhibitorFeeAddedToCart;
        }
        if ($localStorage.showFeeAddedToCart !== undefined && $localStorage.showFeeAddedToCart == true) {
            var successMsg = $translate.instant('home.feeAddedToCart');
            AlertService.success(successMsg, {}, 'bottom right');
            delete $localStorage.showFeeAddedToCart;
        }
        if (Principal.isAuthenticated()) {
            loadCoExhibitors();
            getAccount();
            loadExhibitorInfo();
        }

        // FUNCTION DECLARATIONS
        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if (vm.account && !$localStorage.exhibitorDataSet) {
                    Principal.hasAuthority('PRE_AUTHORIZED').then(function (hasAuthority) {
                        if (hasAuthority) {
                            register();
                        }
                    }, error);
                }
            }, function (error) {
                vm.isAuthenticated = false;
                // Ignore unhandled error
                return $q.reject(error);
            });
        }

        function book() {
            $state.go('area');
        }

        function register() {
            $state.go('registration');
        }

        function editCoexhibitor(id) {
            $log.debug('HomeController | edit co exhibitor:' + id);
            $state.go('registration', {"id": id});
        }

        function removeCoExhibitor(id) {
            var modal = $uibModal.open({
                templateUrl: 'app/components/confirm/confirm-dialog.html',
                controller: 'ModalConfirmController',
                size: 'md',
                windowClass: 'confirm-window',
                resolve: {
                    confirmTitle: function () {
                        return $translate.instant('home.coexhibitorremovetitle');
                    },
                    confirmMessage: function () {
                        return $translate.instant('home.coexhibitorremovedescription');
                    },
                    confirmCaption: function () {
                        return $translate.instant('entity.action.delete');
                    },
                    buttonClass: function () {
                        return 'btn-danger';
                    },
                    iconClass: function () {
                        return 'fa-trash-o';
                    },
                    cancelCaption: function () {
                        return $translate.instant('entity.action.cancel');
                    },
                    cancelButtonClass: function () {
                        return 'btn-default';
                    },
                    cancelIconClass: function () {
                        return 'fa-ban';
                    }
                }
            });

            modal.result.then(function () {
                $log.debug('HomeController | remove co exhibitor:' + id);
                if (id > 0) {
                    RegistrationService.deleteCoExhibitor(id).then(successCoExhibitorDeleted, error);
                } else {
                    var remove = false;
                    var index = 0;

                    angular.forEach($localStorage.coExhibitors, function (exhibitor) {
                        if (exhibitor.id == id) {
                            remove = true;
                        }

                        if (!remove) {
                            index++;
                        }
                    });

                    if (remove) {
                        $localStorage.coExhibitors.splice(index, 1);
                        loadCoExhibitors();
                    }
                }
                CartFactory.removeCoExhibitorBookings(id);
            }, null);
        }

        function newCoExhibitor() {
            $log.debug('HomeController | new co exhibitor');
            // RegistrationService.createCoExhibitor().then(coExhibitorCreated, error);
            if ($localStorage.coExhibitors) {
                var newId = -1;
                angular.forEach($localStorage.coExhibitors, function (exhibitor) {
                    if (Number(exhibitor.id) < newId) {
                        newId = Number(exhibitor.id);
                    }
                });
                $state.go('registration', {"id": newId - 1});
            } else {
                $localStorage.coExhibitors = [];
                $state.go('registration', {"id": -1});
            }
        }

        function go(where) {
            $state.go(where);
        }

        function loadCoExhibitors() {
            RegistrationService.loadCoExhibitors().then(successCoExhibitors, error);
        }

        function successCoExhibitorDeleted(response, id) {
            $log.debug('HomeController | co exhibitor deleted: ', response.data);
            $log.debug('HomeController | co exhibitor deleted id: ', id);
            if (response.data) {
                loadCoExhibitors();
            } else {
                var successMsg = $translate.instant('home.unabletodeletecoexhibitor');
                AlertService.error(successMsg, {}, 'bottom right');
            }
        }

        function coExhibitorCreated(response) {
            $log.debug('HomeController | co exhibitor created: ', response.data);
            $state.go('registration', {"id": response.data});
        }

        function loadExhibitorInfo() {
            Principal.hasAuthority('AUTHORIZATION_PENDING').then(function (value) {
                if (value) {
                    ProjectService.loadPendingLabels().then(successPendingLabels, error);
                }
            }, function () {
                $log.debug('HomeController | not logged in');
            });

            Principal.hasAuthority('ESC_INACTIVE').then(function (value) {
                if (value) {
                    ProjectService.loadEscInactiveLabels().then(successEscInactiveLabels, error);
                }
            }, function () {
                $log.debug('HomeController | not logged in');
            });
        }

        function successPendingLabels(response) {
            $log.debug('HomeController | fetching pending label: ', response.data);
            vm.pendingLabel = response.data;
        }

        function successEscInactiveLabels(response) {
            $log.debug('HomeController | fetching pending label: ', response.data);
            vm.escInactiveLabel = response.data;
        }

        function successCoExhibitors(response) {
            $log.debug('HomeController | fetching coExhibitors: ', response.data);
            vm.coExhibitors = response.data;
            if ($localStorage.coExhibitors) {
                angular.forEach($localStorage.coExhibitors, function (ex) {
                    vm.coExhibitors.push(ex);
                });
            }
        }

        function showLoginButton() {
            return !vm.isAuthenticated;
        }

        function isLoggedIn() {
            return !!vm.isAuthenticated;
        }

        function validateProject() {
            $log.debug('HomeController | validating project with name: ' + vm.project);
            ProjectService.validateProject(vm.project).then(storeProjectInLocalStorage, errorProject);
        }

        function isInteger(value) {
            return typeof value === "number" &&
                isFinite(value) &&
                Math.floor(value) === value;
        }

        function storeProjectInLocalStorage(response) {
            $log.debug('HomeController | Project-Id received: ', response.data);
            if (isInteger(response.data) && response.data > 0) {
                var project = response.data;
                $localStorage.project = project;
                loadProjectInfo(project);
            } else {
                $log.debug('HomeController | ERROR getting project-id, go to', NO_PROJECT_URL);
                $window.location.assign(NO_PROJECT_URL);
            }
        }

        function loadProjectInfo(project) {
            return ProjectService.loadProjectInfo(project)
                .then(function (response) {
                    $log.debug('HomeController | Project info fetching successful', response.data);
                    $localStorage.projectinfo = response.data;
                    setProjectInfo();
                }, function (data) {
                    $log.debug('HomeController | error fetching project info', data);
                });
        }

        function setProjectInfo() {
            $log.debug('HomeController | Project-Info: ', $localStorage.projectinfo);
            if ($localStorage.projectinfo !== undefined) {
                vm.welcomeHeadline = $localStorage.projectinfo.title[vm.lang];
                vm.welcomeText = $sce.trustAsHtml($localStorage.projectinfo.description[vm.lang]);
                vm.welcomeImage = $localStorage.projectinfo.image;
                JhiLanguageService.setLanguages($localStorage.projectinfo.languages);
            } else {
                $window.location.assign(NO_PROJECT_URL);
            }
        }

        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            setProjectInfo();
        });

        function error(response) {
            $log.debug('HomeController | ERROR', response);
        }

        function errorProject(response) {
            $log.debug('HomeController | ERROR', response);
            $window.location.assign(NO_PROJECT_URL);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('download', {
            parent: 'summary',
            url: '/download',
            data: {
                authorities: ['PRE_AUTHORIZED','AUTHORIZED','ESC_INACTIVE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/download/download.html',
                    controller: 'DownloadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('download');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('DownloadService', DownloadService);

    DownloadService.$inject = ['$http', 'API_URL'];

    function DownloadService ($http, API_URL) {

        var service = {
            loadDownloadLabels:loadDownloadLabels,
            loadDownloadDocuments:loadDownloadDocuments
        };

        function loadDownloadLabels() {
            return $http.get(API_URL + 'project/download');
        }

        function loadDownloadDocuments() {
            return $http.get(API_URL + 'project/downloaddocuments');
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('DownloadController', DownloadController);

    DownloadController.$inject = ['$rootScope', '$localStorage', 'Principal', '$translate', '$log', '$state', 'DownloadService', '$sce', 'Auth'];

    function DownloadController($rootScope, $localStorage, Principal, $translate, $log, $state, DownloadService, $sce, Auth) {

        // VARIABLES
        var vm = this;

        vm.lang = $translate.use();

        // FUNCITONS DEFINITIONS
        vm.loaded = pageLoaded;
        vm.finishRegistration = finishRegistration;
        vm.preAuthorized = false;

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            vm.headline = vm.dto.title[vm.lang];
            vm.text = $sce.trustAsHtml(vm.dto.description[vm.lang]);
        });

        getExhibitorAuthorities();

        return vm;

        // FUNCTIONS
        function pageLoaded() {
            return !!vm.dto;
        }

        function getExhibitorAuthorities() {
            Principal.identity().then(function(identity) {
                $log.debug('SummaryController | authorities', identity);
                if (identity.authorities.indexOf('PRE_AUTHORIZED') !== -1) {
                    vm.preAuthorized = true;
                }
                loadDownloadData();
            }, function() {
                $log.debug('SummaryController | ERROR IDENTITY', value);
            });
        }


        function loadDownloadData() {
            DownloadService.loadDownloadLabels().then(successLabels, error);
            DownloadService.loadDownloadDocuments().then(successDocuments, error);
        }

        function successLabels(response) {
            $log.debug("DownloadController | Fetching download dto", response.data);
            vm.dto = response.data;

            if (vm.preAuthorized) {
                vm.headline = vm.dto.pretitle[vm.lang];
                vm.text = $sce.trustAsHtml(vm.dto.predescription[vm.lang]);
            } else {
                vm.headline = vm.dto.title[vm.lang];
                vm.text = $sce.trustAsHtml(vm.dto.description[vm.lang]);
            }
        }

        function successDocuments(response) {
            $log.debug("DownloadController | Fetching download documents", response.data);
            vm.downloads = response.data;
        }

        function error(response) {
            $log.debug('DownloadController | ERROR:', data);
        }

        function back() {
            $log.debug('DownloadController | back');
            $window.history.back();
        }

        function finishRegistration() {
            Auth.logout();
            $state.go('home', {}, {reload: true, notify: true});
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header === null || header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page-1) * 20)==0 ? 1:(($ctrl.page-1) * 20)}} - ' +
                    '{{($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total'
        }
    };

    angular
        .module('exhibitorRegistrationApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', '$localStorage'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance, $localStorage) {
        var vm = this;
        vm.showPassword = false;
        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.togglePasswordVisibility = togglePasswordVisibility;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function togglePasswordVisibility(){
            vm.showPassword = !vm.showPassword;
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username + '#' + $localStorage.project,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home', {}, {reload: true, notify: true});
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$translate', '$localStorage'];

    function JhiLanguageService($q, $translate, $localStorage) {
        var service = {
            setLanguages: setLanguages,
            getLanguages: getLanguages,
            getAll: getAll,
            getCurrent: getCurrent
        };
        init();
        return service;

        function init() {
            if ($localStorage.languages == undefined) {
                $localStorage.languages = ['de', 'en'];
            }
        }

        function getAll() {
            var deferred = $q.defer();
            deferred.resolve($localStorage.languages);
            return deferred.promise;
        }

        function getCurrent() {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }

        function setLanguages(langs) {
            if (!langs) {
                return;
            }

            var splitted = langs.split(',');
            var languages = [];
            angular.forEach(splitted, function(value){
                languages.push(value);
            });

            $localStorage.languages = languages;

        }

        function getLanguages() {
            return $localStorage.languages;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale', '$q'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale, $q) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        }, function (error) {
            // Ignore unhandled error
            return $q.reject(error);
        });

        vm.getLanguages = getLangs;


        return vm;

        function getLangs() {
            return JhiLanguageService.getLanguages();
        }

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'de',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('ngConfirm', ngConfirm);

    ngConfirm.$inject = ['$uibModal'];

    function ngConfirm($uibModal) {
        return {
            restrict: 'A',
            scope: {
                ngConfirmMessage: '@',
                ngConfirmTitle: '@',
                ngCancelCaption: '@',
                ngConfirmCaption: '@',
                ngConfirm: '&',
                ngCancel: '&',
                ngButtonClass: '@',
                ngIconClass: '@',
                ngCancelButtonClass: '@',
                ngCancelIconClass: '@'
            },
            link: function (scope, element) {
                element.bind('click', function () {
                    var modal = $uibModal.open({
                        templateUrl: 'app/components/confirm/confirm-dialog.html',
                        controller: 'ModalConfirmController',
                        size: 'md',
                        windowClass: 'confirm-window',
                        resolve: {
                            confirmMessage: function () {
                                return scope.ngConfirmMessage;
                            },
                            confirmTitle: function () {
                                return scope.ngConfirmTitle;
                            },
                            confirmCaption: function () {
                                return scope.ngConfirmCaption;
                            },
                            buttonClass: function () {
                                return scope.ngButtonClass;
                            },
                            iconClass: function () {
                                return scope.ngIconClass;
                            },
                            cancelCaption: function () {
                                return scope.ngCancelCaption;
                            },
                            cancelButtonClass: function () {
                                return scope.ngCancelButtonClass;
                            },
                            cancelIconClass: function () {
                                return scope.ngCancelIconClass;
                            }
                        }
                    });

                    modal.result.then(function () {
                        scope.ngConfirm();
                    }, function () {
                        scope.ngCancel();
                    });
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('ModalConfirmController', ModalConfirmController);

    ModalConfirmController.$inject = ['$scope', '$uibModalInstance', 'confirmMessage', 'confirmTitle', 'confirmCaption', 'cancelCaption', 'buttonClass', 'iconClass', 'cancelButtonClass', 'cancelIconClass'];

    function ModalConfirmController($scope, $uibModalInstance, confirmMessage, confirmTitle, confirmCaption, cancelCaption, buttonClass, iconClass, cancelButtonClass, cancelIconClass) {
        $scope.confirmMessage = confirmMessage;
        $scope.confirmTitle = confirmTitle;
        $scope.confirmCaption = confirmCaption;
        $scope.cancelCaption = cancelCaption;
        $scope.buttonClass = buttonClass ? buttonClass : 'btn-primary';
        $scope.iconClass = iconClass ? iconClass : 'fa-check';
        $scope.cancelButtonClass = cancelButtonClass ? cancelButtonClass : 'btn-primary';
        $scope.cancelIconClass = cancelIconClass ? cancelIconClass : 'fa-ban';

        $scope.ok = function () {
            $uibModalInstance.close();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

angular.module('exhibitorRegistrationApp').directive('ngReallyClick', [function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            element.bind('click', function() {
                var message = attrs.ngReallyMessage;
                if (message && confirm(message)) {
                    scope.$apply(attrs.ngReallyClick);
                }
            });
        }
    }
}]);
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };
    
    angular
        .module('exhibitorRegistrationApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('exhibitorRegistrationApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-exhibitorRegistrationApp-error');
                var entityKey = httpResponse.headers('X-exhibitorRegistrationApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('exhibitorRegistrationApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: true,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }

        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('exhibitorRegistrationApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('part', {
            parent: 'category',
            url: '/parts/:id',
            data: {
                authorities: ['AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/category/part/part.html',
                    controller: 'PartController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('part');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/**
 * Created by floriangref on 20.06.16.
 */
(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('PartService', PartService);

    PartService.$inject = ['$http', 'API_URL'];

    function PartService($http, API_URL) {
        var service = {
            loadPartsForCategory: loadPartsForCategory,
            loadDocumentsForCategory: loadDocumentsForCategory,
            loadExternalLinksForCategory: loadExternalLinksForCategory,
            loadAreas: loadAreas,
            loadParkingPermits: loadParkingPermits,
            loadExhibitorPermits: loadExhibitorPermits
        };

        return service;

        function loadParkingPermits(tempExhibitors) {
            return $http.get(API_URL + 'parts/parkingpermits', {params: {tempExhibitors: tempExhibitors}});
        }

        function loadExhibitorPermits(tempExhibitors) {
            return $http.get(API_URL + 'parts/exhibitorpermits', {params: {tempExhibitors: tempExhibitors}});
        }

        function loadPartsForCategory(category) {
            return $http.get(API_URL + 'parts/category', {params: {category: category}});
        }

        function loadDocumentsForCategory(category) {
            return $http.get(API_URL + 'parts/documents', {params: {category: category}});
        }

        function loadExternalLinksForCategory(category) {
            return $http.get(API_URL + 'parts/external-links', {params: {category: category}});
        }

        function loadAreas() {
            return $http.get(API_URL + 'area/booked');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('PartController', PartController);

    PartController.$inject = ['$state', '$localStorage', 'Principal', '$log', '$stateParams', 'PartService', 'RegistrationService', '$translate', '$rootScope', 'CartFactory', 'AlertService'];

    function PartController($state, $localStorage, Principal, $log, $stateParams, PartService, RegistrationService, $translate, $rootScope, CartFactory, AlertService) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.parts = [];
        vm.bookedParts = [];
        vm.externalLinks = [];
        vm.welcomeImage = $localStorage.projectinfo.image;

        vm.categoryId = $stateParams.id;
        $log.debug('PartController | opening parts for category ', $stateParams.id);

        vm.pageLoaded = pageLoaded;
        vm.book = book;
        vm.back = goBack;

        vm.coExhibitors = [];

        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateComboBoxValues(vm.areas);
            translateStandSystems(vm.parts);
        });

        getExhibitorAuthorities();

        loadParts();
        loadDocuments();
        loadExternalLinks();

        return vm;


        function getExhibitorAuthorities() {
            Principal.identity().then(function(identity) {
                vm.company = identity.company;
                loadCoExhibitors();
            }, function() {
                $log.debug('PartController | ERROR IDENTITY', value);
            });
        }


        function loadParts() {
            $log.debug('PartController | fetch permits');
            PartService.loadPartsForCategory(vm.categoryId).then(successParts, error);
            PartService.loadAreas().then(successAreas, error);

        }

        function loadCoExhibitors() {
            RegistrationService.loadCoExhibitors().then(successCoExhibitors, error);
        }

        function successCoExhibitors(response) {
            vm.coExhibitors = response.data;

            if (vm.coExhibitors && vm.coExhibitors.length > 0 || $localStorage.coExhibitors && $localStorage.coExhibitors.length > 0) {
                vm.coExhibitors.push({id: -8000, company: vm.company});
            }

            var additionalCoExhibitors = 0;
            if ($localStorage.coExhibitors) {
                additionalCoExhibitors = $localStorage.coExhibitors.length;
                angular.forEach($localStorage.coExhibitors, function (ex) {
                    vm.coExhibitors.push(ex);
                });
            }
            PartService.loadExhibitorPermits(additionalCoExhibitors).then(successExhibitorPermits, error);
            PartService.loadParkingPermits(additionalCoExhibitors).then(successParkingPermits, error);

        }

        function loadDocuments() {
            $log.debug('PartController | fetching docuemnts');
            PartService.loadDocumentsForCategory(vm.categoryId).then(successDocuments, error);
        }

        function loadExternalLinks() {
            $log.debug('PartController | fetching external links');
            PartService.loadExternalLinksForCategory(vm.categoryId).then(successExternalLinks, error);
        }

        function successParts(response) {
            $log.debug('PartController | fetched parts:', response.data);
            vm.parts = response.data;
            translateStandSystems(vm.parts);
        }

        function successExhibitorPermits(response) {
            $log.debug('PartController | fetched successExhibitorPermits:', response.data);
            vm.exhibitorPermitsIncluded = response.data;
        }

        function successParkingPermits(response) {
            $log.debug('PartController | fetched successParkingPermits:', response.data);
            vm.parkingPermitsIncluded = response.data;
        }

        function successDocuments(response) {
            $log.debug('PartController | fetched documents:', response.data);
            vm.documents = response.data;
        }

        function successExternalLinks(response) {
            $log.debug('PartController | fetched external links:', response.data);
            vm.externalLinks = response.data;
        }

        function successAreas(response) {
            $log.debug('PartController | fetched areas:', response.data);
            vm.areas = response.data;
            translateComboBoxValues(vm.areas);
        }

        function error(response) {
            $log.debug('PartController | ERROR:', response);
        }

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.translations[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function translateStandSystems(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                if (value.availableColors !== undefined) {
                    angular.forEach(value.availableColors, function (color) {
                        color.name = color.translations[vm.lang];
                    });
                }
                values.push(value);
            });
            array = values;
        }

        function pageLoaded() {
            return vm.parts && vm.areas ? true : false;
        }

        function book(partId) {
            $log.debug('PartController | Booking parts.', vm.bookedParts);
            $log.debug('PartController | Part Id', partId);

            angular.forEach(vm.bookedParts, function (part, partIndex) {
                if (partIndex == partId) {
                    var price = getCartPositionPriceForPart(partIndex, part);
                    var bookedFor = getCartPositionBookedFor(part);
                    $log.debug('PartController | Part Price', price);
                    var item = {
                        type: 'Part',
                        areaType: '',
                        cartPositionPrice: price,
                        cartPositionParent: null,
                        cartPositionId: partId,
                        cartPositionLabel: getLabelForPart(partIndex),
                        cartPositionAreaLabel: getAreaLabelForPart(part.partArea),
                        cartPositionColorLabel: getColorLabel(partIndex, part.partColor),
                        cartPositionBookedFor: bookedFor,
                        cartPositionBookedForId: part.coExhibitor,
                        amount: part.partAmount,
                        areaID: part.partArea,
                        bookingOptionColors: [{partId: partIndex, colorId: part.partColor}],
                        id: partId
                    };

                    CartFactory.addItem(item);
                    part.partArea = null;
                    part.coExhibitor = null;
                    part.partColor = null;
                    part.partAmount = null;
                }
            });
            var successMsg = $translate.instant('part.addedToCart');
            AlertService.success(successMsg, {}, 'bottom right');

        }

        function getCartPositionPriceForPart(partId, part) {
            var price = 0;
            angular.forEach(vm.parts, function (p) {
                if (p.id == partId) {
                    price = part.partAmount * p.price;
                    //$log.debug('PartController | Calculating price ', price);
                    return price;
                }
            });

            return price;
        }

        function getCartPositionBookedFor(part) {

            var label = ''
            if (part.coExhibitor) {
                angular.forEach(vm.coExhibitors, function (ex) {
                    if (ex.id == part.coExhibitor) {
                        label = '- ' + ex.company;
                        return;
                    }
                });
            }
            return label;
        }

        function getLabelForPart(partId) {
            var label = "";
            angular.forEach(vm.parts, function (p) {
                if (p.id == partId) {
                    label = p.title;
                    return label;
                }
            });

            return label;
        }

        function getAreaLabelForPart(areaId) {
            var label = "";
            angular.forEach(vm.areas, function (area) {
                if (area.id == areaId) {
                    label = area.translations;
                    return label;
                }
            });

            return label;
        }

        function getColorLabel(partId, colorId) {
            var label = {de: '', en: ''};
            angular.forEach(vm.parts, function (p) {
                if (p.id == partId) {
                    angular.forEach(p.availableColors, function (color) {
                        if (color.id == colorId) {
                            label = color.translations;
                            return label;
                        }
                    });
                }
            });

            return label;
        }

        function goBack() {
            $state.go('category');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('categoryNavigation', categoryNavigation);

    categoryNavigation.$inject = ['$log', '$state', '$rootScope', '$translate', '$localStorage', 'CategoryService', '$stateParams'];

    function categoryNavigation($log, $state, $rootScope, $translate, $localStorage, CategoryService, $stateParams) {
        var directive = {
            restrict : 'E',
            templateUrl: 'app/category/navigation/navigation.html',
            scope: {
                minimized: '='
            },
            link : linkFunc
        };

        return directive;

        function linkFunc(scope) {
            var vm = scope.vm = {};
            vm.minimized = scope.minimized;
            vm.lang = $translate.use();
            vm.selectedCategoryId = parseInt($stateParams.id, 10);

            // FUNCITONS PUBLIC
            vm.pageLoaded = pageLoaded;
            vm.book = book;
            vm.changedSelection = changedSelection;

            // OTHER
            $rootScope.$on('$translateChangeSuccess', function () {
                vm.lang = $translate.use();
            });

            loadCategoryTiles();

            return vm;

            // FUNCTION DECLARATIONS
            function loadCategoryTiles() {
                CategoryService.loadCategories().then(successCategories, error);
            }


            function successCategories(response) {
                $log.debug('CategoryController | Fetching category tiles', response.data);
                vm.categories = response.data;
            }

            function error(response) {
                $log.debug('CategoryController | ERROR:',response.data);
            }

            function pageLoaded() {
                if (vm.categories) {
                    return true;
                }
                return false;
            }

            function changedSelection() {
                book(vm.selectedCategoryId);
            }

            function book(itemId) {
                $log.debug('CategoryController | opening category with id',itemId);
                $state.go('part', {'id':itemId});
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('category', {
            parent: 'app',
            url: '/category',
            data: {
                authorities: ['AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/category/category.html',
                    controller: 'CategoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('category');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('CategoryService', CategoryService);

    CategoryService.$inject = ['$http', 'API_URL'];

    function CategoryService ($http, API_URL) {
        var service = {
            loadCategories:loadCategories
        };

        return service;

        function loadCategories() {
            return $http.get(API_URL + 'parts/categories');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('CategoryController', CategoryController);

    CategoryController.$inject = ['$log', '$state', '$rootScope', '$translate', '$localStorage', 'CategoryService'];

    function CategoryController($log, $state, $rootScope, $translate, $localStorage, CategoryService) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();


        // FUNCITONS PUBLIC
        vm.pageLoaded = pageLoaded;
        vm.book = book;

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        loadCategoryTiles();

        return vm;


        // FUNCTION DECLARATIONS
        function loadCategoryTiles() {
            CategoryService.loadCategories().then(successCategories, error);
        }


        function successCategories(response) {
            $log.debug('CategoryController | Fetching category tiles', response.data);
            vm.categories = response.data;
        }

        function error(response) {
            $log.debug('CategoryController | ERROR:',response.data);
        }

        function pageLoaded() {
            if (vm.categories) {
                return true;
            }
            return false;
        }

        function book(itemId) {
            $log.debug('CategoryController | opening category with id',itemId);
            $state.go('part', {'id':itemId});
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('CartHTTPService', CartHTTPService);

    CartHTTPService.$inject = ['$http', 'API_URL'];

    function CartHTTPService($http, API_URL) {
        var service = {
            save: save
        };

        return service;

        function save(data) {
            return $http({
                method: 'POST',
                url: API_URL + 'cart',
                data: data
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('CartService', CartService);

    CartService.$inject = ['$log', 'API_URL', '$uibModal'];

    function CartService($log, API_URL, $uibModal) {
        // VARIABLES
        var vm = this;

        var service = {
            open: open,
            close:close
        };

        var modalInstance = null;

        var resetModal = function () {
            modalInstance = null;
        };

        return service;


        function open() {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/cart/cart.detail.html',
                controller: 'CartController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('cart');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );

        }

        function close() {
            modalInstance.close();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('CartLabelService', CartLabelService);

    CartLabelService.$inject = ['$log', '$translate'];

    function CartLabelService($log, $translate) {

        var service = {
            getCartLabelForItem: getLabelForItem
        };

        function getLabelForItem(item, lang) {
            //$log.debug('CartController | creating label for ', item);
            if (item.type == 'Fee') {
                return '';
            } else if (item.type == 'Area') {
                if (item.areaType == 'Open_Space') {
                    var powerUnit = '';
                    if (item.cartPositionPowerUnit == 'KILOWATT') {
                        powerUnit = 'kW';
                    } else if (item.cartPositionPowerUnit == 'TONS') {
                        powerUnit = 't';
                    }

                    var areaLabel = ' - ' + item.cartPositionBookingOptionTitle[lang] + ' - ' + item.fields.powerAmount + ' ' + powerUnit;
                    if (item.fields.additionalSquareMeters) {
                        areaLabel += " + " + item.fields.additionalSquareMeters + ' ' + $translate.instant('cart.squaremeters');
                        areaLabel += ' ' + $translate.instant('cart.disposalIncluded');
                    }
                    return areaLabel;
                } else if (item.areaType == 'Pavillion') {
                    var areaLabel = ' - ' + item.squaremeters + ' ' + $translate.instant('cart.squaremeters');
                    if (item.cartPositionBookingOptionTitle) {
                        areaLabel += ' - ' + item.cartPositionBookingOptionTitle[lang];
                    }
                    areaLabel += ' ' + $translate.instant('cart.disposalIncluded');

                    $log.debug('CartLabelService | Pavillion area label', areaLabel);

                    return areaLabel;
                } else if (item.areaType == 'Outdoor_area' || item.areaType == 'Outdoor_area_static') {
                    var areaLabel = ' - ' + item.squaremeters + ' ' + $translate.instant('cart.squaremeters');
                    areaLabel += ' ' + $translate.instant('cart.disposalIncluded');
                    return areaLabel;
                }
            } else if (item.type == 'Part') {
                var partLabel =  item.cartPositionColorLabel[lang] + ' - ' + item.cartPositionAreaLabel[lang];
                return partLabel;
            }
        }

        return service;


    }
})();

/**
 * @ngdoc service
 * @name cart:CartFactory
 *
 * @description
 *
 *
 * */
(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('CartFactory', CartFactory);

    CartFactory.$inject = ['$localStorage', '$log', 'CartHTTPService'];

    function CartFactory($localStorage, $log, CartHTTPService) {

        //delete $localStorage.cart;

        var service = {
            getCart: getCart,
            addItem: addItem,
            updateItemByIndex: updateItemByIndex,
            addFee: addFee,
            removeItem: removeItem,
            count: count,
            totalPrice: totalPrice,
            book: book,
            countAreas: countAreas,
            removeCoExhibitorBookings: removeCoExhibitorBookings,
            clear: clear
        };

        return service;

        // returns all items in this cart for the completion page
        function getCart() {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            return $localStorage.cart;
        }

        // adds an item into the cart
        function addItem(item) {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            $log.debug('CartFactory | Adding item: ', item);
            $localStorage.cart.push(item);
        }

        // adds an item into the cart
        function updateItemByIndex(index, item) {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            $log.debug('CartFactory | Updating item old/new: ', $localStorage.cart[index], item);
            $localStorage.cart[index] = item;
        }

        // removes an item
        function removeItem(item) {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            $log.debug('CartFactory | Removing item: ' + item);
            var count = 0;
            angular.forEach($localStorage.cart, function (value) {
                if (value == item) {
                    $localStorage.cart.splice(count, 1);
                }
                count++;
            });
        }

        // Return how many items are currently in this cart
        function count() {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            return $localStorage.cart.length;
        }

        // Returns the total price of all items in this cart
        function totalPrice() {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            var price = 0;

            angular.forEach($localStorage.cart, function (value) {
                if (value != null && value.cartPositionPrice != null)
                    price += value.cartPositionPrice;
            });
            return price;
        }

        function countAreas() {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            var count = 0;

            angular.forEach($localStorage.cart, function (value) {
                if (value != null && value.type != null && value.type == 'Area')
                    count ++;
            });
            return count;
        }

        function removeCoExhibitorBookings(id) {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }

            var index = $localStorage.cart.length - 1;

            while (index >= 0) {
                if ($localStorage.cart[index].cartPositionBookedForId === id) {
                    $localStorage.cart.splice(index, 1);
                }

                index -= 1;
            }
        }

        function addFee(item) {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            $log.debug('CartFactory | Adding fee: ', item);
            var addToCart = true;
            if (item.type == 'Fee') {
                angular.forEach($localStorage.cart, function (value) {
                    if (value.type == 'Fee') {
                        addToCart=false;
                        return;
                    }
                });
            } else if (item.type == 'CoExhibitorFee') {
                angular.forEach($localStorage.cart, function (value) {
                    if (value.type == 'CoExhibitorFee' && value.cartPositionBookedForId == item.cartPositionBookedForId) {
                        value.coExhibitor = item.coExhibitor;
                        value.cartPositionBookedFor = item.cartPositionBookedFor;
                        value.cartPositionBookedForId = item.cartPositionBookedForId;
                        addToCart=false;
                        return;
                    }
                });
            }
            if (addToCart)
                $localStorage.cart.unshift(item);
        }

        function book() {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            return CartHTTPService.save($localStorage.cart);
        }

        function clear() {
            delete $localStorage.cart;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('gsCart', gsCart);


    function gsCart () {
        var directive = {
            controller: 'CartController',
            controllerAs: 'vm',
            templateUrl: 'app/cart/cart.html',
            restrict: 'AE',
        };

        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('CartController', CartController);

    CartController.$inject = ['$log','Principal', 'CartFactory', 'CartService', '$translate', '$rootScope', '$state', 'CartLabelService'];

    function CartController($log,Principal, CartFactory, CartService, $translate, $rootScope, $state, CartLabelService) {
        var vm = this;

        vm.itemCount = CartFactory.count();
        vm.totalPrice = CartFactory.totalPrice();
        vm.cart = CartFactory.getCart();
        vm.cartFactory = CartFactory;
        vm.areaCount = CartFactory.countAreas();
        vm.lang = $translate.use();
        vm.mustBookArea = false;
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        Principal.hasAuthority('PRE_AUTHORIZED').then(function (hasAuthority) {
            if (hasAuthority) {
                vm.mustBookArea = true;
            }else{
                vm.areaCount = 100;
            }
        });

        vm.openCart = openCart;
        vm.remove = removeItem;
        vm.goToSummary = goToSummary;
        vm.getLabelForItem = getLabelForItem;

        function openCart() {
            vm.cart = CartFactory.getCart();
            CartService.open();
        }

        function removeItem(item) {
            CartFactory.removeItem(item);
            if(vm.mustBookArea)
                vm.areaCount = CartFactory.countAreas();
        }

        function goToSummary() {
            CartService.close();
            $state.go('summary');
        }

        function getLabelForItem(item) {
           return CartLabelService.getCartLabelForItem(item, vm.lang);
        }

        return vm;
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-exhibitorRegistrationApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-exhibitorRegistrationApp-params')});
            }
            var alertKey = response.headers('X-exhibitorRegistrationApp-error');
            if (angular.isString(alertKey)) {
                AlertService.error(alertKey, { param : response.headers('X-exhibitorRegistrationApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('exhibitorRegistrationApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token && token.expires_at && token.expires_at > new Date().getTime()) {
                config.headers.Authorization = 'Bearer ' + token.access_token;
            }
            
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate', '$q'];

    function translationHandler($rootScope, $window, $state, $translate, $q) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            }, function (error) {
                // Ignore unhandled error
                return $q.reject(error);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$transitions', '$state', '$translate', 'JhiLanguageService', 'translationHandler', '$window', '$q',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $transitions, $state, $translate, JhiLanguageService, translationHandler, $window, $q,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $transitions.onStart({}, function (transition) {
                var toState = transition.to();
                var toStateParams = transition.params();
                var fromState = transition.from();

                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    transition.abort();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                }, function (error) {
                    // Ignore unhandled error
                    return $q.reject(error);
                });
            });

            var stateChangeSuccess = $transitions.onSuccess({}, function(transition) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (transition.router.globals.current.data.pageTitle) {
                    titleKey = transition.router.globals.current.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "de"');
                $cookies.putObject(name, 'de');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('de');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(logConfig);

    logConfig.$inject = ['$logProvider'];

    function logConfig($logProvider) {
        $logProvider.debugEnabled(true);
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('gref-software');
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(true);
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pavillion', {
            parent: 'area',
            url: '/pavillion',
            data: {
                authorities: ['PRE_AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/area/pavillion/pavillion.html',
                    controller: 'PavillionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pavillion');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('PavillionDetailService', PavillionDetailService);

    PavillionDetailService.$inject = ['$http', '$log', 'API_URL', '$uibModal'];

    function PavillionDetailService($http, $log, API_URL, $uibModal) {
        // VARIABLES
        var vm = this;

        var service = {
            open: open,
            getDetails: getDetails,
        };
        var modalInstance = null;

        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function getDetails() {
            $log.debug("Load package details for package {}",vm.selectedPackage);
            return $http.get(API_URL + 'area/bookingoptiondetail', {params: {id: vm.selectedPackage.id}});
        }

        function open(selectedPackage) {
            if (modalInstance !== null) return;
            vm.selectedPackage = selectedPackage;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/area/pavillion/pavillion.detail.html',
                controller: 'PavillionDetailController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('PavillionDetailController', PavillionDetailController);

    PavillionDetailController.$inject = ['PavillionDetailService', '$log', '$rootScope', '$translate'];

    function PavillionDetailController(PavillionDetailService, $log, $rootScope, $translate) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.detail = {};

        load();

        return vm;

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        function load() {
            PavillionDetailService.getDetails().then(success, error);
        }

        function success(response) {
            $log.debug('Details loaded:');
            vm.detail = response.data;
            $log.debug(vm.detail);
        }

        function error(response) {
            $log.debug('ERROR:');
            $log.debug(response);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('PavillionController', PavillionController);

    PavillionController.$inject = ['PavillionDetailService', '$log', 'AreaService', '$rootScope', '$translate', 'CartFactory', '$state', '$filter', '$localStorage'];

    function PavillionController(PavillionDetailService, $log, AreaService, $rootScope, $translate, CartFactory, $state, $filter, $localStorage) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.labels = [];


        // RESERVED!! USE THIS OBJECT TO POST DATA
        vm.pavillion = {
            squaremeters: 0,
            price: null,
            package: null,
            colors: []
        };

        // FUNCITONS PUBLIC
        vm.packageInfo = openInfo;
        vm.calc = calculateSquaremeters;
        vm.pageLoaded = pageLoaded;
        vm.bookArea = bookArea;
        vm.resetPackage = resetPackage;
        vm.packageChanged = packageChanged;
        vm.goBack = goBack;


        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateComboBoxValues(vm.prices.prices);
            translateStandSystems(vm.bookingoptions);
        });

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function goBack() {
            $state.go('area');
        }

        function translateStandSystems(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang] + " - " + value.price.prices[0].title[vm.lang];
                if (value.availableColors !== undefined) {
                    angular.forEach(value.availableColors, function (color) {
                        if (color.colors !== undefined) {
                            angular.forEach(color.colors, function (col) {
                                col.name = col.translations[vm.lang];
                            });
                        }
                    });
                }
                values.push(value);
            });
            array = values;
        }

        load();

        // FUNCTION DECLARATIONS
        function load() {
            AreaService.loadPrices('Pavillion').then(successPrices, error);
            AreaService.loadLabels('Pavillion').then(successLabels, error);
            AreaService.loadBookingOptions('Pavillion').then(successBookingOptions, error);
            AreaService.loadCartLabels('Pavillion').then(successCartLabels, error)
        }

        function successPrices(response) {
            $log.debug("PavillionController | Fetching prices ", response.data);
            vm.prices = response.data
            translateComboBoxValues(vm.prices.prices);
        }

        function successLabels(response) {
            $log.debug("PavillionController | Fetching text labels", response.data);
            angular.forEach(response.data, function (value) {
                vm.labels[value.key] = value.translations;
            });
        }

        function successCartLabels(response) {
            $log.debug('PavillionController | Fetching cart label', response.data);
            vm.pavillion.cartPositionLabel = response.data;
        }

        function successBookingOptions(response) {
            $log.debug("PavillionController | Fetching booking options", response.data);
            vm.bookingoptions = response.data;
            translateStandSystems(vm.bookingoptions);
        }

        function openInfo() {
            $log.debug('PavillionController | Open pavillion detail Information info');
            PavillionDetailService.open(vm.pavillion.package);
        }

        function error(response) {
            $log.debug('PavillionController | ERROR:', data);
        }

        function pageLoaded() {
            if (vm.bookingoptions) {
                return true;
            }
            return false;
        }

        function calculateSquaremeters() {
            $log.debug('PavillionController | Calculate squaremeter');
            vm.pavillion.squaremeters = parseFloat(vm.pavillion.length * vm.pavillion.width);
        }

        function bookArea() {
            $log.debug('PavillionController | Book Pavillion:', vm.pavillion);
            calculateAreaPrice();

            var colors = [];
            angular.forEach(vm.pavillion.colors, function (colorId, partId) {
                colors.push({partId: partId, colorId: colorId});
            });

            var bookingOption = vm.pavillion.package ? vm.pavillion.package.id : null;
            var bookingOptionTitle = vm.pavillion.package ? vm.pavillion.package.title : null;

            var item = {
                type: 'Area',
                areaType: 'Pavillion',
                cartPositionPrice: vm.pavillion.cartPositionPrice,
                cartPositionParent: null,
                cartPositionLabel: vm.pavillion.cartPositionLabel,
                cartPositionBookingOptionTitle: bookingOptionTitle,
                cartPositionId: null,
                price: vm.pavillion.price.id,
                bookingOption: bookingOption,
                length: vm.pavillion.length,
                width: vm.pavillion.width,
                squaremeters: squareMetersToDouble(vm.pavillion.squaremeters),
                bookingOptionColors: colors,
                fields: {
                    suggestions: vm.pavillion.suggestions,
                    weExhibit: vm.pavillion.vehicleDescription,
                    heaviestObject: vm.pavillion.heaviestObject,
                    maxWeightPerSq: vm.pavillion.maxWeightPerSq,
                    ownstand: vm.pavillion.ownstand,
                    requestedStandSystemOffer: vm.pavillion.requestedStandSystemOffer

                },
                id: null
            };

            $localStorage.showSuccessAlert = true;

            CartFactory.addItem(item);
            $state.go('area');
        }

        function resetPackage() {
            vm.pavillion.package = null;
            vm.pavillion.colors = [];
        }

        function squareMetersToDouble(squaremeters) {
            return parseFloat(squaremeters);
        }

        function packageChanged() {
            vm.pavillion.colors = [];
        }

        function calculateAreaPrice() {
            var packagePrice = vm.pavillion.package ? vm.pavillion.package.price.prices[0].price : 0;
            var sq = parseFloat(vm.pavillion.squaremeters);
            vm.pavillion.cartPositionPrice = (sq) * (packagePrice + vm.pavillion.price.price + vm.prices.disposalFee);
            vm.pavillion.cartPositionParent = null;
            $log.debug('PavillionController | Preis der Fläche:', vm.pavillion.cartPositionPrice);
        }

        return vm;
    }
})();


(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('outdoorstatic', {
            parent: 'area',
            url: '/outdoorstatic',
            data: {
                authorities: ['PRE_AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/area/outdoorstatic/outdoorstatic.html',
                    controller: 'OutdoorStaticController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('outdoorstatic');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('OutdoorStaticController', OutdoorStaticController);

    OutdoorStaticController.$inject = ['$state', '$log', 'CartFactory', 'AreaService', '$translate', '$rootScope', 'AreaCalculationService', '$filter', '$localStorage'];

    function OutdoorStaticController($state, $log, CartFactory, AreaService, $translate, $rootScope, AreaCalculationService, $filter, $localStorage) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.labels = [];

        vm.outdoorAreaStatic = {
            cartPositionPrice: 0,
            cartPositionParent: null,
            cartPositionLabel: null,
            cartPositionId: null
        };
        vm.toggleOwnContainer = true;

        vm.bookArea = bookArea;
        vm.calc = calculate;
        vm.pageLoaded = pageLoaded;
        vm.toggle = toggle;
        vm.goBack = back;


        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        load();

        // FUNCTION DECLARATIONS
        function load() {
            AreaService.loadPrices('Outdoor_area_static').then(successPrices, error);
            AreaService.loadLabels('Outdoor_area_static').then(successLabels, error);
            AreaService.loadCartLabels('Outdoor_area_static').then(successCartLabels, error)
        }

        function successPrices(response) {
            $log.debug("OutdoorStaticController | Fetching prices ", response.data);
            vm.prices = response.data
            translateComboBoxValues(vm.prices.prices);
        }

        function successLabels(response) {
            $log.debug("OutdoorStaticController | Fetching text labels ", response.data);
            angular.forEach(response.data, function (value) {
                vm.labels[value.key] = value.translations;
            });
        }

        function successCartLabels(response) {
            $log.debug('OutdoorStaticController | Fetching cart label', response.data);
            vm.outdoorAreaStatic.cartPositionLabel = response.data;
        }

        function error(response) {
            $log.debug('OutdoorStaticController | ERROR:', response);
        }

        function calculate() {
            vm.outdoorAreaStatic.squaremeters = parseFloat(vm.outdoorAreaStatic.length * vm.outdoorAreaStatic.width);

            if (vm.outdoorAreaStatic.squaremeters > 0) {
                calculateAreaPrice();
            }
        }

        function toggle() {
            vm.toggleOwnContainer = !vm.toggleOwnContainer;
        }

        function bookArea() {
            calculateAreaPrice();

            var item = {
                type: 'Area',
                areaType: 'Outdoor_area_static',
                cartPositionPrice: vm.outdoorAreaStatic.cartPositionPrice,
                cartPositionParent: null,
                cartPositionLabel: vm.outdoorAreaStatic.cartPositionLabel,
                cartPositionId: null,
                length: vm.outdoorAreaStatic.length,
                width: vm.outdoorAreaStatic.width,
                squaremeters: squareMetersToDouble(vm.outdoorAreaStatic.squaremeters),
                fields: {
                    suggestions: vm.outdoorAreaStatic.suggestions,
                    weExhibit: vm.outdoorAreaStatic.weexhibit,
                    requestedContainerOffer: vm.outdoorAreaStatic.requestedContainerOffer,
                    requestedTentOffer: vm.outdoorAreaStatic.requestedTentOffer,
                    tentOrContainerWidth: vm.outdoorAreaStatic.containerWidth,
                    tentOrContainerLength: vm.outdoorAreaStatic.containerLength
                },
                id: null
            };
            $localStorage.showSuccessAlert = true;

            $log.debug('OutdoorStaticController | adding item to cart', item);

            CartFactory.addItem(item);
            $state.go('area');
        }

        function back() {
            $state.go('area');
        }

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function squareMetersToDouble(squaremeters) {
            return parseFloat(squaremeters);
        }

        function pageLoaded() {
            // TODO
            return true;
        }

        function calculateAreaPrice() {
            vm.outdoorAreaStatic.cartPositionPrice = AreaCalculationService.calculateAreaPrice(vm.prices, vm.outdoorAreaStatic.squaremeters);
        }

        return vm;
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('outdoor', {
            parent: 'area',
            url: '/outdoor',
            data: {
                authorities: ['PRE_AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/area/outdoor/outdoor.html',
                    controller: 'OutdoorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('outdoor');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('OutdoorController', OutdoorController);

    OutdoorController.$inject = ['$state', '$log', 'CartFactory', 'AreaService', '$translate', '$rootScope', 'AreaCalculationService', '$filter', '$localStorage'];

    function OutdoorController($state, $log, CartFactory, AreaService, $translate, $rootScope, AreaCalculationService, $filter, $localStorage) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.labels = [];

        vm.outdoorArea = {
            cartPositionPrice: 0,
            cartPositionParent: null,
            cartPositionLabel: null,
            cartPositionType: 'Outdoor_area',
            cartPositionId: null
        };
        vm.toggleOwnContainer = true;

        vm.bookArea = bookArea;
        vm.calc = calculate;
        vm.pageLoaded = pageLoaded;
        vm.toggle = toggle;
        vm.goBack = back;

        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        load();

        // FUNCTION DECLARATIONS
        function load() {
            AreaService.loadPrices('Outdoor_area').then(successPrices, error);
            AreaService.loadLabels('Outdoor_area').then(successLabels, error);
            AreaService.loadBookingOptions('Outdoor_area').then(successBookingOptions, error);
            AreaService.loadCartLabels('Outdoor_area').then(successCartLabels, error)
        }

        function successPrices(response) {
            $log.debug("OutdoorController | Fetching prices ",response.data);
            vm.prices = response.data
            translateComboBoxValues(vm.prices.prices);
        }

        function successLabels(response) {
            $log.debug("OutdoorController | Fetching text labels ",response.data);
            angular.forEach(response.data, function (value) {
                vm.labels[value.key] = value.translations;
            });
        }

        function successCartLabels(response) {
            $log.debug('OutdoorController | Fetching cart label',response.data);
            vm.outdoorArea.cartPositionLabel = response.data;
        }

        function successBookingOptions(response) {
            $log.debug("OutdoorController | Fetching booking options",response.data);
            vm.bookingoptions = response.data;
            translateComboBoxValues(vm.bookingoptions);
        }


        function error(response) {
            $log.debug('OutdoorController | ERROR:',response);
        }

        function calculate() {
            vm.outdoorArea.squaremeters = parseFloat(vm.outdoorArea.length * vm.outdoorArea.width);
            if (vm.outdoorArea.squaremeters > 0) {
                calculateAreaPrice();
            }
        }

        function back() {
            $state.go('area');
        }


        function toggle() {
            vm.toggleOwnContainer = !vm.toggleOwnContainer;
        }

        function bookArea() {
            calculateAreaPrice();
            
            var item = {
                type:'Area',
                areaType:'Outdoor_area',
                cartPositionPrice: vm.outdoorArea.cartPositionPrice,
                cartPositionParent: null,
                cartPositionLabel: vm.outdoorArea.cartPositionLabel,
                cartPositionId: null,
                length: vm.outdoorArea.length,
                width: vm.outdoorArea.width,
                squaremeters: squareMetersToDouble(vm.outdoorArea.squaremeters),
                fields: {
                    suggestions: vm.outdoorArea.suggestions,
                    weExhibit: vm.outdoorArea.vehicleDescription,
                    ownstand: vm.outdoorArea.ownstand,
                    tentOrContainerLength: vm.outdoorArea.containerLength,
                    tentOrContainerWidth: vm.outdoorArea.containerWidth,
                    requestedContainerOffer: vm.outdoorArea.requestedContainerOffer,
                    requestedTentOffer: vm.outdoorArea.requestedTentOffer
                },
                id:null
            };

            $localStorage.showSuccessAlert = true;

            $log.debug('OutdoorController | Book area:', item);


            CartFactory.addItem(item);
            $state.go('area');
        }


        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function squareMetersToDouble(squaremeters) {
            return parseFloat(squaremeters);
        }

        function pageLoaded() {
            // TODO
            return true;
        }

        function calculateAreaPrice() {
            vm.outdoorArea.cartPositionPrice = AreaCalculationService.calculateAreaPrice(vm.prices, vm.outdoorArea.squaremeters);
            $log.debug('OutdoorController | Calculated area price:', vm.outdoorArea.cartPositionPrice );
        }


        return vm;
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('openspace', {
            parent: 'area',
            url: '/openspace',
            data: {
                authorities: ['PRE_AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/area/openspace/openspace.html',
                    controller: 'OpenSpaceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('openspace');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('OpenSpaceController', OpenSpaceController);

    OpenSpaceController.$inject = ['$log', 'AreaService', '$rootScope', '$translate', 'CartFactory', '$state', 'AreaCalculationService', '$localStorage'];

    function OpenSpaceController($log, AreaService, $rootScope, $translate, CartFactory, $state, AreaCalculationService, $localStorage) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.labels = [];
        vm.priceTable = [];
        vm.powerunit;


        // RESERVED!! USE THIS OBJECT TO POST DATA
        vm.openSpace = {
            cartPositionPrice: 0,
            cartPositionParent: null,
            cartPositionLabel: null,
            cartPositionType: 'Open_Space',
            cartPositionId: null
        };

        // FUNCITONS PUBLIC
        vm.pageLoaded = pageLoaded;
        vm.bookArea = bookArea;
        vm.showPrices = showPrices;
        vm.goBack = goBack;

        function goBack() {
            $state.go('area');
        }

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateBookingOptions(vm.bookingoptions);
            translateComboBoxValues(vm.prices.prices);

        });


        function translateBookingOptions(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                values.push(value);
            });
            array = values;
        }

        load();

        // FUNCTION DECLARATIONS
        function load() {
            AreaService.loadPrices('Open_Space').then(successPrices, error);
            AreaService.loadLabels('Open_Space').then(successLabels, error);
            AreaService.loadBookingOptions('Open_Space').then(successBookingOptions, error);
            AreaService.loadCartLabels('Open_Space').then(successCartLabels, error)
        }

        function successPrices(response) {
            $log.debug("OpenSpaceController | Fetching prices ", response.data);
            vm.prices = response.data
            translateComboBoxValues(vm.prices.prices);
        }

        function successLabels(response) {
            $log.debug("OpenSpaceController | Fetching labels ", response.data);
            angular.forEach(response.data, function (value) {
                vm.labels[value.key] = value.translations;
            });
        }

        function successCartLabels(response) {
            $log.debug('OpenSpaceController | fetching area translation', response.data);
            vm.openSpace.cartPositionLabel = response.data;
        }

        function successBookingOptions(response) {
            $log.debug("OpenSpaceController | Fetching booking options", response.data);
            vm.bookingoptions = response.data;
            translateBookingOptions(vm.bookingoptions);
        }


        function error(response) {
            $log.debug('OpenSpaceController | ERROR:', response);
        }

        function pageLoaded() {

            // TODO
            return true;
            if (vm.bookingoptions) {
                return true;
            }
            return false;
        }

        function bookArea() {
            calculateAreaPrice();
            var bookingOptionTitle = vm.openSpace.bookingoption ? vm.openSpace.bookingoption.title : null;

            var item = {
                type: 'Area',
                areaType: 'Open_Space',
                cartPositionPrice: vm.openSpace.cartPositionPrice,
                cartPositionParent: null,
                cartPositionLabel: vm.openSpace.cartPositionLabel,
                cartPositionId: null,
                cartPositionPowerUnit: vm.powerunit,
                cartPositionBookingOptionTitle: bookingOptionTitle,
                bookingOption: vm.openSpace.bookingoption.id,
                fields: {
                    suggestions: vm.openSpace.suggestions,
                    weExhibit: vm.openSpace.vehicleDescription,
                    vehicleDescription: vm.openSpace.vehicleDescription,
                    additionalSquareMeters: vm.openSpace.additionalSquareMeters,
                    powerAmount: vm.openSpace.powerAmount
                },
                id: null
            };

            CartFactory.addItem(item);

            $localStorage.showSuccessAlert = true;
            $log.debug('OpenSpaceController | saving area', item);
            $state.go('area');
        }

        function resetPackage() {
            vm.openSpace.package = null;
        }

        function showPrices() {
            vm.priceTable = [];

            angular.forEach(vm.bookingoptions, function (bookingoption) {
                if (vm.openSpace.bookingoption == bookingoption) {
                    vm.powerunit = bookingoption.powerUnit;

                    angular.forEach(bookingoption.price.prices, function (price) {
                        vm.priceTable.push({
                            name: price.title[vm.lang],
                            smIncluded: price.smIncluded,
                            price: price.price
                        });
                    });
                }
            });
        }

        function calculateAreaPrice() {
            $log.debug('OpenSpaceController | calculating price with power', vm.openSpace.powerAmount);
            vm.openSpace.cartPositionPrice = AreaCalculationService.calculateAreaPrice(vm.openSpace.bookingoption.price, vm.openSpace.powerAmount);
            $log.debug('OpenSpaceController | area price ', vm.openSpace.cartPositionPrice);

            if (vm.openSpace.additionalSquareMeters) {
                // Fix for additional squaremeters disposal fee
                var additionalSquaremeters = vm.openSpace.additionalSquareMeters;
                $log.debug('OpenSpaceController |  additionalsquaremeters', additionalSquaremeters);

                var disposalPrice = additionalSquaremeters * vm.prices.disposalFee;
                $log.debug('OpenSpaceController | calculating disposalprice ', disposalPrice);

                // Calculate fix price for additional squaremeters:
                if (vm.prices.prices[0].price) {
                    $log.debug('OpenSpaceController | calculating price for additional squaremeters', (vm.prices.prices[0].price * vm.openSpace.additionalSquareMeters));
                    vm.openSpace.cartPositionPrice += vm.openSpace.additionalSquareMeters * vm.prices.prices[0].price;
                }
                vm.openSpace.cartPositionPrice += disposalPrice;
            }

            vm.openSpace.cartPositionParent = null;
        }

        return vm;
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jointstand', {
            parent: 'area',
            url: '/jointstand',
            data: {
                authorities: ['PRE_AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/area/joint-stand/joint-stand.html',
                    controller: 'JointStandController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('jointstand');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('JointStandController', JointStandController);

    JointStandController.$inject = ['$log', 'AreaService', '$rootScope', '$translate', 'CartFactory', '$state', 'AreaCalculationService', '$localStorage', '$sce'];

    function JointStandController($log, AreaService, $rootScope, $translate, CartFactory, $state, AreaCalculationService, $localStorage, $sce) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.labels = [];
        vm.priceTable = [];
        vm.sanitizedJointInfo2 = '';
        vm.area = null;

        // RESERVED!! USE THIS OBJECT TO POST DATA
        vm.jointStand = {
            cartPositionPrice: 0,
            cartPositionParent: null,
            cartPositionLabel: null,
            cartPositionType: 'Joint_Stand',
            cartPositionId: null
        };

        // FUNCITONS PUBLIC
        vm.pageLoaded = pageLoaded;
        vm.bookArea = bookArea;
        vm.showPrices = showPrices;
        vm.goBack = goBack;
        vm.trustHtml = trustHtml;

        function goBack() {
            $state.go('area');
        }

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateComboBoxValues(vm.prices.prices);

        });

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                values.push(value);
            });
            array = values;
        }

        load();

        // FUNCTION DECLARATIONS
        function load() {
            AreaService.loadPrices('Joint_Stand').then(successPrices, error);
            AreaService.loadLabels('Joint_Stand').then(successLabels, error);
            AreaService.loadCartLabels('Joint_Stand').then(successCartLabels, error);
            loadArea();
        }

        function successPrices(response) {
            $log.debug("JointStandController | Fetching prices ", response.data);
            vm.prices = response.data;
            translateComboBoxValues(vm.prices.prices);
        }

        function successLabels(response) {
            $log.debug("JointStandController | Fetching labels ", response.data);
            angular.forEach(response.data, function (value) {
                vm.labels[value.key] = value.translations;
            });
        }

        function successCartLabels(response) {
            $log.debug('JointStandController | fetching area translation', response.data);
            vm.jointStand.cartPositionLabel = response.data;
        }

        function loadArea() {
            vm.area = $localStorage.areaInformation.areas.find(function (area) {
                return area.areaType === 'Joint_Stand';
            });
        }

        function error(response) {
            $log.debug('JointStandController | ERROR:', response);
        }

        function trustHtml(value) {
            return $sce.trustAsHtml(value);
        }

        function pageLoaded() {
            return true;
        }

        function bookArea() {
            $log.debug('JointStandController | Book Joint_Stand:', vm.jointStand);

            var item = {
                type: 'Area',
                areaType: 'Joint_Stand',
                cartPositionPrice: vm.jointStand.price.price,
                cartPositionParent: null,
                cartPositionLabel: vm.jointStand.cartPositionLabel,
                cartPositionId: null,
                price: vm.jointStand.price.id,
                fields: {
                    suggestions: vm.jointStand.suggestions,
                    weExhibit: vm.jointStand.vehicleDescription,
                    heaviestObject: vm.jointStand.heaviestObject,
                    maxWeightPerSq: vm.jointStand.maxWeightPerSq,
                    ownstand: vm.jointStand.ownstand,
                    requestedStandSystemOffer: vm.jointStand.requestedStandSystemOffer

                },
                id: null
            };

            $localStorage.showSuccessAlert = true;

            CartFactory.addItem(item);
            $state.go('area');
        }

        function showPrices() {
            vm.priceTable = [];
        }

        return vm;
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('AreaCalculationService', AreaCalculationService);

    AreaCalculationService.$inject = ['$log'];

    function AreaCalculationService($log) {
        var service = {
            calculateAreaPrice: calculateAreaPrice
        };

        function calculateAreaPrice(prices, squaremeters) {
            $log.debug('AreaCalculationService | calculating area price');

            if (typeof squaremeters === 'string' || squaremeters instanceof String) {
                squaremeters = parseFloat(squaremeters);
            }

            var calcType = prices.calculationType;
            var disposalFee = prices.disposalFee;
            $log.debug('AreaCalculationService | disposalFee found', disposalFee);

            $log.debug('AreaCalculationService | Calculation type: ', calcType);
            if (calcType == 'SCALED_PRICE_PER_SQUARE_METER') {
                var totalSquaremeters = squaremeters;
                var totalPrice = 0;
                totalPrice += squaremeters * disposalFee;
                prices.prices = sortArray(prices.prices, 'minRange');

                angular.forEach(prices.prices, function (value) {

                    var max = value.maxRange;
                    var min = value.minRange;
                    var price = value.price;

                    var isInCompleteInterval = totalSquaremeters > max && max != 0;

                    if (isInCompleteInterval) {
                        totalPrice += (max - min) * price;
                    } else {
                        if (totalSquaremeters > min) {
                            totalPrice += (totalSquaremeters - min) * price;
                        }
                    }

                });

                $log.debug('AreaCalculationService | SCALED_PRICE_PER_SQUARE_METER price', totalPrice);
                return totalPrice;
            } else if (calcType == 'FIXED_PRICE_PER_SQUARE_METER') {
                var totalPrice = prices.prices[0].price * squaremeters;
                totalPrice += squaremeters * disposalFee;
                $log.debug('AreaCalculationService | FIXED_PRICE_PER_SQUARE_METER price', totalPrice);
                return totalPrice;
            } else if (calcType == 'SCALED_PRICE_PER_UNIT_AREA_INCLUDED') {
                var totalPrice = 0;
                angular.forEach(prices.prices, function (value) {

                    var max = value.maxRange;
                    var min = value.minRange;
                    var price = value.price;


                    if (squaremeters >= min && squaremeters <= max) {
                        totalPrice = squaremeters * price;
                        $log.debug('AreaCalculationService | SCALED_PRICE_PER_UNIT_AREA_INCLUDED price', totalPrice);
                        return totalPrice;
                    }else if(squaremeters>min && max ==0){
                        totalPrice = squaremeters * price;
                        $log.debug('AreaCalculationService | SCALED_PRICE_PER_UNIT_AREA_INCLUDED price', totalPrice);
                        return totalPrice;
                    }
                });

                return totalPrice;
            }
        }

        function sortArray(input, attribute) {
            if (!angular.isObject(input)) return input;

            var array = [];
            for (var objectKey in input) {
                array.push(input[objectKey]);
            }

            array.sort(function (a, b) {
                a = parseInt(a[attribute]);
                b = parseInt(b[attribute]);
                return a - b;
            });

            $log.debug('AreaCalculationService | Array sortiert');
            $log.debug(array);
            return array;
        }

        return service;

    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('area', {
            parent: 'app',
            url: '/area',
            data: {
                authorities: ['PRE_AUTHORIZED']
            },
            views: {
                'content@': {
                    templateUrl: 'app/area/area.html',
                    controller: 'AreaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('area');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('AreaService', AreaService);

    AreaService.$inject = ['$http', 'API_URL'];

    function AreaService ($http, API_URL) {
        var service = {
            areaInfo: areaInfo,
            loadPrices : loadPrices,
            loadLabels: loadLabels,
            loadBookingOptions: loadBookingOptions,
            loadCartLabels: loadCartLabels
        };

        return service;


        function areaInfo() {
            return $http.get(API_URL + 'area');
        }

        function loadPrices(key) {
            return $http.get(API_URL + 'area/prices', {params:{key:key}});
        }
        
        function loadLabels(key) {
            return $http.get(API_URL + 'project/translations', {params:{key:key}});
        }

        function loadBookingOptions(key) {
            return $http.get(API_URL + 'area/bookingoptions', {params:{key:key}});
        }

        function loadCartLabels(key) {
            return $http.get(API_URL + 'area/cartlabel', {params:{key:key}});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('AreaController', AreaController);

    AreaController.$inject = ['$scope', '$log', '$state', 'AreaService', '$rootScope', '$translate', '$localStorage', 'AlertService'];

    function AreaController($scope, $log, $state, AreaService, $rootScope, $translate, $localStorage, AlertService) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.areas = [];

        // FUNCITONS PUBLIC
        vm.book = book;
        vm.pageLoaded = pageLoaded;

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        loadAreaTiles();
        successAlert();

        return vm;

        function loadAreaTiles() {
            if ($localStorage.areaInformation !== undefined) {
                $log.debug('AreaController | Fetching area tiles from localStorage');
                vm.areas = $localStorage.areaInformation
            } else {
                AreaService.areaInfo().then(successAreas, error);
            }
        }

        function successAlert() {
            if ($localStorage.showSuccessAlert !== undefined && $localStorage.showSuccessAlert == true) {
                var successMsg = $translate.instant('area.addedToCart');
                AlertService.success(successMsg, {}, 'bottom right');
                delete $localStorage.showSuccessAlert;
            }
        }

        function book(type) {
            $log.debug('AreaController | Booking Area with Type: ' + type);
            if (type == 'Joint_Stand') {
                $log.debug('AreaController | goto jointstand');
                $state.go('jointstand');
            }
            if (type == 'Pavillion') {
                $log.debug('AreaController | goto pavillion');
                $state.go('pavillion');
            }
            if (type == 'Outdoor_area') {
                $log.debug('AreaController | goto outdoor');
                $state.go('outdoor');
            }
            if (type == 'Open_Space') {
                $log.debug('AreaController | goto open space');
                $state.go('openspace');
            }
            if (type == 'Outdoor_area_static') {
                $log.debug('AreaController | goto outdoorstatic');
                $state.go('outdoorstatic');
            }
        }

        function successAreas(response) {
            $log.debug('AreaController | Fetching area tiles', response.data);
            vm.areas = response.data;
            $localStorage.areaInformation = vm.areas;
        }

        function error(response) {
            $log.debug('AreaController | ERROR:', response.data);
        }

        function pageLoaded() {
            return (vm.areas.areas !== undefined && vm.areas.areas.length > 0);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('exhibitorRegistrationApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('NO_PROJECT_URL', "https://www.geoplangmbh.de/")
        .constant('API_URL', "https://registrierung.geoplangmbh.de/exhibitor-api/")
;
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(config);

    config.$inject = ['$locationProvider'];

    function config($locationProvider) {
        $locationProvider.hashPrefix('');
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', '$q'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService, $q) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        }, function (error) {
            // Ignore unhandled error
            return $q.reject(error);
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management_new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management_edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management_delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'paginationConstants', 'JhiLanguageService', '$q'];

    function UserManagementController(Principal, User, ParseLinks, paginationConstants, JhiLanguageService, $q) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.page = 1;
        vm.setActive = setActive;
        vm.totalItems = null;
        vm.users = [];


        vm.loadAll();

        
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        }, function (error) {
            // Ignore unhandled error
            return $q.reject(error);
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        }, function (error) {
            // Ignore unhandled error
            return $q.reject(error);
        });


        function loadAll () {
            User.query({page: vm.page - 1, size: paginationConstants.itemsPerPage}, function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');

                //hide anonymous user from user management: it's a required user for Spring Security
                for(var i in result) {
                    if(result[i]['login'] === 'anonymoususer') {
                        result.splice(i,1);
                    }
                }
                vm.users = result;
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http', 'API_URL'];

    function JhiMetricsService ($rootScope, $http, API_URL) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get(API_URL + 'management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get(API_URL + 'management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource', 'API_URL'];

    function LogsService ($resource, API_URL) {
        var service = $resource(API_URL + 'management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http', 'API_URL'];

    function JhiHealthService ($rootScope, $http, API_URL) {
        var service = {
            checkHealth: checkHealth
        };

        return service;

        function checkHealth () {
            return $http.get(API_URL + 'management/health').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('exhibitorRegistrationApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.addHealthObject = addHealthObject;
        vm.baseName = baseName;
        vm.flattenHealthData = flattenHealthData;
        vm.getLabelClass = getLabelClass;
        vm.getModuleName = getModuleName;
        vm.hasSubSystem = hasSubSystem;
        vm.isHealthObject = isHealthObject;
        vm.refresh = refresh;
        vm.updatingHealth = true;
        vm.separator = '.';
        vm.showHealth = showHealth;
        vm.subSystemName = subSystemName;
        vm.transformHealthData = transformHealthData;

        vm.refresh();


        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!vm.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function baseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (vm.isHealthObject(value)) {
                    if (vm.hasSubSystem(value)) {
                        vm.addHealthObject(result, false, value, vm.getModuleName(path, key));
                        vm.flattenHealthData(result, vm.getModuleName(path, key), value);
                    } else {
                        vm.addHealthObject(result, true, value, vm.getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + vm.separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = vm.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  vm.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

        function subSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        function transformHealthData (data) {
            var response = [];
            vm.flattenHealthData(response, null, data);
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http', 'API_URL'];

    function JhiConfigurationService ($filter, $http, API_URL) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get(API_URL + 'management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get(API_URL + 'management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource', 'API_URL'];

    function AuditsService ($resource, API_URL) {
        var service = $resource(API_URL + 'management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('registration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal','ProjectService', 'Auth', 'JhiLanguageService', '$translate', '$localStorage', '$q'];

    function SettingsController (Principal,ProjectService, Auth, JhiLanguageService, $translate, $localStorage, $q) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        loadComboBoxValues();

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                fax: account.fax,
                phone: account.phone,
                login: account.login,
                title: account.title,
                salutation: account.salutation,
                projectID :  $localStorage.project
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        }, function (error) {
            // Ignore unhandled error
            return $q.reject(error);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                }, function (error) {
                    // Ignore unhandled error
                    return $q.reject(error);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                }, function (error) {
                    // Ignore unhandled error
                    return $q.reject(error);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
        function loadComboBoxValues () {
            ($localStorage.salutations !== undefined) ? vm.salutations = $localStorage.salutations : ProjectService.loadSalutations($localStorage.project).then(successSalutations, error);
            ($localStorage.academictitles !== undefined) ? vm.academictitles = $localStorage.academictitles : ProjectService.loadAcademicTitles($localStorage.project).then(successAcademicTitles, error);
        }

        function error(response) {
            $log.debug('SettingsController | ERROR:', response);
        }

        function successSalutations(response) {
            vm.salutations = response.data;
            translateComboBoxValues(vm.salutations);
            $localStorage.salutations = vm.salutations;
        }

        function successAcademicTitles(response) {
            vm.academictitles = response.data;
            translateComboBoxValues(vm.academictitles);
            $localStorage.academictitles = vm.academictitles;
        }

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.translations[vm.lang];
                values.push(value);
            });
            array = values;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?project&key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService', 'ProjectInitService', '$q'];

    function ResetFinishController($stateParams, $timeout, Auth, LoginService, ProjectInitService, $q) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function () {
            angular.element('#password').focus();
        });

        function finishReset() {
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                ProjectInitService.initProject($stateParams.project).then(function () {
                    Auth.resetPasswordFinish({
                        key: $stateParams.key,
                        newPassword: vm.resetAccount.password
                    }).then(function () {
                        vm.success = 'OK';
                    }).catch(function () {
                        vm.success = null;
                        vm.error = 'ERROR';
                    });
                }, function (error) {
                    // Ignore unhandled error
                    return $q.reject(error);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', '$localStorage', 'AccountService', '$log', '$rootScope'];

    function RegisterController ($translate, $timeout, Auth, LoginService, $localStorage, AccountService, $log, $rootScope) {
        var vm = this;
        vm.showPassword = false;
        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.togglePasswordVisibility = togglePasswordVisibility;
        vm.registerAccount = {};
        vm.success = null;
        vm.registerAccount.projectID = $localStorage.project;
        vm.lang = $translate.use();


        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateComboBoxValues(vm.salutations);
        });

        loadValues();

        function loadValues() {
            AccountService.loadSalutations().then(successSalutations, error);
            AccountService.loadTitles().then(successTitles, error);
        }

        function togglePasswordVisibility(){
            vm.showPassword = !vm.showPassword;
        }

        function successSalutations(response) {
            $log.debug('RegisterController | fetching salutations:', response);
            vm.salutations = response.data;
            translateComboBoxValues(vm.salutations);
        }
        function successTitles(response) {
            $log.debug('RegisterController | fetching titles:', response);
            vm.academictitles = response.data;
            translateComboBoxValues(vm.academictitles);
        }

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.translations[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function error(response) {
            $log.debug('RegisterController | ERROR:', response);
        }

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', '$localStorage', '$q'];

    function PasswordController (Auth, Principal, $localStorage, $q) {
        var vm = this;
        vm.showPassword = false;
        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.togglePasswordVisibility = togglePasswordVisibility;


        Principal.identity().then(function(account) {
            vm.account = account;
        }, function (error) {
            // Ignore unhandled error
            return $q.reject(error);
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword || $localStorage.project === null) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function togglePasswordVisibility(){
            vm.showPassword = !vm.showPassword;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?project&key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService', 'ProjectInitService', '$q'];

    function ActivationController($stateParams, Auth, LoginService, ProjectInitService, $q) {
        var vm = this;
        vm.error = null;
        vm.success = null;
        vm.login = LoginService.open;

        ProjectInitService.initProject($stateParams.project).then(function () {
            Auth.activateAccount({key: $stateParams.key}).then(function () {
                vm.error = null;
                vm.success = 'OK';
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }, function (error) {
            // Ignore unhandled error
            return $q.reject(error);
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('AccountService', AccountService);

    AccountService.$inject = ['$http', 'API_URL', '$localStorage'];

    function AccountService ($http, API_URL, $localStorage) {
        var service = {
            loadSalutations: loadSalutations,
            loadTitles: loadTitles
        };

        return service;


        function loadSalutations() {
            return $http.get(API_URL + 'salutation', {params:{project:$localStorage.project}});
        }
        function loadTitles() {
            return $http.get(API_URL + 'academictitle', {params:{project:$localStorage.project}});
        }
    }
})();
(function(){'use strict';angular.module('exhibitorRegistrationApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/area/area.html','<div class="row page-description"><h1>{{vm.areas.title[vm.lang]}}</h1><div class="description-text">{{vm.areas.description[vm.lang]}}</div></div><div class="gs-success-alert"><jhi-alert></jhi-alert></div><div vertilize-container class="row"><div class="col-md-6 col-sm-12 col-xs-12 tile-container" ng-repeat="area in vm.areas.areas"><div vertilize class="tile" ng-click="vm.book(area.areaType)"><img class="col-sm-12 col-md-12 col-xs-12" ng-src="{{area.imageURL}}"><div class="tile-text"><h3 class="tile-title">{{area.title[vm.lang]}}</h3><div class="tile-description">{{area.description[vm.lang]}}</div></div></div></div></div>');
$templateCache.put('app/cart/cart.detail.html','<div class="panel-default"><div class="panel-heading"><h3 class="panel-title" translate="cart.headline">Panel title</h3></div><div class="panel-body cart-wrapper" ng-show="vm.cart.length"><div class="cart-headline"><h3 translate="cart.positions"></h3></div><div class="cart"><div class="cart-item overflow-hidden" ng-repeat="item in vm.cart"><div style="height:auto;line-height:1.2em;padding:10px 15px" class="col-md-8">{{(item.amount ? item.amount : 1) + \'x\'}}&nbsp;{{ item.cartPositionLabel[vm.lang] }} {{ vm.getLabelForItem(item)}} {{ item.cartPositionBookedFor }}</div><div class="col-md-2"><span class="pull-right">{{item.cartPositionPrice | currency: \'\u20AC\' }}</span></div><div class="col-md-2"><button class="btn btn-link pull-right" ng-show="item.type != \'Fee\' && item.type != \'CoExhibitorFee\'" ng-click="vm.remove(item)"><i class="fa fa-trash-o" aria-hidden="true"></i> {{ \'cart.buttons.delete\' | translate }}</button></div></div></div><div class="cart-footer"><div class="cart-price-summary overflow-hidden"><div class="col-md-offset-4 col-md-6"><hr><span translate="cart.totalprice"></span><span class="pull-right">{{ vm.cartFactory.totalPrice() | currency:\'\u20AC\' }}</span></div></div><div class="cart-button-panel overflow-hidden" ng-show="vm.areaCount > 0"><button class="btn btn-primary pull-right" ng-click="vm.goToSummary()"><span class="fa fa-credit-card"></span> <span class="small">{{\'cart.buttons.book\' | translate}}</span></button></div></div></div><div class="panel-body" ng-show="!vm.cart.length"><label translate="cart.empty">Zur Zeit befinden sich keine Artikel im Warenkorb...</label></div><div class="panel-body" ng-show="vm.areaCount < 1"><label translate="cart.noAreaBooked">Achtung, Sie m\xFCssen mindestens eine Fl\xE4che buchen um fortzufahren...</label></div></div>');
$templateCache.put('app/cart/cart.html','<div ng-click="vm.openCart()" ng-class="{\'cart-not-empty\':vm.cartFactory.totalPrice() > 0}"><span class="glyphicon glyphicon-shopping-cart"></span> <span>{{ vm.cartFactory.totalPrice() | currency :"\u20AC" }}</span></div>');
$templateCache.put('app/category/category.html','<div class="row page-description"><h1>{{vm.categories.title[vm.lang]}}</h1><div class="description-text">{{vm.categories.description[vm.lang]}}</div></div><div vertilize-container class="row" ng-show="vm.pageLoaded()"><div class="col-md-6 col-sm-12 col-xs-12 tile-container" ng-repeat="category in vm.categories.categories"><div class="tile" vertilize ng-click="vm.book(category.categoryID)"><img ng-if="category.imageURL" class="col-sm-12 col-md-12 col-xs-12" ng-src="{{category.imageURL}}"><div class="tile-text"><h3 class="tile-title">{{category.title[vm.lang]}}</h3><div class="tile-description">{{category.description[vm.lang]}}</div></div></div></div></div>');
$templateCache.put('app/download/download.html','<div ng-show="vm.loaded()" class="overflow-hidden"><h3>{{vm.headline}}</h3><p ng-bind-html="vm.text"></p><div ng-repeat="download in vm.downloads" class="row-margin-20"><a ng-if="download.paths[vm.lang] && download.labels[vm.lang]" href="{{download.paths[vm.lang]}}" class="padding-lr-15 btn-link voffset2 fa fa-lg fa-file-pdf-o" aria-hidden="true" target="_blank"><span class="padding-left-5">{{download.labels[vm.lang]}}</span></a></div><form name="form" ng-submit="vm.finishRegistration()"><button type="submit" class="btn btn-primary pull-right"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span translate="global.menu.account.logout">Sign out</span></button></form></div>');
$templateCache.put('app/home/home.html','<div class=""><jhi-alert></jhi-alert></div><div has-any-authority="AUTHORIZATION_PENDING,ESC_INACTIVE" class="panel panel-danger overflow-hidden"><div class="panel-heading bg-danger"><span translate="home.info"></span></div><div has-authority="AUTHORIZATION_PENDING" class="panel-body"><div>{{vm.pendingLabel.translations[vm.lang]}}</div></div><div has-authority="ESC_INACTIVE" class="panel-body"><div>{{vm.escInactiveLabel.translations[vm.lang]}}</div></div></div><div ng-cloak><div class="row row-margin-25"><div class="img-container col-md-4"><img class="home-image col-md-12" ng-src="{{ vm.welcomeImage }}"></div><div class="col-md-8"><h1 class="">{{ vm.welcomeHeadline }}</h1><p class="lead"></p><div ng-bind-html="vm.welcomeText"></div><p></p></div><div ng-show="vm.showLogin()"><button class="btn btn-primary pull-right glyph-button" ng-click="vm.login()"><span class="glyphicon glyphicon-log-in"></span><label translate="global.menu.account.login"></label></button></div><!--<div ng-show="vm.isLoggedIn()">--><!--<button class="btn btn-primary pull-right glyph-button" has-authority="PRE_AUTHORIZED" ng-click="vm.go(\'registration\')"><span class="glyphicon glyphicon-user"></span><label translate="home.registration"></label></button>--><!--</div>--><div has-authority="AUTHORIZED"><button class="btn btn-primary pull-right glyph-button" ng-click="vm.go(\'category\')"><span class="fa fa-shopping-bag"></span><label translate="global.menu.category"></label></button></div></div><div class="row row-margin-25" ng-show="vm.isLoggedIn()"><div ng-show="vm.isLoggedIn()"><button class="btn btn-primary pull-right glyph-button" has-authority="PRE_AUTHORIZED" ng-click="vm.go(\'area\')"><span class="fa fa-handshake"></span><label translate="home.area"></label></button></div></div><div class="row row-margin-25" ng-show="vm.isLoggedIn()"><hr><h3 translate="home.coexhibitortitle">Mitaussteller verwalten</h3><p translate="home.coexhibitordescription">In dieser \xDCbersicht k\xF6nnen Sie neue Mitaussteller hinzuf\xFCgen oder bestehende Mitaussteller verwalten.</p><div class="panel panel-default"><!-- Table --><table class="table"><thead><tr><th translate="home.company">Firma</th><th translate="home.city">Ort</th></tr></thead><tbody><tr ng-if="!vm.coExhibitors || vm.coExhibitors.length == 0"><td><div translate="home.coexhibitorEmpty">Sie haben noch keine Mitaussteller hinzugef\xFCgt...</div></td></tr><tr ng-if="vm.coExhibitors && vm.coExhibitors.length >0" valign="middle" ng-repeat="coExhibitor in vm.coExhibitors"><td style="vertical-align: middle">{{coExhibitor.company}}</td><td style="vertical-align: middle">{{coExhibitor.city}}</td><td><button class="btn btn-default pull-right" ng-click="vm.editCoexhibitor(coExhibitor.id)"><span class="glyphicon glyphicon-edit"></span><label></label></button></td><td><button has-any-authority="PRE_AUTHORIZED,AUTHORIZED,ESC_INACTIVE" class="btn btn-default pull-right" ng-click="vm.removeCoExhibitor(coExhibitor.id)"><span class="glyphicon glyphicon-trash"></span></button></td></tr></tbody></table></div><button class="btn btn-default pull-right glyph-button" has-any-authority="PRE_AUTHORIZED,AUTHORIZED,ESC_INACTIVE" ng-click="vm.newCoExhibitor()"><span class="glyphicon glyphicon-plus"></span><label translate="home.newcoexhibitor"></label></button></div></div>');
$templateCache.put('app/nomenclature/nomenclature.html','<div class=""><jhi-alert></jhi-alert></div><div><div class="row"><h2 translate="nomenclature.headline">nomenclature.headline</h2></div><div class="row"><div ng-if="vm.status === \'loading\'">Loading...</div><form ng-if="vm.status === \'loaded\'" class="form-horizontal" name="form" ng-submit="form.$valid && vm.submit()"><fieldset><legend translate="nomenclature.form.title">nomenclature.form.title</legend><div class="alert alert-info">{{\'nomenclature.text\' | translate}}</div><div><div ng-repeat="group in vm.nomenclature"><h2>{{(\'nomenclature.items.\' + group.key) | translate}}</h2><div ng-if="!group.items" class="checkbox"><span style="display: inline-block; width: 10px"></span><label><input type="checkbox" name="selected[group.key]" ng-model="vm.selected[group.key]" ng-value="group.key"> <span>{{(\'nomenclature.items.\' + group.key) | translate}}</span></label></div><div ng-if="group.items"><div ng-repeat="key in group.items" class="checkbox"><span style="display: inline-block; width: 10px"></span><label><input type="checkbox" name="selected[key]" ng-model="vm.selected[key]" ng-value="key"> <span>{{(\'nomenclature.items.\' + key) | translate}}</span></label></div></div></div></div></fieldset><button type="submit" class="btn btn-primary pull-right"><span class="fa fa-floppy-o"></span> <span class="small">{{\'nomenclature.form.submit\' | translate}}</span></button></form></div></div>');
$templateCache.put('app/orderhistory/orderhistory.html','<h3 translate="orderhistory.headline"></h3><div ng-show="vm.areas"><fieldset><legend translate="orderhistory.bookedareas"></legend><div class="overflow-hidden row-margin-10" ng-repeat="area in vm.areas">{{(area.number ? area.number + \' - \' : \'\')}} {{area.title[vm.lang]}} <span ng-repeat="option in area.bookedOptions">- {{ option[vm.lang]}} </span>{{(area.squaremeters ? \' - \' + area.squaremeters : \'\')}} {{(area.squaremeters ? (\'orderhistory.sq\'| translate) : \'\')}}</div></fieldset></div><div ng-show="vm.parts.length"><fieldset><legend translate="orderhistory.bookedparts"></legend><div class="overflow-hidden" ng-repeat="part in vm.parts">{{part.amount}}x {{part.title[vm.lang]}} - {{part.price | currency:\'\u20AC\'}} <button ng-really-message="{{ \'orderhistory.buttons.confirmdelete\' | translate }}" ng-really-click="vm.deletePart(part.id)" class="btn btn-primary pull-right btn-sm" type="button" ng-show="part.deletable"><span class="fa fa-trash"></span> <span class="small">{{\'orderhistory.buttons.delete\' | translate}}</span></button></div></fieldset></div><div class="" ng-show="!vm.parts.length"><fieldset><legend translate="orderhistory.bookedparts"></legend><label translate="orderhistory.empty">Zur Zeit befinden sich keine Artikel im Warenkorb...</label></fieldset></div>');
$templateCache.put('app/registration/registration.html','<div><div class="row"><h2 translate="registration.headline">registration.headline</h2></div><div class="row"><form class="form-horizontal" name="form" ng-submit="form.$valid && vm.register()" ng-show="vm.loaded()"><div class="row"><div class="col-md-6 pull-right"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" translate="registration.form.registrationFee"></h3></div><div class="panel-body"><div ng-show="!vm.exhibitor.coExhibitor">{{ vm.registrationFee | currency:\'\u20AC\' }}</div><div ng-show="vm.exhibitor.coExhibitor">{{ vm.registrationFeeCoExhibitor | currency:\'\u20AC\' }}</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="panel panel-warning"><div class="panel-heading"><h3 class="panel-title" translate="registration.form.legend"></h3></div><div class="panel-body"><span class="" translate="registration.form.fillOut"></span></div></div></div></div><fieldset><legend translate="registration.form.companyaddress">Firmenanschrift</legend><div class="form-group"><div class="col-sm-2 control-label"><label for="vm.exhibitor.company" class="control-label" translate="registration.form.company">company</label><label class="required-label">*</label></div><div class="col-sm-10"><input type="text" class="form-control" id="vm.exhibitor.company" required="" placeholder="{{ \'registration.form.company\' | translate}}" ng-model="vm.exhibitor.company" ng-readonly="vm.readOnly"></div></div><div class="form-group"><div class="col-sm-2 control-label"><label for="street" class="control-label" translate="registration.form.street">street</label><label class="required-label">*</label></div><div class="col-sm-10"><input type="text" class="form-control" id="street" required="" placeholder="{{ \'registration.form.street\' | translate}}" ng-model="vm.exhibitor.street" ng-readonly="vm.readOnly"></div></div><div class="form-group"><div class="col-sm-2 col-xs-12 control-label"><label for="postal" class="control-label" translate="registration.form.postalcity">postalcity</label><label class="required-label">*</label></div><div class="col-md-3 col-xs-4"><input type="text" class="form-control" id="postal" required="" placeholder="{{ \'registration.form.postal\' | translate}}" ng-model="vm.exhibitor.postalCode" ng-readonly="vm.readOnly"></div><div class="col-md-7 col-xs-8"><input type="text" class="form-control" id="city" required="" placeholder="{{ \'registration.form.city\' | translate}}" ng-model="vm.exhibitor.city" ng-readonly="vm.readOnly"></div></div><div class="form-group"><div class="col-sm-2 control-label"><label for="country" class="control-label" translate="registration.form.country">country</label><label class="required-label">*</label></div><div class="col-sm-10"><select id="country" class="form-control" ng-model="vm.exhibitor.country" required="" ng-options="country.id as country.name for country in vm.countries | orderBy:\'name\'" convert-to-number ng-disabled="vm.readOnly"><option value="">{{\'registration.noselection\' | translate}}</option></select></div></div><div class="form-group"><div class="col-sm-2 control-label"><label for="email" class="control-label" translate="registration.form.emailgeneral">email</label><label class="required-label">*</label></div><div class="col-sm-10"><input type="text" class="form-control" id="email" required="" placeholder="{{ \'registration.form.emailgeneral\' | translate}}" ng-model="vm.exhibitor.email" ng-readonly="vm.readOnly"></div></div><div class="form-group"><div class="col-sm-2 control-label"><label for="registercourt" class="control-label" translate="registration.form.registercourt">registercourt</label><label class="required-label">*</label></div><div class="col-sm-10"><select id="registercourt" class="form-control" required="" placeholder="{{ \'registration.form.registercourt\' | translate}}" ng-model="vm.exhibitor.companyRegisteredIn" ng-options="country.id as country.name for country in vm.countries | orderBy:\'name\'" convert-to-number ng-disabled="vm.readOnly"><option value="">{{\'registration.noselection\' | translate}}</option></select></div></div><div class="form-group"><div class="col-sm-2 control-label"><label for="hrbnumber" class="control-label" translate="registration.form.hrbnumber">hrbnumber</label></div><div class="col-sm-10"><input type="text" class="form-control" id="hrbnumber" placeholder="{{ \'registration.form.hrbnumber\' | translate}}" ng-model="vm.exhibitor.tradeRegisterNumber" ng-readonly="vm.readOnly"></div></div><div class="form-group"><div class="col-sm-2 control-label"><label for="vatid" class="control-label" translate="registration.form.vatid">vatid</label><label class="required-label">*</label></div><div class="col-sm-10"><input type="text" class="form-control" id="vatid" placeholder="{{ \'registration.form.vatid\' | translate}}" ng-model="vm.exhibitor.vatId" required="" ng-readonly="vm.readOnly"></div></div><div ng-if="!vm.steinexpo" class="col-sm-offset-2"><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.agreeLinkingOnHomepage" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly"> {{vm.labels[\'geoplan.linkinginfo\'][vm.lang]}}</label></div></div><div ng-if="vm.exhibitor.agreeLinkingOnHomepage" class="form-group row-margin-10"><div class="col-sm-2 control-label"><label for="homepage" class="control-label" translate="registration.form.homepage">homepage</label><label class="required-label">*</label></div><div class="col-sm-10"><input type="text" class="form-control" id="homepage" required="" placeholder="{{ \'registration.form.homepage\' | translate}}" ng-model="vm.exhibitor.website" ng-readonly="vm.readOnly"></div></div></fieldset><fieldset ng-if="vm.exhibitor.coExhibitor == 1"><legend translate="registration.form.legalrepresentatives">legal representatives</legend><div class="form-group"><label for="title" class="col-sm-2 control-label" translate="registration.form.title">title</label><div class="col-sm-10"><select class="form-control" ng-change="vm.updateAcademicTitles()" ng-model="vm.exhibitor.representativeTitle" ng-options="title.id as title.name for title in vm.academictitles | orderBy:\'name\'" convert-to-number ng-disabled="vm.readOnly"><option value="">{{\'registration.noselection\' | translate}}</option></select></div></div><div class="form-group"><label for="salutation" class="col-sm-2 control-label" translate="registration.form.salutation">salutation</label><div class="col-sm-10"><select class="form-control" ng-change="vm.updateSalutations()" ng-model="vm.exhibitor.representativeSalutation" ng-options="salutation.id as salutation.name for salutation in vm.salutations | orderBy:\'name\' " convert-to-number ng-disabled="vm.readOnly"><option value="">{{\'registration.noselection\' | translate}}</option></select></div></div><div class="form-group"><label for="firstname" class="col-sm-2 control-label" translate="registration.form.firstname">firstname</label><div class="col-sm-10"><input type="text" class="form-control" id="firstname" placeholder="{{ \'registration.form.firstname\' | translate}}" ng-model="vm.exhibitor.representativeFirstname" ng-readonly="vm.readOnly"></div></div><div class="form-group"><label for="lastname" class="col-sm-2 control-label" translate="registration.form.lastname">lastname</label><div class="col-sm-10"><input type="text" class="form-control" id="lastname" placeholder="{{ \'registration.form.lastname\' | translate}}" ng-model="vm.exhibitor.representativeLastname" ng-readonly="vm.readOnly"></div></div><div class="col-sm-offset-2"><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.representativeProprietor" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly"> {{ \'registration.form.representativeProprietor\' | translate }}</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.representativeFullyQualifiedMerchant" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly">{{ \'registration.form.representativeFullyQualifiedMerchant\' | translate }}</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.representativeGeneralParnter" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly">{{ \'registration.form.representativeGeneralParnter\' | translate }}</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.representativeManager" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly">{{ \'registration.form.representativeManager\' | translate }}</label></div></div></fieldset><fieldset><legend translate="registration.form.typeofcompany">typeofcompany</legend><div class="col-sm-offset-2"><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.representativeCompanyManufacturer" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly">{{ \'registration.form.representativeCompanyManufacturer\' | translate }}</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.representativeCompanyAssociation" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly">{{ \'registration.form.representativeCompanyAssociation\' | translate }}</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.representativeCompanyPublisher" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly">{{ \'registration.form.representativeCompanyPublisher\' | translate }}</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.representativeCompanyDealer" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly">{{ \'registration.form.representativeCompanyDealer\' | translate }}</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.representativeCompanyServiceProvider" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly">{{ \'registration.form.representativeCompanyServiceProvider\' | translate }}</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.representativeCompanyOther" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly">{{ \'registration.form.representativeCompanyOther\' | translate }}</label></div></div><div class="form-group row-margin-10" ng-if="vm.exhibitor.representativeCompanyOther"><label for="representativeCompanyOtherText" class="col-sm-2 control-label" translate="registration.form.representativeCompanyOtherText">representativeCompanyOtherText</label><div class="col-sm-10"><input type="text" class="form-control" id="representativeCompanyOtherText" placeholder="{{ \'registration.form.representativeCompanyOtherText\' | translate}}" ng-model="vm.exhibitor.representativeCompanyOtherText" ng-readonly="vm.readOnly"></div></div></fieldset><fieldset><legend translate="registration.form.memberassociations">memberassociations</legend><div class="form-group"><label for="memberassociations" class="col-sm-2 control-label" translate="registration.form.memberassociations">memberassociations</label><div class="col-sm-10"><textarea class="form-control" rows="3" id="memberassociations" ng-model="vm.exhibitor.memberOfTradeAssociations" ng-disabled="vm.readOnly"></textarea></div></div></fieldset><fieldset ng-if="vm.exhibitor.coExhibitor == 1"><legend translate="registration.form.contactperson">contactperson</legend><div class="form-group"><label for="title" class="col-sm-2 control-label" translate="registration.form.title">title</label><div class="col-sm-10"><select class="form-control" id="title" ng-model="vm.exhibitor.contactTitle" ng-options="option.id as option.name for option in vm.academictitles | orderBy:\'name\'" placeholder="{{ \'registration.form.title\' | translate}}" convert-to-number ng-disabled="vm.readOnly"><option value="">{{\'registration.noselection\' | translate}}</option></select></div></div><div class="form-group"><div class="col-sm-2 col-xs-12 control-label"><label for="salutation" class="control-label" translate="registration.form.salutation">salutation</label><label class="required-label">*</label></div><div class="col-sm-10"><select class="form-control" id="salutation" ng-model="vm.exhibitor.contactSalutation" required="" ng-options="option.id as option.name for option in vm.salutations | orderBy:\'name\'" convert-to-number ng-disabled="vm.readOnly"><option value="">{{\'registration.noselection\' | translate}}</option></select></div></div><div class="form-group"><div class="col-sm-2 col-xs-12 control-label"><label for="firstname" class="control-label" translate="registration.form.firstname">firstname</label><label class="required-label">*</label></div><div class="col-sm-10"><input type="text" class="form-control" id="firstname" required="" placeholder="{{ \'registration.form.firstname\' | translate}}" ng-model="vm.exhibitor.contactFirstname" ng-readonly="vm.readOnly"></div></div><div class="form-group"><div class="col-sm-2 col-xs-12 control-label"><label for="lastname" class="control-label" translate="registration.form.lastname">lastname</label><label class="required-label">*</label></div><div class="col-sm-10"><input type="text" class="form-control" id="lastname" required="" placeholder="{{ \'registration.form.lastname\' | translate}}" ng-model="vm.exhibitor.contactLastname" ng-readonly="vm.readOnly"></div></div><div class="form-group"><div class="col-sm-2 col-xs-12 control-label"><label for="phone" class="control-label" translate="registration.form.phone">phone</label><label class="required-label">*</label></div><div class="col-sm-10"><input type="text" class="form-control" id="phone" required="" placeholder="{{ \'registration.form.phone\' | translate}}" ng-model="vm.exhibitor.contactPhone" ng-readonly="vm.readOnly"></div></div><div class="form-group"><label for="fax" class="col-sm-2 control-label" translate="registration.form.fax">fax</label><div class="col-sm-10"><input type="text" class="form-control" id="fax" placeholder="{{ \'registration.form.fax\' | translate}}" ng-model="vm.exhibitor.contactFax" ng-readonly="vm.readOnly"></div></div><div class="form-group"><div class="col-sm-2 col-xs-12 control-label"><label for="email" class="control-label" translate="registration.form.email">email</label><label class="required-label">*</label></div><div class="col-sm-10"><input type="email" class="form-control" id="email" required="" placeholder="{{ \'registration.form.email\' | translate}}" ng-model="vm.exhibitor.contactEmail" ng-readonly="vm.readOnly"></div></div></fieldset><fieldset ng-if="vm.exhibitor.coExhibitor == 1"><legend translate="registration.form.correspondence">correspondence</legend><div class="form-group"><label for="correspondeceCompany" class="col-sm-2 control-label" translate="registration.form.correspondeceCompany">correspondeceCompany</label><div class="col-sm-10"><input type="text" class="form-control" id="correspondeceCompany" placeholder="{{ \'registration.form.correspondeceCompany\' | translate}}" ng-model="vm.exhibitor.correspondeceCompany" ng-readonly="vm.readOnly"></div></div><div class="form-group"><label for="vatid" class="col-sm-2 control-label" translate="registration.form.street">correspondeceStreet</label><div class="col-sm-10"><input type="text" class="form-control" id="vatid" placeholder="{{ \'registration.form.street\' | translate}}" ng-model="vm.exhibitor.correspondeceStreet" ng-readonly="vm.readOnly"></div></div><div class="form-group"><label for="postal" class="col-sm-2 col-xs-12 control-label" translate="registration.form.postalcity">postalcity</label><div class="col-md-3 col-xs-4"><input type="text" class="form-control" id="postal" placeholder="{{ \'registration.form.postal\' | translate}}" ng-model="vm.exhibitor.correspondecePostalCode" ng-readonly="vm.readOnly"></div><div class="col-md-7 col-xs-8"><input type="text" class="form-control" id="city" placeholder="{{ \'registration.form.city\' | translate}}" ng-model="vm.exhibitor.correspondeceCity" ng-readonly="vm.readOnly"></div></div><div class="form-group"><label for="country" class="col-sm-2 control-label" translate="registration.form.country">country</label><div class="col-sm-10"><select id="country" class="form-control" ng-model="vm.exhibitor.correspondeceCountry" ng-options="country.id as country.name for country in vm.countries | orderBy:\'name\'" convert-to-number ng-disabled="vm.readOnly"><option value="">{{\'registration.noselection\' | translate}}</option></select></div></div></fieldset><fieldset ng-if="vm.exhibitor.coExhibitor == 1"><legend translate="registration.form.mainexhibitor">main exhibitor</legend><div class="form-group"><div class="col-sm-2 col-xs-12 control-label"><label for="invoice" class="control-label control-label-for-big-text" translate="registration.form.invoice">invoice</label><label class="required-label control-label-for-big-text" ng-show="vm.exhibitor.coExhibitor == 1">*</label></div><div class="col-sm-10"><select id="invoice" class="form-control" ng-model="vm.exhibitor.invoicePaidByCoExhibitor" ng-options="option.id as option.value for option in vm.invoicePaidBy" convert-to-number ng-disabled="vm.readOnly" ng-required="vm.exhibitor.coExhibitor == 1"><option value="">{{\'registration.noselection\' | translate}}</option></select></div></div></fieldset><fieldset ng-if="vm.steinexpo"><legend translate="registration.form.entryexhibitorlist">entryexhibitorlist</legend><div class="form-group"><label class="col-md-offset-2 col-md-10" translate="registration.form.agreeEntryFairCatalogue"></label></div><div class="form-group"><label for="agreeEntryFairCatalogue" class="col-sm-2 control-label" translate="registration.form.letter">letter</label><div class="col-sm-10"><select id="agreeEntryFairCatalogue" class="form-control" ng-model="vm.exhibitor.agreeEntryFairCatalogue" ng-options=" option for option in vm.alphabet" convert-to-number ng-disabled="vm.readOnly"><option value="">{{\'registration.noselection\' | translate}}</option></select></div></div><div class="col-sm-offset-2"><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.agreeLinkingOnHomepage" value="" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly"> {{vm.labels[\'geoplan.linkinginfo\'][vm.lang]}}</label></div></div><div ng-if="vm.exhibitor.agreeLinkingOnHomepage" class="form-group row-margin-10"><div class="col-sm-2 control-label"><label for="homepage" class="control-label" translate="registration.form.homepage">homepage</label><label class="required-label">*</label></div><div class="col-sm-10"><input type="text" class="form-control" id="homepage" required="" placeholder="{{ \'registration.form.homepage\' | translate}}" ng-model="vm.exhibitor.website" ng-readonly="vm.readOnly"></div></div></fieldset><fieldset ng-if="vm.steinexpo"><legend translate="registration.form.thinkbig.headline">thinkbig</legend><div class="col-sm-offset-2"><div class="checkbox"><label><input type="checkbox" ng-model="vm.exhibitor.thinkbig" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly"> {{\'registration.form.thinkbig.label\' | translate}}</label></div></div></fieldset><fieldset ng-if="vm.steinexpo"><legend translate="registration.form.exhibitorlogo">registration.form.exhibitorlogo</legend><div class="col-sm-offset-2"><p><strong>{{\'registration.form.booklogoinfo\' | translate}}</strong></p><p><strong>{{vm.logoFeeCartLabel[vm.lang]}}: {{vm.logoFee | currency:\'\u20AC\'}}</strong></p><div class="checkbox"><label><input type="checkbox" ng-model="vm.bookLogo" ng-true-value="1" ng-false-value="0" ng-disabled="vm.readOnly || vm.logoIsPaid"> {{\'registration.form.booklogo\' | translate}}</label></div></div><div ng-if="vm.bookLogo" class="row form-group mt-4" ng-class="{\'has-error\': (form.logoUploader.$invalid || (form.logo.$invalid && (form.$submitted || form.logo.$touched)))}"><div class="col-sm-2 control-label"><label for="logoUploader">{{\'registration.form.logouploader\' | translate}}</label><label class="required-label">*</label></div><div class="col-sm-10"><div><div class="btn btn-default" ngf-select="vm.uploadLogo($file)" ngf-pattern="\'image/jpeg,image/png\'" ngf-accept="\'image/jpeg,image/png\'" ngf-max-size="5MB" id="logoUploader" name="logoUploader" ng-model="logoUploader" ng-disabled="vm.readOnly || vm.logoUploadStatus !== null"><i ng-show="vm.logoUploadStatus !== null" class="fa fa-circle-o-notch fa-spin fa-fw no-animate"></i> <span>{{\'registration.form.uploadLogo\' | translate}}</span> <span ng-show="vm.logoUploadStatus !== null" class="no-animate">({{vm.logoUploadStatus}}%)</span></div><p ng-show="form.logoUploader.$invalid" class="help-block"><span ng-show="form.logoUploader.$error.maxSize">{{\'global.form.validation.fileMaxSize\' | translate}}</span> <span ng-show="form.logoUploader.$error.pattern">{{\'global.form.validation.fileTypeImage\' | translate}}</span></p><input type="hidden" name="logo" ng-model="vm.logo" ng-required="true"><p ng-show="form.logo.$invalid && (form.$submitted || form.logo.$touched)" class="help-block"><span ng-show="form.logo.$error.required">{{\'form.required\' | translate}}</span></p></div><div ng-if="vm.logoPreviewThumbnail" class="mt-4"><img ngf-thumbnail="vm.logoPreviewThumbnail" style="max-width: 300px"></div></div></div></fieldset><button type="button" ng-click="vm.goBack()" has-any-authority="AUTHORIZATION_PENDING" class="btn btn-primary pull-right"><span class="fa fa-arrow-left"></span> <span class="small">{{\'entity.action.back\' | translate}}</span></button> <button type="submit" has-any-authority="PRE_AUTHORIZED,AUTHORIZED,ESC_INACTIVE" class="btn btn-primary pull-right"><div ng-if="!vm.coExhibitorId && vm.mainExhibitorDataSet || vm.coExhibitorId > 0"><span class="fa fa-floppy-o"></span> <span class="small">{{\'registration.form.savebutton\' | translate}}</span></div><div ng-if="!vm.coExhibitorId && !vm.mainExhibitorDataSet || vm.coExhibitorId && vm.coExhibitorId < 0"><span class="fa fa-credit-card"></span> <span class="small">{{\'cart.buttons.book\' | translate}}</span></div></button></form></div></div>');
$templateCache.put('app/summary/summary.html','<h3 translate="summary.headline"></h3><div class="row form-horizontal"><fieldset ng-if="vm.preAuthorized"><legend translate="summary.companyaddress"></legend><div class="form-group"><div class="col-md-4" translate="summary.company"></div><div class="col-md-8">{{vm.summaryExhibitor.company}}</div></div><div class="form-group"><div class="col-md-4" translate="summary.street">Firma</div><div class="col-md-8">{{vm.summaryExhibitor.street}}</div></div><div class="form-group"><div class="col-md-4" translate="summary.postal">Firma</div><div class="col-md-8">{{vm.summaryExhibitor.postalCode}}</div></div><div class="form-group"><div class="col-md-4" translate="summary.city">Firma</div><div class="col-md-8">{{vm.summaryExhibitor.city}}</div></div><div class="form-group"><div class="col-md-4" translate="summary.country">Firma</div><div class="col-md-8">{{vm.country}}</div></div><div class="form-group"><div class="col-md-4" translate="summary.email">Firma</div><div class="col-md-8">{{vm.summaryExhibitor.email}}</div></div><div class="form-group"><div class="col-md-4" translate="summary.homepage">Firma</div><div class="col-md-8">{{vm.summaryExhibitor.website}}</div></div><div class="form-group"><div class="col-md-4" translate="summary.registercourt">Firma</div><div class="col-md-8">{{vm.companyRegisteredIn}}</div></div><div class="form-group"><div class="col-md-4" translate="summary.hrbnumber">Firma</div><div class="col-md-8">{{vm.summaryExhibitor.tradeRegisterNumber}}</div></div><div class="form-group"><div class="col-md-4" translate="summary.vatid">Firma</div><div class="col-md-8">{{vm.summaryExhibitor.vatId}}</div></div></fieldset><fieldset><legend translate="summary.positions"></legend><div class="cart"><div class="cart-item overflow-hidden" ng-repeat="item in vm.cart"><div class="row"><div class="col-md-8">{{(item.amount ? item.amount : 1) + \'x\'}}&nbsp;{{ item.cartPositionLabel[vm.lang] }} {{ vm.getLabelForItem(item)}} {{ item.cartPositionBookedFor }}</div><div class="col-md-4"><span class="pull-right">{{item.cartPositionPrice | currency: \'\u20AC\' }}</span></div></div></div></div><hr><span translate="summary.totalprice"></span><span class="pull-right">{{ vm.totalPrice | currency:\'\u20AC\' }}</span></fieldset><form name="form" ng-submit="form.$valid && vm.bookCart()"><fieldset ng-show="vm.labels.gtcAccept" ng-if="vm.preAuthorized"><legend ng-if="vm.labels.gtcTitle">{{ vm.labels.gtcTitle[vm.lang]}}</legend><span ng-bind-html="vm.gtcDescription"></span><hr><div class="checkbox"><label><input type="checkbox" ng-required="vm.labels.gtcAccept" ng-true-value="1" ng-false-value="0" value=""> {{ \'summary.acceptGTC\' | translate }}</label></div><div ng-repeat="document in vm.documents"><div class="row-margin-5 overflow-hidden" ng-if="document.type == \'GTC\' && document.labels[vm.lang] && document.paths[vm.lang]"><a href="{{document.paths[vm.lang]}}" class="btn-link voffset2 fa fa-lg fa-file-pdf-o" aria-hidden="true" target="_blank"><span class="padding-left-5">{{document.labels[vm.lang]}}</span></a></div></div></fieldset><fieldset ng-show="vm.labels.privacyAccept" ng-if="vm.preAuthorized"><legend ng-if="vm.labels.privacyTitle">{{vm.labels.privacyTitle[vm.lang]}}</legend><span ng-bind-html="vm.privacyDescription"></span><hr><div class="checkbox"><label><input type="checkbox" ng-required="vm.labels.privacyAccept" ng-true-value="1" ng-false-value="0" value=""> {{ \'summary.acceptPrivacy\' | translate }}</label></div><div ng-repeat="document in vm.documents"><div class="row-margin-5 overflow-hidden" ng-if="document.type == \'PRIVACY\' && document.labels[vm.lang] && document.paths[vm.lang]"><a href="{{document.paths[vm.lang]}}" class="btn-link voffset2 fa fa-lg fa-file-pdf-o" aria-hidden="true" target="_blank"><span class="padding-left-5">{{document.labels[vm.lang]}}</span></a></div></div></fieldset><fieldset ng-show="vm.labels.additionalPrivacyAccept" ng-if="vm.preAuthorized"><legend ng-if="vm.labels.additionalPrivacyTitle">{{vm.labels.additionalPrivacyTitle[vm.lang]}}</legend><span ng-bind-html="vm.additionalPrivacyDescription"></span><hr><div class="checkbox"><label><input type="checkbox" ng-required="vm.labels.additionalPrivacyAccept" ng-true-value="1" ng-false-value="0" value=""> {{ \'summary.acceptPrivacy\' | translate }}</label></div><div ng-repeat="document in vm.documents"><div class="row-margin-5 overflow-hidden" ng-if="document.type == \'PRIVACY\' && document.labels[vm.lang] && document.paths[vm.lang]"><a href="{{document.paths[vm.lang]}}" class="btn-link voffset2 fa fa-lg fa-file-pdf-o" aria-hidden="true" target="_blank"><span class="padding-left-5">{{document.labels[vm.lang]}}</span></a></div></div></fieldset><button class="btn btn-primary pull-left" type="button" ng-click="vm.back()"><span class="fa fa-arrow-left"></span> <span class="small">{{\'summary.buttons.back\' | translate}}</span></button> <button class="btn btn-primary pull-right" type="submit"><span class="fa fa-credit-card"></span> <span class="small">{{\'summary.buttons.book\' | translate}}</span></button></form></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" translate="activate.messages.success" translate-compile>Your user has been activated. Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="{{vm.showPassword ? \'text\': \'password\'}}" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required> <button type="button" ng-click="vm.togglePasswordVisibility()" class="glyphicon glyphicon-eye-close"></button><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="{{vm.showPassword ? \'text\': \'password\'}}" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required> <button type="button" ng-click="vm.togglePasswordVisibility()" class="glyphicon glyphicon-eye-close"></button><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><!-- Salutation --><div class="form-group"><label for="salutation" class="control-label" translate="global.form.salutation">salutation</label><label class="required-label">*</label><div class=""><select class="form-control" id="salutation" ng-model="vm.registerAccount.salutation" ng-options="salutation.id as salutation.name for salutation in vm.salutations | orderBy:\'name\' " convert-to-number required><option value="">{{\'global.form.salutation.placeholder\' | translate}}</option></select></div><div ng-show="form.salutation.$dirty && form.salutation.$invalid"><p class="help-block" ng-show="form.salutation.$error.required" translate="global.messages.validate.salutation.required">salutation is required.</p></div></div><!-- Title --><div class="form-group"><label for="title" class="control-label" translate="global.form.title">title</label><div class=""><select class="form-control" id="title" ng-model="vm.registerAccount.title" ng-options="title.id as title.name for title in vm.academictitles | orderBy:\'name\' " convert-to-number><option value="">{{\'global.form.title.placeholder\' | translate}}</option></select></div></div><!-- Firstname --><div class="form-group"><label class="control-label" for="firstname" translate="global.form.firstname">Firstname</label><label class="required-label">*</label><input type="text" class="form-control" id="firstname" name="firstname" placeholder="{{\'global.form.firstname.placeholder\' | translate}}" ng-model="vm.registerAccount.firstName" required><div ng-show="form.firstname.$dirty && form.firstname.$invalid"><p class="help-block" ng-show="form.firstname.$error.required" translate="global.messages.validate.firstname.required">Firstname is required.</p></div></div><!-- Lastname --><div class="form-group"><label class="control-label" for="lastname" translate="global.form.lastname">Lastname</label><label class="required-label">*</label><input type="text" class="form-control" id="lastname" name="lastname" placeholder="{{\'global.form.lastname.placeholder\' | translate}}" ng-model="vm.registerAccount.lastName" required><div ng-show="form.lastname.$dirty && form.lastname.$invalid"><p class="help-block" ng-show="form.lastname.$error.required" translate="global.messages.validate.lastname.required">Lastname is required.</p></div></div><!-- Company --><div class="form-group"><label class="control-label" for="company" translate="global.form.company">Company</label><label class="required-label">*</label><input type="text" class="form-control" id="company" name="company" placeholder="{{\'global.form.company.placeholder\' | translate}}" ng-model="vm.registerAccount.company" required><div ng-show="form.company.$dirty && form.company.$invalid"><p class="help-block" ng-show="form.company.$error.required" translate="global.messages.validate.company.required">Company is required.</p></div></div><!-- Phone --><div class="form-group"><label class="control-label" for="phone" translate="global.form.phone">Phone</label><label class="required-label">*</label><input type="text" class="form-control" id="phone" name="phone" placeholder="{{\'global.form.phone.placeholder\' | translate}}" ng-model="vm.registerAccount.phone" required><div ng-show="form.phone.$dirty && form.phone.$invalid"><p class="help-block" ng-show="form.phone.$error.required" translate="global.messages.validate.phone.required">Phone is required.</p></div></div><!-- Fax --><div class="form-group"><label class="control-label" for="fax" translate="global.form.fax">Fax</label><input type="text" class="form-control" id="fax" name="fax" placeholder="{{\'global.form.fax.placeholder\' | translate}}" ng-model="vm.registerAccount.fax"></div><!-- Username--><div class="form-group"><label class="control-label" for="login" translate="global.form.username">Username</label><label class="required-label">*</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><!-- Email--><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label><label class="required-label">*</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><!-- password--><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><label class="required-label">*</label><input type="{{vm.showPassword ? \'text\': \'password\'}}" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required> <button type="button" ng-click="vm.togglePasswordVisibility()" class="glyphicon glyphicon-eye-close"></button><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><!-- password confirmation--><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><label class="required-label">*</label><input type="{{vm.showPassword ? \'text\': \'password\'}}" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required> <button type="button" ng-click="vm.togglePasswordVisibility()" class="glyphicon glyphicon-eye-close"></button><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><input type="hidden" ng-model="vm.registerAccount.projectID"> <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="register.form.button">Register</button></form></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="settings.messages.success"><strong>Settings saved!</strong></div><div class="alert alert-danger" ng-show="vm.errorEmailExists" translate="settings.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.error" translate="settings.messages.error.fail"><strong>An error has occurred!</strong> Settings could not be saved.</div><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label for="title" translate="registration.form.title">title</label><select id="title" name="title" class="form-control" ng-model="vm.settingsAccount.title" placeholder="{{ \'registration.form.title\' | translate}}" convert-to-number ng-options="option.id as option.name for option in vm.academictitles | orderBy:\'name\'"><option value="">{{\'registration.noselection\' | translate}}</option></select></div><div class="form-group"><label for="salutation" translate="registration.form.salutation">title</label><select id="salutation" name="salutation" class="form-control" required ng-model="vm.settingsAccount.salutation" placeholder="{{ \'registration.form.salutation\' | translate}}" convert-to-number ng-options="option.id as option.name for option in vm.salutations | orderBy:\'name\'"><option value="">{{\'registration.noselection\' | translate}}</option></select></div><div class="form-group"><label class="control-label" for="firstName" translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="phone" translate="registration.form.phone">phone</label><input type="text" class="form-control" id="phone" name="phone" placeholder="{{ \'registration.form.phone\' | translate}}" ng-model="vm.settingsAccount.phone" ng-minlength="1" ng-maxlength="50" required maxlength="50"></div><div class="form-group"><label class="control-label" for="fax" translate="registration.form.fax">phone</label><input type="text" class="form-control" id="fax" name="fax" placeholder="{{ \'registration.form.fax\' | translate}}" ng-model="vm.settingsAccount.fax" ng-minlength="1" ng-maxlength="50" maxlength="50"></div><div class="form-group"><label for="langKey" translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 translate="configuration.title">Configuration</h2><span translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span translate="configuration.table.prefix">Prefix</span></th><th translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" translate="health.table.service">Service Name</th><th class="col-md-2 text-center" translate="health.table.status">Status</th><th class="col-md-2 text-center" translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="health.details.name">Name</th><th class="col-md-6 text-left" translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 translate="logs.title">Logs</h2><p translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="metrics.refresh.button">Refresh</span></button></p><h3 translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b translate="metrics.jvm.memory.title">Memory</b><p><span translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" translate="metrics.updating">Updating...</div><h3 translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-maxlength="50"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" ng-model="vm.user.activated"> <span translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management_new"><span class="glyphicon glyphicon-flash"></span> <span translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th translate="userManagement.login">Login</th><th translate="userManagement.email">Email</th><th></th><th translate="userManagement.langKey">Lang Key</th><th translate="userManagement.profiles">Profiles</th><th translate="userManagement.createdDate">Created Date</th><th translate="userManagement.lastModifiedBy">Last Modified By</th><th translate="userManagement.lastModifiedDate">Last Modified Date</th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" translate="userManagement.deactivated" style="cursor: pointer">Desactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management_edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management_delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadAll()"></uib-pagination></div></div>');
$templateCache.put('app/area/joint-stand/joint-stand.html','<div class="row" ng-show="vm.pageLoaded()"><form class="form-horizontal" name="form" ng-submit="form.$valid && vm.bookArea()"><!-- INFO --><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-md-8"><p>{{vm.labels[\'joint.info1\'][vm.lang]}}</p><p ng-bind-html="vm.trustHtml(vm.labels[\'joint.info2\'][vm.lang])"></p></div><div class="col-md-4"><img ng-src="{{vm.area.imageURL}}" style="max-width: 100%"></div></div></div></div><!-- booking options --><div class="row"><div class="col-md-8"><div class="form-group"><div class="col-md-3"><label translate="jointstand.type"></label><label class="required-label">*</label></div><div class="col-md-6 col-md-offset-1"><select class="form-control" ng-model="vm.jointStand.price" ng-options="price as price.name for price in vm.prices.prices | orderBy:\'name\'" required="" convert-to-number><option value="">{{\'jointstand.noselection\' | translate}}</option></select></div></div></div><!-- PRICES --><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" translate="jointstand.prices"></h3></div><div class="panel-body"><div class="row" ng-repeat="price in vm.prices.prices"><div class="col-xs-6 text-left">{{price.title[vm.lang]}}</div><div class="col-xs-6 text-right">{{ price.price | currency:\'\u20AC\'}}</div></div></div></div><p>{{vm.labels[\'jointstand.registrationfee\'][vm.lang]}}</p></div></div><div><button class="btn btn-primary" type="button" ng-click="vm.goBack()"><span class="fa fa-arrow-left"></span> <span class="small">{{\'jointstand.form.backButton\' | translate}}</span></button> <button type="submit" class="btn btn-primary pull-right"><span class="glyphicon glyphicon-shopping-cart"></span> <span class="small">{{\'jointstand.form.bookButton\' | translate}}</span></button></div></form></div>');
$templateCache.put('app/area/openspace/openspace.html','<div class="row" ng-show="vm.pageLoaded()"><form class="form-horizontal" name="form" ng-submit="form.$valid && vm.bookArea()"><!-- INFO --><div class="panel panel-default"><div class="panel-body"><p>{{vm.labels[\'openspace.info2\'][vm.lang]}}</p><p>{{vm.labels[\'openspace.registrationfee\'][vm.lang]}}</p></div></div><!-- booking options --><div class="row"><div class="col-md-8"><div class="form-group"><div class="col-md-2"><label translate="openspace.type"></label><label class="required-label">*</label></div><div class="col-md-8 col-md-offset-1"><select class="form-control" ng-model="vm.openSpace.bookingoption" ng-options="bookingoption as bookingoption.name for bookingoption in vm.bookingoptions | orderBy:\'name\'" required="" convert-to-number ng-change="vm.showPrices()"><option value="">{{ \'openspace.noselection\' | translate }}</option></select></div></div><div class="form-group" ng-show="vm.openSpace.bookingoption"><div class="col-md-8 col-md-offset-3"><div class="col-md-6" ng-if="vm.openSpace.bookingoption.imageURL"><img src="{{vm.openSpace.bookingoption.imageURL}}" class="col-md-12"></div><div class="col-md-6"><p>{{vm.openSpace.bookingoption.description[vm.lang]}}</p></div></div></div></div><div class="col-md-4" ng-show="vm.openSpace.bookingoption"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" translate="openspace.inclusiv"></h3></div><div class="panel-body"><table class="w-100 table table-condensed"><thead><th ng-show="vm.openSpace.bookingoption.powerUnit == \'KILOWATT\'">{{\'openspace.power\' | translate}}</th><th ng-show="vm.openSpace.bookingoption.powerUnit == \'TONS\'">{{\'openspace.weight\' | translate}}</th><th ng-show="vm.openSpace.bookingoption.powerUnit == \'KILOWATT\'">{{\'openspace.powerPrice\' | translate}}</th><th ng-show="vm.openSpace.bookingoption.powerUnit == \'TONS\'">{{\'openspace.weightPrice\' | translate}}</th><th class="text-right">{{\'openspace.areaincluded\' | translate}}</th></thead><tbody><tr ng-repeat="price in vm.priceTable"><td>{{ price.name }}</td><td>{{ price.price | currency:\'\u20AC\' }}</td><td class="text-right">{{ price.smIncluded }} m<sup>2</sup></td></tr></tbody></table></div></div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" translate="openspace.pricesAdditionalSquareMeters"></h3></div><div class="panel-body"><div ng-repeat="price in vm.prices.prices">{{price.title[vm.lang]}} {{price.price | currency:\'\u20AC\'}}</div></div></div></div></div><div class="form-group" ng-show="vm.openSpace.bookingoption"><div class="col-md-2" ng-show="vm.openSpace.bookingoption.powerUnit == \'KILOWATT\'"><label>{{\'openspace.power\' | translate}}</label><label class="required-label">*</label></div><div class="col-md-2" ng-show="vm.openSpace.bookingoption.powerUnit == \'TONS\'"><label>{{\'openspace.weight\' | translate}}</label><label class="required-label">*</label></div><div class="col-md-10"><input ng-show="vm.openSpace.bookingoption.powerUnit == \'KILOWATT\'" type="number" min="1" class="form-control" placeholder="{{\'openspace.power\' | translate}}" ng-model="vm.openSpace.powerAmount" required=""> <input ng-show="vm.openSpace.bookingoption.powerUnit == \'TONS\'" type="number" min="1" class="form-control" placeholder="{{\'openspace.weight\' | translate}}" ng-model="vm.openSpace.powerAmount" required=""></div></div><div class="form-group"><div class="col-md-2"><label translate="openspace.additionalSquareMeters"></label></div><div class="col-md-10"><input type="number" step="0.1" class="form-control" placeholder="{{\'openspace.additionalSquareMeters\' | translate}}" ng-model="vm.openSpace.additionalSquareMeters"></div></div><div><div class="form-group"><label for="weexhibit" class="col-sm-2" translate="openspace.weexhibit"></label><div class="col-sm-10"><textarea class="form-control" rows="3" id="weexhibit" ng-model="vm.openSpace.vehicleDescription"></textarea></div></div><div class="form-group"><label for="suggestions" class="col-sm-2" translate="openspace.suggestions"></label><div class="col-sm-10"><textarea class="form-control" rows="3" id="suggestions" ng-model="vm.openSpace.suggestions"></textarea></div></div></div><div><button class="btn btn-primary" type="button" ng-click="vm.goBack()"><span class="fa fa-arrow-left"></span> <span class="small">{{\'openspace.form.backButton\' | translate}}</span></button> <button type="submit" class="btn btn-primary pull-right"><span class="glyphicon glyphicon-shopping-cart"></span> <span class="small">{{\'openspace.form.bookButton\' | translate}}</span></button></div></form></div>');
$templateCache.put('app/area/outdoor/outdoor.html','<div class="row" ng-show="vm.pageLoaded()"><form class="form-group form-horizontal" name="form" ng-submit="form.$valid && vm.bookArea()"><div class="panel panel-default"><div class="panel-body"><p>{{vm.labels[\'outdoor.areainfo\'][vm.lang]}}</p></div></div><div class="row"><!-- AREA CALCULATION --><div class="col-md-6"><div class="form-group"><div class="col-md-3"><label translate="outdoor.demo.length"></label><label class="required-label">*</label></div><div class="col-md-6 col-md-offset-1"><input class="form-control" type="number" step="0.1" min="1" ng-model="vm.outdoorArea.length" required="" ng-change="vm.calc()"></div></div><div class="form-group"><div class="col-md-3"><label translate="outdoor.demo.width"></label><label class="required-label">*</label></div><div class="col-md-6 col-md-offset-1"><input class="form-control" type="number" step="0.1" min="1" ng-model="vm.outdoorArea.width" required="" ng-change="vm.calc()"></div></div><div class="form-group"><div class="col-md-3"><label translate="outdoor.demo.totalsqauremeters"></label></div><div class="col-md-6 col-md-offset-1"><input class="form-control" type="text" readonly="readonly" ng-model="vm.outdoorArea.squaremeters"></div></div></div><!-- PRICES --><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" translate="outdoor.demo.prices"></h3></div><div class="panel-body"><p ng-repeat="price in vm.prices.prices">{{ price.title[vm.lang] }} {{ price.price | currency:\'\u20AC\' }}</p></div></div><p>{{vm.labels[\'outdoor.registrationfee\'][vm.lang]}}</p><p>{{vm.labels[\'outdoor.calcexample\'][vm.lang]}}</p></div></div><!-- Radio button toggle --><div class="row-margin-15"><div class="radio-inline"><label><input type="radio" name="optionsRadios" id="noowncontainer" value="noowncontainer" ng-model="vm.outdoorArea.noowntent" ng-checked="vm.toggleOwnContainer" ng-click="vm.toggle()"> {{ \'outdoor.demo.noowncontainer\' | translate }}</label></div><div class="radio-inline"><label><input type="radio" name="optionsRadios" id="owncontainer" value="owncontainer" ng-model="vm.outdoorArea.owntent" ng-checked="!vm.toggleOwnContainer" ng-click="vm.toggle()"> {{ \'outdoor.demo.owncontainer\' | translate }}</label></div></div><!-- No own container --><div class="row-margin-15" ng-show="vm.toggleOwnContainer"><div><label translate="outdoor.demo.requireowncontainer"></label></div><div><div class="checkbox"><label><input type="checkbox" ng-model="vm.outdoorArea.requestedTentOffer" ng-true-value="1" ng-false-value="0" value=""> {{ \'outdoor.demo.tent\' | translate }}</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.outdoorArea.requestedContainerOffer" ng-true-value="1" ng-false-value="0" value=""> {{ \'outdoor.demo.container\' | translate }}</label></div></div><div class="row row-margin-10"><div class="col-md-2"><label translate="outdoor.demo.length"></label></div><div class="col-md-2"><input type="number" class="form-control" step="0.1" ng-model="vm.outdoorArea.containerLength"></div><div class="col-md-2"><label translate="outdoor.demo.width"></label></div><div class="col-md-2"><input type="number" class="form-control" step="0.1" ng-model="vm.outdoorArea.containerWidth"></div></div></div><!-- own container --><div class="row row-margin-15" ng-show="!vm.toggleOwnContainer"><div><label translate="outdoor.demo.owncontainer"></label></div><div><div class="row-margin-10"><div class="col-md-2"><label translate="outdoor.demo.length"></label></div><div class="col-md-2"><input type="number" class="form-control" step="0.1" ng-model="vm.outdoorArea.containerLength"></div><div class="col-md-2"><label translate="outdoor.demo.width"></label></div><div class="col-md-2"><input type="number" class="form-control" step="0.1" ng-model="vm.outdoorArea.containerWidth"></div></div></div></div><!-- Textareas --><div><div class="form-group"><label for="weexhibit" class="col-sm-2" translate="outdoor.demo.weexhibit"></label><div class="col-sm-10"><textarea class="form-control" rows="3" id="weexhibit" ng-model="vm.outdoorArea.vehicleDescription"></textarea></div></div><div class="form-group"><label for="suggestions" class="col-sm-2" translate="outdoor.demo.suggestions"></label><div class="col-sm-10"><textarea class="form-control" rows="3" id="suggestions" ng-model="vm.outdoorArea.suggestions"></textarea></div></div></div><div class=""><button class="btn btn-primary" type="button" ng-click="vm.goBack()"><span class="fa fa-arrow-left"></span> <span class="small">{{\'outdoor.back\' | translate}}</span></button> <button type="submit" class="btn btn-primary pull-right"><span class="glyphicon glyphicon-shopping-cart"></span> <span class="small">{{\'outdoor.continue\' | translate}}</span></button></div></form></div>');
$templateCache.put('app/area/outdoorstatic/outdoorstatic.html','<div class="row" ng-show="vm.pageLoaded()"><form name="form" class="form-group form-horizontal" ng-submit="form.$valid && vm.bookArea()"><div class="panel panel-default"><div class="panel-body"><p>{{vm.labels[\'outdoorstatic.info1\'][vm.lang]}}</p></div></div><div class="row"><!-- AREA CALCULATION --><div class="col-md-6"><div class="form-group"><div class="col-md-3"><label translate="outdoorstatic.demo.length"></label><label class="required-label">*</label></div><div class="col-md-6 col-md-offset-1"><input class="form-control" type="number" step="0.1" name="length" min="1" ng-model="vm.outdoorAreaStatic.length" required="" ng-change="vm.calc()"></div></div><div class="form-group"><div class="col-md-3"><label translate="outdoorstatic.demo.width"></label><label class="required-label">*</label></div><div class="col-md-6 col-md-offset-1"><input class="form-control" step="0.1" type="number" name="width" min="1" ng-model="vm.outdoorAreaStatic.width" required="" ng-change="vm.calc()"></div></div><div class="form-group"><div class="col-md-3"><label translate="outdoorstatic.demo.totalsquaremeters"></label></div><div class="col-md-6 col-md-offset-1"><input class="form-control" type="text" readonly="readonly" ng-model="vm.outdoorAreaStatic.squaremeters"></div></div></div><!-- PRICES --><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" translate="outdoorstatic.demo.prices"></h3></div><div class="panel-body"><p ng-repeat="price in vm.prices.prices">{{ price.title[vm.lang] }} {{ price.price | currency:\'\u20AC\' }}</p></div></div><p>{{vm.labels[\'outdoorstatic.registrationfee\'][vm.lang]}}</p><p>{{vm.labels[\'outdoorstatic.calcexample\'][vm.lang]}}</p></div></div><!-- Radio button toggle --><div class="row-margin-15"><div class="radio-inline"><label><input type="radio" name="optionsRadios" id="noowncontainer" value="noowncontainer" ng-model="vm.outdoorAreaStatic.noowntent" ng-checked="vm.toggleOwnContainer" ng-click="vm.toggle()"> {{ \'outdoorstatic.demo.noowncontainer\' | translate }}</label></div><div class="radio-inline"><label><input type="radio" name="optionsRadios" id="owncontainer" value="owncontainer" ng-model="vm.outdoorAreaStatic.owntent" ng-checked="!vm.toggleOwnContainer" ng-click="vm.toggle()"> {{ \'outdoorstatic.demo.owncontainer\' | translate }}</label></div></div><!-- No own container --><div class="row-margin-15" ng-show="vm.toggleOwnContainer"><div><label translate="outdoorstatic.demo.requireowncontainer"></label></div><div><div class="checkbox"><label><input type="checkbox" ng-model="vm.outdoorAreaStatic.requestedTentOffer" ng-true-value="1" ng-false-value="0" value=""> {{ \'outdoorstatic.demo.tent\' | translate }}</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.outdoorAreaStatic.requestedContainerOffer" ng-true-value="1" ng-false-value="0" value=""> {{ \'outdoorstatic.demo.container\' | translate }}</label></div></div><div class="row row-margin-10"><div class="col-md-2"><label translate="outdoorstatic.demo.length"></label></div><div class="col-md-2"><input type="number" class="form-control" step="0.1" ng-model="vm.outdoorAreaStatic.containerLength"></div><div class="col-md-2"><label translate="outdoorstatic.demo.width"></label></div><div class="col-md-2"><input type="number" class="form-control" step="0.1" ng-model="vm.outdoorAreaStatic.containerWidth"></div></div></div><!-- own container --><div class="row row-margin-15" ng-show="!vm.toggleOwnContainer"><div><label translate="outdoorstatic.demo.owncontainer"></label></div><div><div class="row-margin-10"><div class="col-md-2"><label translate="outdoorstatic.demo.length"></label></div><div class="col-md-2"><input type="number" class="form-control" step="0.1" ng-model="vm.outdoorAreaStatic.containerLength"></div><div class="col-md-2"><label translate="outdoorstatic.demo.width"></label></div><div class="col-md-2"><input type="number" class="form-control" step="0.1" ng-model="vm.outdoorAreaStatic.containerWidth"></div></div></div></div><!-- Textareas --><div><div class="form-group"><label for="weexhibit" class="col-sm-2" translate="outdoorstatic.demo.weexhibit"></label><div class="col-sm-10"><textarea class="form-control" rows="3" id="weexhibit" ng-model="vm.outdoorAreaStatic.weexhibit"></textarea></div></div><div class="form-group"><label for="suggestions" class="col-sm-2" translate="outdoorstatic.demo.suggestions"></label><div class="col-sm-10"><textarea class="form-control" rows="3" id="suggestions" ng-model="vm.outdoorAreaStatic.suggestions"></textarea></div></div></div><div class=""><button class="btn btn-primary" type="button" ng-click="vm.goBack()"><span class="fa fa-arrow-left"></span> <span class="small">{{\'outdoorstatic.back\' | translate}}</span></button> <button type="submit" class="btn btn-primary pull-right"><span class="glyphicon glyphicon-shopping-cart"></span> <span class="small">{{\'outdoorstatic.continue\' | translate}}</span></button></div></form></div>');
$templateCache.put('app/area/pavillion/pavillion.detail.html','<div class="modal-header"><h4 class="modal-title">{{vm.detail.title[vm.lang]}}</h4></div><div class="modal-body"><div class="row"><div class="col-md-10 col-md-offset-1 row-margin-5"><label>{{vm.detail.description[vm.lang]}}</label></div><div class="col-md-10 col-md-offset-1 row-margin-15"><img ng-src="{{vm.detail.imageURL}}"></div><div class="col-md-10 col-md-offset-1 row-margin-15" ng-show="vm.detail.parts"><label translate="pavillion.detail.parts" class="row-margin-15">Ausstattung:</label><ul><li ng-repeat="part in vm.detail.parts">{{part[vm.lang]}}</li></ul></div></div></div>');
$templateCache.put('app/area/pavillion/pavillion.html','<div class="row" ng-show="vm.pageLoaded()"><form class="form-group form-horizontal" name="form" ng-submit="form.$valid && vm.bookArea()"><!-- INFO --><div class="panel panel-default"><div class="panel-body"><p>{{vm.labels[\'pavillon.info1\'][vm.lang]}}</p></div></div><div class="row"><!-- AREA CALCULATION --><div class="col-md-6"><div class="form-group"><div class="col-md-3"><label translate="pavillion.type"></label><label class="required-label">*</label></div><div class="col-md-6 col-md-offset-1"><select class="form-control" ng-model="vm.pavillion.price" ng-options="price as price.name for price in vm.prices.prices| orderBy:\'name\'" required="" convert-to-number></select></div></div><div class="form-group"><div class="col-md-3"><label translate="pavillion.length"></label><label class="required-label">*</label></div><div class="col-md-6 col-md-offset-1"><input class="form-control" type="number" step="0.1" min="1" ng-model="vm.pavillion.length" required="" ng-change="vm.calc()"></div></div><div class="form-group"><div class="col-md-3"><label translate="pavillion.width"></label><label class="required-label">*</label></div><div class="col-md-6 col-md-offset-1"><input class="form-control" type="number" step="0.1" min="1" ng-model="vm.pavillion.width" required="" ng-change="vm.calc()"></div></div><div class="form-group"><div class="col-md-3"><label translate="pavillion.totalsquaremeters"></label></div><div class="col-md-6 col-md-offset-1"><input class="form-control" type="text" readonly="readonly" ng-model="vm.pavillion.squaremeters"></div></div></div><!-- PRICES --><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" translate="pavillion.prices"></h3></div><div class="panel-body"><p ng-repeat="price in vm.prices.prices">{{ price.title[vm.lang] }} {{ price.price | currency:\'\u20AC\' }}</p></div></div><p>{{vm.labels[\'pavillon.registrationfee\'][vm.lang]}}</p></div></div><!-- BOOKING OPTIONS --><div class="form-group"><div class="checkbox col-md-offset-2 col-md-10"><label><input type="checkbox" ng-true-value="1" ng-true-value="0" ng-model="vm.pavillion.requestedStandSystemOffer">{{ \'pavillion.requestedStandSystemOffer\' | translate }}</label></div><div class="checkbox col-md-offset-2 col-md-10"><label><input type="checkbox" ng-true-value="1" ng-true-value="0" ng-model="vm.pavillion.ownstand" ng-click="vm.resetPackage()">{{ \'pavillion.wehaveownstand\' | translate }}</label></div></div><div uib-collapse="vm.pavillion.ownstand"><div class="form-group row"><div class="col-md-2"><label translate="pavillion.packages"></label></div><div class="col-md-10"><select class="form-control" ng-model="vm.pavillion.package" ng-change="vm.packageChanged()" convert-to-number ng-options="bookingoption as bookingoption.name for bookingoption in vm.bookingoptions | orderBy:\'name\'"><option translate="pavillion.noselection" value=""></option></select></div></div><div class="form-group"><div class="col-md-offset-2 col-md-4"><img src="{{vm.pavillion.package.imageURL}}" style="max-width: 100%"></div><div class="col-md-4"><p>{{vm.pavillion.package.description[vm.lang]}}</p></div><div class="col-md-2" ng-show="vm.pavillion.package"><button type="button" class="btn btn-warning pull-right" ng-click="vm.packageInfo()"><span class="fa fa-info-circle fa-lg fa-fw"></span><span>{{ \'\' | translate }}</span></button></div></div><!-- BOOKING OPTION COLORS --><div class="panel panel-warning col-md-offset-2" ng-show="vm.pavillion.package.availableColors.length > 0"><p class="panel-heading" translate="pavillion.chooseColor"></p><div class="panel-body"><div class="form-group padding-lr-15" ng-repeat="colorOption in vm.pavillion.package.availableColors"><div class="col-md-4"><p>{{colorOption.title[vm.lang]}}</p></div><select class="form-control col-md-8" ng-model="vm.pavillion.colors[colorOption.partID]" ng-options="color.id as color.name for color in colorOption.colors| orderBy:\'name\'" convert-to-number></select></div></div></div><!-- BOOKING OPTION COLORS END --></div><!-- BOOKING OPTIONS END--><div class="row row-margin-15 form-group"><div class="col-md-2"><label translate="pavillion.maxWeightPerSq">gr\xF6\xDFte belastung....</label></div><div class="col-md-10"><input class="form-control" ng-model="vm.pavillion.maxWeightPerSq"></div></div><div class="row row-margin-15 form-group"><div class="col-md-2"><label translate="pavillion.heaviestObject">Schwerster Gegenstand</label></div><div class="col-md-10"><input class="form-control" ng-model="vm.pavillion.heaviestObject" placeholder="Art"></div></div><div><div class="form-group"><label for="weexhibit" class="col-sm-2" translate="pavillion.weexhibit"></label><div class="col-sm-10"><textarea class="form-control" rows="3" id="weexhibit" ng-model="vm.pavillion.vehicleDescription"></textarea></div></div><div class="form-group"><label for="suggestions" class="col-sm-2" translate="pavillion.suggestions"></label><div class="col-sm-10"><textarea class="form-control" rows="3" id="suggestions" ng-model="vm.pavillion.suggestions"></textarea></div></div></div><div class=""><button class="btn btn-primary" type="button" ng-click="vm.goBack()"><span class="fa fa-arrow-left"></span> <span class="small">{{\'pavillion.form.backButton\' | translate}}</span></button> <button type="submit" class="btn btn-primary pull-right"><span class="glyphicon glyphicon-shopping-cart"></span> <span class="small">{{\'pavillion.form.bookButton\' | translate}}</span></button></div></form></div>');
$templateCache.put('app/category/navigation/navigation.html','<select ng-if="vm.minimized" class="form-control" ng-change="vm.changedSelection()" ng-model="vm.selectedCategoryId" ng-options="category.categoryID as category.title[vm.lang] for category in vm.categories.categories | orderBy: (\'title.\' + vm.lang)" convert-to-number></select><div ng-if="!vm.minimized"><ul class="list-group"><a ng-repeat="category in vm.categories.categories | orderBy: (\'title.\' + vm.lang)" ng-click="vm.book(category.categoryID)" class="list-group-item" ng-class="{\'active\': category.categoryID === vm.selectedCategoryId}">{{category.title[vm.lang]}}</a></ul></div>');
$templateCache.put('app/category/part/part.html','<div class="img-container mb-4"><img class="home-image" ng-src="{{ vm.welcomeImage }}"></div><category-navigation minimized="true" class="visible-xs visible-sm"></category-navigation><hr><h3 translate="part.headline"></h3><div class="gs-success-alert"><jhi-alert></jhi-alert></div><div class="row"><div class="col-md-3 hidden-xs hidden-sm"><category-navigation minimized="false"></category-navigation></div><div class="col-md-9"><form name="form" ng-submit="form.$valid && vm.book()" novalidate show-validation><div class="row row-margin-10" ng-if="vm.documents && vm.documents.length >0"><div class="col-md-9"><span class="bold" translate="part.document"></span></div></div><div ng-repeat="externalLink in vm.externalLinks" class="panel panel-default"><div class="panel-heading"><div class="panel-title">{{externalLink.title[vm.lang]}}</div></div><div class="panel-body"><div>{{externalLink.description[vm.lang]}}</div><a ng-href="{{externalLink.buttonLink[vm.lang]}}" target="_blank" class="btn btn-primary btn-sm pull-right">{{externalLink.buttonLabel[vm.lang]}}</a></div></div><div ng-repeat="document in vm.documents"><div class="panel panel-default"><div class="panel-heading"><div class="panel-title">{{document.labels[vm.lang]}}</div></div><div class="panel-body"><div>{{document.infos[vm.lang]}}</div><a ng-if="document.labels[vm.lang] && document.paths[vm.lang]" href="{{document.paths[vm.lang]}}" class="btn btn-primary btn-sm pull-right" aria-hidden="true" target="_blank"><i class="fa fa-lg fa-file-pdf-o"></i> <span class="padding-left-5">Download</span></a></div></div></div><div class="row row-margin-10" ng-if="vm.parts && vm.parts.length > 0"><div class="col-md-1"><span class="bold" translate="part.amount"></span></div><div class="col-md-6"><span class="bold" translate="part.description"></span></div><div class="col-md-3"></div><div class="col-md-2"><span class="bold" translate="part.price"></span></div></div><p class="overflow-hidden"></p><div class="row row-margin-20 part-item overflow-hidden" ng-repeat="part in vm.parts"><div class="row"><div class="col-md-1"><div class="div-min-height-60"><input type="number" class="form-control form-control-amount" name="amount" min="0" class="form-control" ng-model="vm.bookedParts[part.id].partAmount" ng-required="vm.bookedParts[part.id].partArea || vm.bookedParts[part.id].partColor || vm.bookedParts[part.id].coExhibitor"></div><div class="div-min-height-60"></div></div><div class="col-md-7"><div class="div-min-height-60 col-md-12"><p><span class="bold">{{ part.title[vm.lang] }}</span></p><div ng-if="part.exhibitorPermit"><span class="">{{ vm.exhibitorPermitsIncluded }}</span> <span class="" translate="part.includedExhibitorPermits"></span></div><div ng-if="part.parkingPermit"><span class="">{{ vm.parkingPermitsIncluded }}</span> <span class="" translate="part.includedParkingPermits"></span></div><p>{{ part.description[vm.lang] }}</p></div><hr><div class="div-min-height-60 col-md-4"><select id="area" name="area" class="form-control" ng-model="vm.bookedParts[part.id].partArea" ng-options="area.id as area.name for area in vm.areas | orderBy:\'name\'" ng-required="vm.bookedParts[part.id].partAmount || vm.bookedParts[part.id].availableColors" convert-to-number><option value="">{{\'part.noareaselected\' | translate}}</option></select></div><div class="div-min-height-60 col-md-4" ng-show="vm.coExhibitors && vm.coExhibitors.length > 0"><select id="coExhibitor" name="coExhibitor" class="form-control" ng-model="vm.bookedParts[part.id].coExhibitor" ng-options="coExhibitor.id as coExhibitor.company for coExhibitor in vm.coExhibitors | orderBy:\'company\'" ng-required="vm.bookedParts[part.id].partAmount || vm.bookedParts[part.id].partArea " convert-to-number><option value="">{{\'part.nocoexhibitorselected\' | translate}}</option></select></div><div class="div-min-height-60 col-md-4" ng-show="part.availableColors.length > 0"><select id="color" name="color" class="form-control" ng-model="vm.bookedParts[part.id].partColor" ng-options="color.id as color.name for color in part.availableColors | orderBy:\'name\'" ng-required="vm.bookedParts[part.id].partAmount || vm.bookedParts[part.id].partArea || vm.bookedParts[part.id].coExhibitor" convert-to-number><option value="">{{\'part.nocolorselected\' | translate}}</option></select></div></div><div class="col-md-2 text-center"><img class="part-image" ng-src="{{ part.imageURL }}"></div><div class="col-md-2"><div class="div-min-height-60">{{ part.price * ((vm.bookedParts[part.id].partAmount) ? vm.bookedParts[part.id].partAmount : 1) | currency: \'\u20AC\' }}</div><div class="div-min-height-60"><button type="submit" class="btn btn-primary" ng-disabled="!vm.bookedParts[part.id].partAmount || !vm.bookedParts[part.id].partArea || (part.availableColors.length > 0 && !vm.bookedParts[part.id].partColor) || (vm.coExhibitors.length > 0 && (!vm.bookedParts[part.id].coExhibitor ))" ng-click="vm.book(part.id)" uib-tooltip="{{ \'part.buttons.booktooltip\' | translate }}"><span class="glyphicon glyphicon-shopping-cart"></span> <span class="small">{{\'part.buttons.addtocart\' | translate}}</span></button></div></div></div></div><div class="row"><button class="btn btn-primary pull-left" type="button" ng-click="vm.back()"><span class="fa fa-arrow-left"></span> <span class="small">{{\'part.buttons.back\' | translate}}</span></button></div></form></div></div>');
$templateCache.put('app/components/confirm/confirm-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title">{{confirmTitle}}</h4></div><div class="modal-body"><p>{{confirmMessage}}</p></div><div class="modal-footer"><button type="button" class="btn" ng-class="cancelButtonClass" data-dismiss="modal" ng-click="cancel()"><i class="fa fa-fw" ng-class="cancelIconClass"></i> {{cancelCaption}}</button> <button type="button" class="btn" ng-class="buttonClass" ng-click="ok()"><i class="fa fa-fw" ng-class="iconClass"></i> {{confirmCaption}}</button></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><h4 class="modal-title" translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username" autofocus="autofocus"></div><div class="form-group"><label for="password" translate="login.form.password">Password</label><input type="{{vm.showPassword ? \'text\': \'password\'}}" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"> <button type="button" ng-click="vm.togglePasswordVisibility()" class="glyphicon glyphicon-eye-close"></button></div><button type="submit" class="btn btn-primary" translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div class="alert alert-danger" translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/geoplan.jpg"><!--<span translate="global.title">ExhibitorRegistration</span> <span class="navbar-version">v1</span>--></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><!--<li ui-sref-active="active"  has-authority="PRE_AUTHORIZED">\n                    <a ui-sref="registration" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-play"></span>\n                        <span class="hidden-sm" translate="global.menu.registration">registration</span>\n                    </a>\n                </li>\n                --><li ui-sref-active="active"><a ui-sref="home" ui-sref-opts="{reload: true, notify: true}" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" translate="global.menu.home">Home</span></a></li><li ui-sref-active="active" has-authority="AUTHORIZED"><a ui-sref="category" ng-click="vm.collapseNavbar()"><span class="fa fa-shopping-bag"></span> <span class="hidden-sm" translate="global.menu.category">global.menu.category</span></a></li><li ng-if="vm.steinexpo" ui-sref-active="active" has-authority="AUTHORIZED"><a ui-sref="news" ng-click="vm.collapseNavbar()"><span class="fa fa-newspaper-o"></span> <span class="hidden-sm" translate="global.menu.news">global.menu.news</span></a></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" translate="global.menu.account.myaccount">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true" has-any-authority="PRE_AUTHORIZED,AUTHORIZATION_PENDING,ESC_INACTIVE,AUTHORIZED"><a ui-sref="registration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span translate="global.menu.account.mydata">my data</span></a></li><li ui-sref-active="active" ng-switch-when="true" has-any-authority="AUTHORIZATION_PENDING,ESC_INACTIVE,AUTHORIZED"><a ui-sref="orderhistory" ng-click="vm.collapseNavbar()"><span class="fa fa-history"></span>&nbsp; <span translate="global.menu.account.myorders">my orders</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span> <span translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span translate="global.menu.admin.logs">Logs</span></a></li><li ng-hide="vm.inProduction || vm.swaggerDisabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" has-any-authority="PRE_AUTHORIZED,AUTHORIZED,ESC_INACTIVE" ng-switch-when="true"><a class="dropdown-toggle dropdown pointer" gs-cart></a></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm" ng-show="languageVm.getLanguages().length > 1"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.getLanguages().length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.getLanguages().length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.getLanguages()"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/news/edit/edit.html','<div><div class="row"><h2 translate="news.headline">news.headline</h2></div><div class="row"><form class="form-horizontal" name="form" novalidate ng-submit="form.$valid && vm.submit()"><div class="form-group" ng-class="{\'has-error\': (form.language.$invalid && (form.$submitted || form.language.$touched))}"><div class="col-sm-2 control-label"><label for="language" translate="news.form.language"></label><label class="required-label">*</label></div><div class="col-sm-10"><select class="form-control" id="language" name="language" required="true" ng-model="vm.news.language"><option value="de_DE">{{\'news.language.de\' | translate}}</option><option value="en_GB">{{\'news.language.en\' | translate}}</option></select><p ng-show="form.language.$invalid && (form.$submitted || form.language.$touched)" class="help-block">{{\'form.required\' | translate}}</p></div></div><div class="form-group" ng-class="{\'has-error\': (form.title.$invalid && (form.$submitted || form.title.$touched))}"><div class="col-sm-2 control-label"><label for="title" translate="news.form.title"></label><label class="required-label">*</label></div><div class="col-sm-10"><input type="text" class="form-control" id="title" name="title" required="true" ng-model="vm.news.title"><p ng-show="form.title.$invalid && (form.$submitted || form.title.$touched)" class="help-block">{{\'form.required\' | translate}}</p></div></div><div class="form-group" ng-class="{\'has-error\': (form.newsTeaser.$invalid && (form.$submitted || form.newsTeaser.$touched))}"><div class="col-sm-2 control-label"><label for="newsTeaser" translate="news.form.teaser"></label><label class="required-label">*</label></div><div class="col-sm-10"><ng-quill-editor ng-model="vm.news.teaser" id="newsTeaser" name="newsTeaser" class="form-control" toolbar="true" toolbar-entries="bold italic underline" editor-required="true" ng-required="true" error-class="error"></ng-quill-editor><p ng-show="form.newsTeaser.$invalid && (form.$submitted || form.newsTeaser.$touched)" class="help-block">{{\'form.required\' | translate}}</p></div></div><div class="form-group" ng-class="{\'has-error\': (form.newsContent.$invalid && (form.$submitted || form.newsContent.$touched))}"><div class="col-sm-2 control-label"><label for="newsContent" translate="news.form.content"></label><label class="required-label">*</label></div><div class="col-sm-10"><ng-quill-editor ng-model="vm.news.content" id="newsContent" name="newsContent" class="form-control" toolbar="true" toolbar-entries="bold italic underline bullet align" editor-required="true" ng-required="true" error-class="error"></ng-quill-editor><p ng-show="form.newsContent.$invalid && (form.$submitted || form.newsContent.$touched)" class="help-block">{{\'form.required\' | translate}}</p></div></div><div class="row form-group" ng-class="{\'has-error\': (form.newsImage.$invalid || (form.image.$invalid && (form.$submitted || form.image.$touched)))}"><div class="col-sm-2 control-label"><label for="newsImage" translate="news.form.image"></label></div><div class="col-sm-10"><div><div class="btn btn-default" ngf-select="vm.uploadImage($file)" ngf-pattern="\'image/jpeg,image/png\'" ngf-accept="\'image/jpeg,image/png\'" ngf-max-size="5MB" id="newsImage" name="newsImage" ng-model="newsImage" ng-disabled="vm.imageUploadStatus !== null"><i ng-show="vm.imageUploadStatus !== null" class="fa fa-circle-o-notch fa-spin fa-fw no-animate"></i> <span>{{\'news.form.uploadImage\' | translate}}</span> <span ng-show="vm.imageUploadStatus !== null" class="no-animate">({{vm.imageUploadStatus}}%)</span></div><p ng-show="form.newsImage.$invalid" class="help-block"><span ng-show="form.newsImage.$error.maxSize">{{\'global.form.validation.fileMaxSize\' | translate}}</span> <span ng-show="form.newsImage.$error.pattern">{{\'global.form.validation.fileTypeImage\' | translate}}</span></p><input type="hidden" name="image" ng-model="vm.news.image"><p ng-show="form.image.$invalid && (form.$submitted || form.image.$touched)" class="help-block"><span ng-show="form.image.$error.required">{{\'form.required\' | translate}}</span></p></div><div ng-if="vm.imagePreviewThumbnail" class="mt-4"><img ngf-thumbnail="vm.imagePreviewThumbnail" style="max-width: 300px"></div></div></div><div class="row mt-4 form-group" ng-class="{\'has-error\': (form.newsAttachments.$invalid)}"><div class="col-sm-2 control-label"><label for="newsAttachments" translate="news.form.attachments"></label></div><div class="col-sm-10"><div class="btn btn-default" ngf-select="vm.uploadAttachment($file)" ngf-pattern="\'application/pdf,application/zip,image/jpeg,image/png,application/vnd.openxmlformats-officedocument.wordprocessingml.document\'" ngf-accept="\'application/pdf,application/zip,image/jpeg,image/png,application/vnd.openxmlformats-officedocument.wordprocessingml.document\'" ngf-max-size="5MB" id="newsAttachments" name="newsAttachments" ng-model="newsAttachments" ng-disabled="vm.news.downloads.length < 0 || 3 <= vm.news.downloads.length">{{\'news.form.uploadAttachments\' | translate}}</div><span class="badge">{{vm.news.downloads.length}} / Max. 3</span><p ng-show="form.newsAttachments.$invalid" class="help-block"><span ng-show="form.newsAttachments.$error.maxSize">{{\'global.form.validation.fileMaxSize\' | translate}}</span> <span ng-show="form.newsAttachments.$error.pattern">{{\'global.form.validation.fileTypePdfZipImageWord\' | translate}}</span></p><div ng-repeat="download in vm.news.downloads" class="row mt-4"><div class="col-xs-1"><i class="fa fa-fw fa-file"></i></div><div class="col-xs-10"><input type="text" class="form-control" name="downloadTitle[]" required="true" ng-model="vm.news.downloads[$index].title"></div><div class="col-xs-1"><button type="button" class="btn btn-danger" ng-click="vm.removeAttachment(download.uuid)"><i class="fa fa-fw fa-trash-o"></i></button></div></div></div></div><div><button type="submit" class="btn btn-primary pull-right" ng-disabled="vm.imageUploadStatus !== null"><span class="fa fa-floppy-o"></span> <span class="small">{{\'news.form.submit\' | translate}}</span></button> <button type="button" class="btn btn-default pull-right mr-3" ui-sref="news"><span class="small">{{\'entity.action.cancel\' | translate}}</span></button></div></form></div></div>');
$templateCache.put('app/news/list/list.html','<div><div class="clearfix"><button type="button" class="btn btn-primary pull-right" ng-click="vm.add()"><i class="fa fa-fw fa-plus"></i> {{\'news.add\' | translate}}</button><h2 translate="news.headline">news.headline</h2></div><table class="table table-striped table-hover"><thead><tr><td style="width: 50px">&nbsp;</td><td style="width: 100px">{{\'news.form.status\' | translate}}</td><td style="width: 160px">{{\'news.form.image\' | translate}}</td><td>{{\'news.form.title\' | translate}}</td><td>{{\'news.form.teaser\' | translate}}</td><td style="width: 60px">&nbsp;</td></tr></thead><tbody><tr ng-repeat="item in vm.items"><td><img ng-if="item.language" ng-src="content/images/flags/{{item.language.substr(3, 2)}}.png"></td><td><span ng-if="!item.approved" class="label label-warning">{{\'news.status.review\' | translate}} </span><span ng-if="item.approved" class="label label-success">{{\'news.status.online\' | translate}}</span></td><td><img ng-src="{{item.image}}"></td><td>{{item.title}}</td><td ng-bind-html="vm.trustedHtml(item.teaser)"></td><td><button type="button" class="btn btn-danger" ng-click="vm.remove(item.id)"><i class="fa fa-fw fa-trash-o"></i></button></td></tr></tbody></table></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();